import { ELanguages } from "src/app/core/enums/Languages.enum";

export const locale = {
  lang: ELanguages.UZ_CYRL,
  data: {
    LANG_TAB: {
      UZ: "Oʻzbekcha",
      UZ_CYRL: "Ўзбекча",
      RU: "Русский",
    },
    PAGE: "Саҳифа",
    TEST_MODE: "Тизим тест режимида ишламоқда!",
    ALL: "Барчаси",
    NEW_VERSION_AVAILABLE: "Тизимнинг янги версияси мавжуд",
    REFRESH: "Янгилаш",
    LAYOUT: {
      SHOW_SIDEBAR: "Катта ён меню",
      SMALL_SIDEBAR: "Кичик ён меню",
      DROPDOWN_NAVBAR: "Одатий юқори меню",
      MEGA_NAVBAR: "Катта юқори меню",
    },
    AUDIT_LOG: {
      IS_BUDGET_ORG: "Буджет ташкилоти",
      END_AT: "Тугаш санаси",
      COURT_WARNING_ENTITY: {
        PREFIX: "Суд жараёни",
      },
      ORGANIZATION_ENTITY: {
        PREFIX: "Корхонани",
      },
      MAHALLA_ENTITY: {
        PREFIX: "Маҳаллани",
        PUBLIC_OFFER_FILE_ID: "Оммавий оферта файли",
        ADDED_INSPECTOR: "Маҳаллага янги инспектор бириктирилди",
      },
      USER_ENTITY: {
        PREFIX: "Фойдаланувчини",
        CHANGE_IMAGE: "Фойдаланувчини расми ўзгартрилди",
        CHANGE_PASSWORD: "Фойдаланувчи пароли ўзгартрилди",
        CHANGE_PASSPORT: "Фойдаланувчи паспорт серияси ўзгартрилди",
        CHANGE_DISTRICT: "Фойдаланувчи туман/ шаҳар ўзгартрилди",
        CHANGE_REGION: "Фойдаланувчи вилоят ўзгартрилди",
        CHANGE_PHONE: "Фойдаланувчи телефон рақами ўзгартрилди",
        CHANGE_EMAIL: "Фойдаланувчи электрон почта манзили ўзгартрилди",
        ADDRESS: "Манзили",
        TABLE_NUMBER: "Стол рақами",
        ATTACHED_HOME: "Фойдаланувчига янги уй бириктирилди",
      },
      NORM_ENTITY: {
        PREFIX: "Юридик",
      },
      ACT_PACK_ENTITY: {
        PREFIX: "Актлар пачкасини",
      },
      AUTOMOBILE_ENTITY: {
        PREFIX: "Транспорт воситасини",
      },
      TARIFF_ENTITY: {
        PREFIX: "Тарифни",
      },
      COMPANY_ENTITY: {
        PREFIX: "Корхонани",
      },
      EMPLOYEE_ENTITY: {
        PREFIX: "Ходимни",
      },
      OLD_AUDITS_INFO: {
        CHANGE_INFO: "Маълумотлар ўзгариши",
        FIELD: "Майдон",
        OLD_VALUE: "Эски қиймат",
        NEW_VALUE: "Янги қиймат",
      },
    },
    RESIDENT_AUDIT_LOG: {
      STATUS: "Статус",
      ACTIVE: "Фаол",
      IN_ACTIVE: "Фаол эмас",
      FROM: "дан",
      TO: "га",
      CHANGED: "ўзгартирилди",

      INDIVIDUAL_RESIDENT: {
        PREFIX: "Жисмоний абонентни",
        ELECTRICITY_COATO: "Електр енергия CОАТО",
        CITIZEN: "Абонент паспорт маълумотлари ўзгартирилди",
        MAHALLA: "Абонент маҳалласи ўзгартирилди",
        STREET: "Абонент кўчаси ўзгартирилди",
        IDENTIFIED: "Идентификацияланган",
        IDENTIFIED_DATE: "Идентификацияланган сана",
        ELECTRICITY_ACCOUNT_NUMBER: "Електр енергия ҳисоб рақами",
        LAST_PAYMENT_DATE: "Охирги тўлов санаси",
        LAST_PAYMENT_AMOUNT: "Охирги тўлов суммаси",
        LAST_PAYMENT_TYPE: "Охирги тўлов тури",
        CONTRACT_DATE: "Шартнома санаси",
        DESCRIPTION: "Изоҳ",
        BALANCE: "Баланс",
      },
      ACT: {
        PREFIX: "Абанентни акти",
        OLD_INHABITANT_COUNT: "Олдинги яшовчилар сони",
        NEW: "Янги",
        CONFIRMED: "Тасдиқланган",
        CANCELED_AT: "Бекор қилинган сана",
        CANCELED_BY: "Бекор қилган фойдаланувчи",
        CANCELLATION_CONCLUSION: "Бекор қилинганлик хулосаси",
      },
    },
    MAIN_COMPANY: {
      TITLE: "Корхона маълумотлари",
      ENABLE_OR_DISABLE_INTEGRATION: "Интеграцияни ёқиш ёки ўчириш",
      EDIT_INTEGRATION: "Интеграцияни таҳрирлаш",
      COMPANY_NOT_ENOUGH_DATA_TITLE:
        "Сариқ рангли қатордаги маҳаллаларнинг маълумоти тўлиқ эмас!",
      ATTACH_AUTO_TO_COMPANY: "Автотехника бириктириш",
      CONTRACT_END_DATE_WARNING: "Шартнома тугашига 1 ойдан кам вақт қолди!",
      CONTRACT_END_DATE_WARNING_LESS_MORE_THAN_MONTH:
        "Шартнома тугашига 1 ойдан кам вақт қолди!",
      CONTRACT_END_DATE_WARNING_ROW:
        "Сариқ рангли қатордаги корхона шартномаси тугашига 1 ойдан кам вақт қолди",
      COMPANY_COVERAGE: {
        CONFIRMATION_MODAL: {
          TITLE: "СМС жўнатиш",
          MESSAGE:
            "Сиз ҳақиқатан ҳам корхонаси о`згарган маҳалла абонентларига огоҳлантириш СМСни юбормоқчимисиз!",
        },
        PUBLIC_CONTRACT_UPLOAD: "Оммаий шартнома файлини юклаш",
        PUBLIC_CONTRACT_DELETE: "Оммаий шартнома файлини ўчириш",
        PUBLIC_CONTRACT_DELETE_MESSAGE:
          "Сиз ҳақиқатан ҳам оммаий шартнома файлини ўчирмоқчимисиз?",
        VIEW_PUBLIC_CONTRACTS: "Оммаий шартномаларни кўриш",
        DATE_ATTACH_CONTRACT: "Охирги шартнома бириктирилган сана",
        NEW_MAHALLA_CONTRACT_START_DATE: "Янги шартноманинг бошланиш санаси",
      },
      TABS: {
        STATISTICS: "Статистика",
        VILLAGES: "Маҳаллалар",
        EMPLOYEES: "Ҳодимлар",
        SETTINGS: "Созламалар",
        COVERAGE: "Қамров ҳудуди",
        PUBLIC_CONTRACTS: "Оммаий шартномалар",
        COMPANY_CONTRACTS: "Шартномалар",
        COMPANY_AUTO: "Техникалар",
        COMPANY_SHARED_AUTO: "Улашилган техникалар",
        VISIT_GRAPH_FILE: "График файллари",
        COMPANY_AUTO_WORK_GRAPHIC: "Техника иш графиги",
      },
      APPX_CHART1: {
        ECO_PAY_INVENTORY: "EcoPay инвентаризация",
        INVENTORY: "Инвентаризация",
        FROZEN: "Музлатилган",
        SIMPLE: "Оддий",
        SERVICE_NOT_PROVIDED: "Хизмат кўрсатилмаган",
        SPECIAL: "Махсус",
        OTHERS: "Бошқалар",
        NO_ACT_DATA: "Ушбу давр бўйича актлар йўқ",
        NO_INCOME_DATA: "Ушбу давр бўйича тушумлар йўқ",
        NO_ALL_APPEALS_DATA: "Ушбу давр бўйича барча мурожаатлар йўқ",
        NO_COURT_ACTION_DATA: "Ушбу давр бўйича суд жараёнлари йўқ",
      },
      APPX_CHART2: {
        QUEUE: "Навбатда",
        LEARNING: "Ўрганилмоқда",
        DONE: "Бажарилди",
        CANCELED: "Бекор қилинди",
        CREATED: "Яратилди",
        ACCEPTED: "Қабул қилинди",
        COMPLETED: "Тугатилди",
        CANCELLED: "Бекор қилинди",
        SYSTEM_CANCELLED: "Тизим томонидан бекор қилинди",
      },
      APPX_CHART3: {
        NEW: "Янги",
        ALERTED: "Огоҳлантирилди",
        DOCUMENTS_FORMALIZED: "Расмийлаштирилди",
        MIB_EXECUTION: "МИБ бажарилмоқда",
        SENT: "Юборилди",
        THE_DECISION_CAME_OUT: "Қарор чиқди",
        DEBT_COVERED: "Қарз қопланди",
        CANCELLED: "Бекор қилинди",
        WARNED: "Огоҳлантирилди",
        DOCUMENT_PREPARATION: "Ҳужжатлар тайёрланмоқда",
        DOCUMENTS_SENT: "Ҳужжатлар юборилди",
        COURT_DECISION: "Суд қарори",
        DEBT_PAID: "Қарз тўланди",
      },
      COMPANY_SETTING_TYPES: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Номи",
          SHORT_NAME: "Қисқа номи",
          ACTION: "Ҳаракатлар",
        },
        ADD_EDIT_MODAL: {
          SHORT_NAME: "Қисқа номи:",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Созлама турии қўшиш",
          EDIT_MODAL_TITLE: "Созлама туриини таҳрирлаш",
          DELETE_MODAL_TITLE: "Созлама туриини ўчириш",
          DELETE_MESSAGE:
            "Сиз ҳақиқатан ҳам ушбу созлама туриини тизимдан олиб ташламоқчимисиз?",
        },
      },
      COMPANY_AUTO_WORK_GRAPHIC: {
        COMPANY_AUTO_NUMBER: "Aвтомобил рақами",
        COMPANY_AUTO_REST_DAY: "Дам олиш куни",
        COMPANY_AUTO_PIN_MAHALLA: "Маҳалла бириктириш",
        COMPANY_AUTO_PIN_AUTO: "Aвтомобил бириктириш",
        COMPANY_AUTO_EDIT_MAHALLA: "Таҳрирлаш",
        COMPANY_AUTO_MAHALLA_NAME: "Маҳалла номи",
        NO_DATA: "Техника иш графиги мавжуд эмас!",
        COMPANY_AUTO_MAHALLA_SECTION: "Маҳалла кесимда",
        COMPANY_AUTO_AUTOS_SECTION: "Техника кесимнда",
        SELECT_COMPANY: "Корхонани танланг",
        SELECT_COMPANY_NOT_FOUND: "Корхона топилмади",
        SEE_ALL: "Барчасини кўриш",
        VISIT_GRAPH_FILE: "График файли",
        VISIT_GRAPH_CANCEL: "Ташриф графигини бекор қилиш",
        VISIT_GRAPH_APPROVE: "Ташриф графигини тасдиқлаш",
        CHANGE_GRAPHIC_WARNING:
          " Тасдиқланган графикни ўзгартириш мумкин емас, ўзгартириш учун марказ ходимлари билан боғланинг !",
        WARNING: "Огоҳлантириш",
      },
      COMPANY_AUTO: {
        TABLE_HEADERS: {
          ID: "ID",
          AUTOMOBILE_NUMBER: "Автотехника рақами",
          AUTOMOBILE_TYPE: "Автотехника тури",
          COMPANY_NAME: "Корхона номи",
          GPS_SYSTEM_NAME: "GPS номи",
          MODEL: "Модел",
        },
      },
      COMPANY_SHARED_AUTO: {
        TABS: {
          SHARED_AUTO_TAB: "Корхона томонидан улашилган",
          SHARED_BY_TAB: "Корхона томонидан қабул қилинган",
        },
        TABLE: {
          COMPANY_AUTO_NUMBER: "Aвтомобил рақами",
          SHARED_BY_COMPANY: "Улашган корхона номи",
          COMPANY_NAME: "Корхона номи",
        },
        TABLE_HEADERS: {
          COMPANY_AUTO_NUMBER: "Автомобил рақами",
          SHARED_BY_COMPANY: "Улашган корхона номи",
          COMPANY_NAME: "Қабул қилган корхона номи",
        },
        MODAL: {
          DELETE_MODAL: "Улашган техникани ўчириш",
          DELETE_MODAL_SUBTITLE:
            "Сиз ҳақиқатан ҳам ушбу техникани олиб ташламоқчимисиз?",
        },
        FORM: {
          COMPANY_AUTO_SHARED_TO_TITLE:
            "Техникани улашилмоқчи бўлган корхонани танланг",
          REGION: "Вилоят",
          DISTRICT: "Туман / Шаҳар",
          COMPANY: "Корхона номи",
          COMPANY_SHARED_AUTO: "Улашилмоқчи бўлган техникани танланг",
        },
      },
      COMPANY_CONTRACTS: {
        ADD_CONTRACT: "Шартнома қўшиш",
        CONTRACT_NUMBER: "Шартнома рақами",
        CONTRACT_START_DATE: "Шартнома бошланиш санаси",
        CONTRACT_END_DATE: "Шартнома тугаш санаси",
        CONTRACT_FILE: "Шартнома файли",
        MODAL: {
          DELETE_MODAL: "Шартномани ўчириш",
          DELETE_MODAL_SUBTITLE:
            "Сиз ҳақиқатан ҳам ушбу шартномани олиб ташламоқчимисиз?",
        },
      },
      COMPANY_FILES: {
        TABLE_HEADERS: {
          ID: "ID",
          CREATED_AT: "Яратилган сана",
          DOCUMENT_DATE: "Ҳужжат санаси",
          FILE: "Файл",
          DESCRIPTION: "Изоҳ",
        },
        MODAL: {
          DELETE_MODAL: "Файлни ўчириш",
          DELETE_MODAL_SUBTITLE:
            "Сиз ҳақиқатан ҳам ушбу файлни олиб ташламоқчимисиз?",
          EDIT_MODAL: "Файлни таҳрирлаш",
          ADD_MODAL: "Файл бириктириш",
          ADDED_FILE: "Бириктирилган файл",
        },
      },
      VISIT_GRAPH_FILE: {
        ADD_TITLE: "Файл бириктириш",
        EDIT_TITLE: "Графикни таҳрирлаш",
        FILTER: {
          MAHALLA_NAME: "Маҳалла номи",
          ACTIVE: "Фаол",
          IN_ACTIVE: "Фаол эмас",
          STATUS: "Ҳолат",
        },
        TABLE_HEADERS: {
          MAHALLA_NAME: "Маҳалла номи",
          START_DATE: "Бошланиш санаси",
          END_DATE: "Тугаш санаси",
          FILE: "Файл",
          ACTIONS: "Амаллар",
        },
        FORM: {
          ATTACH_GRAPH_FILE: "График файли",
          MAHALLA_NAME: "Маҳалла номи",
        },
        MODAL: {
          TITLE_DELETE: "График файлини ўчириш",
          DELETE_MODAL_SUBTITLE:
            "Сиз ҳақиқатан ҳам танланган график файлини тизимдан олиб ташламоқчимисиз?",
        },
      },
    },
    MAPS: {
      LENGTH: "Узунлик",
      SEGMENT: "Сегмент",
      COOR: "Координаталар",
      SIMPLE_OPEN: "Оддий очиқ",
      HYBRID: "Гибрид",
      SIMPLE: "Оддий",
      NIGHT: "Тунги",
    },
    STATISTICS: {
      UNITS: {
        TA: "та",
        SUM: "сўм",
        PROTSENT: "%",
        ACCOUNTS: "абонент",
      },
      BALANCE: "Баланс",
      INITIAL_BALANCE: "Бирламчи баланс",

      COMPANY: {
        TITLE: "Қарздорликлар/Хақдорлик маҳаллалар кесимида",
      },
      TOTAL_AMOUNT: "Жами сумма",
      TOTAL_QUANTITY: "Жами сони",
      BILLION: "Миллиард",
      MILLION: "Миллион",

      TITLE: "Статистика",
      MAP_TITLE: "Ўзбекистон Республикаси",
      TITLE2: "Назоратчиларнинг киримлари",
      TITLE3: "Кирим турлари (минг сўм)",
      INCOME_BY_REGION: "Тушумлар ҳудудлар кесимида",
      INCOME_BY_CHANNEL: "Тушумлар каналлар кесимида",
      DEBIT_BY_REGION: "Қарздорлик/Хақдорлик ҳудудлар кесимида",
      DEBIT_DYNAMICS: "Қарздорлик динамикаси",
      CASH_DYNAMICS: "Тушумлар динамикаси",
      DAY: "Кун",
      WEEK: "Ҳафта",
      MONTH: "Ой",
      YEAR: "Йил",
      TITLE4: "Абонентлар ҳудудлар кесимида",
      TITLE_5: "Маълумотлар",
      PIE_CHART_DATA: {
        TITLE: "Абонентлар туманлар кесимида",
      },
      STATISTICS_DATA: {
        RESIDENTS: "Абонентлар сони",
        DEBTORS: "Карздор абонентлар сони",
        TOTAL_DEBT: "Умумий карздорлик",
        ENTITLEMENT: "Хакдор абонентлар сони",
        REVENUE: "Тўловлар",
        APPEALS: "Мурожаатлар",
        COURT_PROCEEDINGS: "Суд жараёнлари",
        ACTS: "Актлар",
      },
      DEBIT: "Қарздорлик",
      CREDIT: "Хақдорлик",
      INCOMEE: "Даромад",
      RESIDENT_COUNT: "Абонентлар сони",
      MAHALLAS_COUNT: "Маҳаллалар сони",
      FROZEN_MAHALLAS_COUNT: "Музлатилган маҳаллалар сони",
      FROZEN_START_DATE: "Музлатилганлик бошланган сана",
      EMPLOYEES_COUNT: "Ҳодимлар сони",
      SUM: "сўм",
      MUNIS: "Мунис",
      ELECTRONIC_PAYMENTS: "Электрон тўловлар",
      MOBILE: "Мобил",
      WEB: "Веб",
      PAYMENTS_1031: "МИБ ва 1031 тўловлар",
      INCOME: "Тушум",

      // Regions
      ANDIJON: "Андижон",
      BUKHARA: "Бухоро",
      FERGANA: "Фарғона",
      JIZZAKH: "Жиззах",
      KHOREZM: "Хоразм",
      NAMANGAN: "Наманган",
      NAVOI: "Навоий",
      KASHKADARYA: "Қашқадарё",
      SAMARKAND: "Самарқанд",
      SURKHANDARYA: "Сурхондарё",
      TASHKENT: "Тошкент",
      TASHKENT_CITY: "Тошкент шаҳар",

      // Months
      JANUARY: "Январь",
      FEBRUARY: "Февраль",
      MARCH: "Март",
      APRIL: "Апрель",
      MAY: "Май",
      JUNE: "Июнь",
      JULY: "Июль",
      AUGUST: "Август",
      SEPTEMBER: "Сентябрь",
      OCTOBER: "Октябрь",
      NOVEMBER: "Ноябрь",
      DECEMBER: "Декабрь",
    },
    CALCULATOR: {
      CALCULATOR: "Калькулятор",
      CURRENT_TARIFF: "Жорий тариф",
      INHABITANT_CNT: "Яшовчилар сони",
      AS_OF_THE_CURRENT_PERIOD: "Жорий давр ҳолатига кўра қарздорлик",
      AS_OF_THE_CURRENT_PERIOD1: "Жорий давр ҳолатига кўра ҳақдорлик",
      IT_WAS_UNTIL_THE_SELECT_PERIOD: "Танланган давргача бўлган қарздорлик",
      IT_WAS_UNTIL_THE_SELECT_PERIOD1: "Танланган давргача бўлган ҳақдорлик",
    },
    PINNED: {
      BUTTON: "Картага ўтиш",
      BUTTON1: "Қайта ҳисоблаш",
      BUTTON2: "Ҳуқуқлар",
      BUTTON3: "Пачкага ўтиш",
      BUTTON4: "Бўлимларга ўтиш",
      BUTTON5: "Ходимларга ўтиш",
      BUTTON6: "Тўловларга ўтиш",
      BLOCK: "Блоклаш",
      WRITE_ANSWER: "Жавоб ёзиш",
      OLD: "Эски",
      CORRECTED: "Тузатилган",
      TRUE: "Фаол",
      FALSE: "Нофаол",
      YES: "Ҳа",
      SPEED: "Тезлик (км/соат)",
      NO: "Йўқ",
      BACK: "Ортга",
      NEW: "Янги",
      DIFFERENCE: "Фарқли",
      CONFIRMED: "Тасдиқланган",
      PAYED: "Тўланган",
      CANCELED: "Бекор қилинган",
      CONFIRMED_CANCELED: "Тасдиқланган бекор қилинган",
      OLD_ACTS: "Эски актлар",
      WARNED: "Огоҳлантирилган",
      WARN: "Огоҳлантириш",
      DEFECT_CORRECTED: "Нуқсанлар тузатилган",
      WARN_CORRECTED: "Огоҳлантиришлар тузатилган",
      CREDIT: "Ҳақдорлик",
      DEBIT: "Қарздорлик",
      CREDITOR: "Ҳақдор",
      DEBTOR: "Қарздор",
      APPROVED: "Қабул қилинган",
      WARNED_CANCELLED: "Огоҳлантирилган ва бекор қилинган",
      SELECT_ALL: "Барчасини танлаш",
      UN_SELECT_ALL: "Барчасини бекор қилиш",
      OPERATIONS: "Тўловлар тарихи",
      CREATE: "Яратилди",
      UPDATE: "Янгиланди",
      DELETE: "Ўчирилди",
      WEB: "Веб",
      MOBILE: "Mobil",
      SUM: "сўм",
      MORE_DETAILS: "Батафсил",
      HOUR: "соат",
      MINUTES: "дақиқа",
      SECOND: "сония",
      TIME: "вақт",
      SPEED_BY_X1: "Тезлик 1x",
      SPEED_BY_X2: "Тезлик 2x",
      SPEED_BY_X3: "Тезлик 3x",
    },
    PRINT: {
      CARD: "Картани чоп этиш",
      NOTIFICATION: "Хабарнома",
      CONTRACT: "Шартнома",
      EV_DOC: "Далолатнома",
      REFERENCE_DOC: "Маълумотнома",
    },
    WARNING_CARD: {
      WARNING_TITLE:
        "Илтимос, файл структураси қандай кўринишда бўлишини юклаб олиш учун пастдан варянтни танланг!",
      TITLE:
        'Агар "{{selectTitle}}"ни таҳрирлаш учун файл структураси қандай кўринишда бўлишини билмасангиз намуна учун файлни юклаб олишингиз мумкин.',
      BUTTON: "Юклаб олиш",
      NO_USER_FOUND_FOR_SUCH_PASSPORT_AND_PNFL:
        "Бундай паспорт ва ЖШШИР бўйича фойдаланувчи топилмади!",
    },
    IMPORT_CARD: {
      TITLE:
        "Агар файл структураси қандай кўринишда бўлишини билмасангиз намауна учун файлни юклаб олишингиз мумкин",
      BUTTON: "Юклаб олиш",
    },
    BUTTON: {
      SAVE: "Сақлаш",
      UPDATE: "Янгилаш",
      DELETE: "Ўчириш",
      DELETE_SELECTED: "Танланганларни ўчириш",
      WARNING_CELECTED: "Танланганларни огоҳлантириш",
      SEARCH: "Қидириш",
      CANCEL: "Бекор қилиш",
      CLEAN: "Тозалаш",
      PRINT: "Чоп этиш",
      CLOSE: "Ёпиш",
      CONFIRM: "Тасдиқлаш",
      EDIT: "Таҳрирлаш",
      LINK: "Ҳавола",
      OTHER: "Бошқа",
      SELECT: "Танлаш",
      READ_MORE: "Батафсил",
      GPS_SETTING: "GPS созламалари",
    },
    GARBAGE_TYPE: {
      SOLID_WASTE: "Қаттиқ маиший чиқиндилар (сўм)",
      LIQUID_WASTE: "Суюқ маиший чиқиндилар (сўм)",
      CONSTRUCTION_WASTE: "Қурилиш ва бошқа чиқиндилар (сўм)",
    },
    BUTTON_TITLES: {
      CLEARABLE_BUTTON_TITLE: "Филтерни тозалаш",
    },
    HOUSE_TYPE: {
      HOUSE: "Участка",
      APARTMENT: "Кўп каватли",
      NOT_INCLUDET: "Киритилмаган",
    },
    ACTION_DROPDOWN: {
      ACTION: "Ҳаракатлар",
      ADD: "Қўшиш",
      EDIT: "Таҳрирлаш",
      DELETE: "Ўчириш",
      STOP: "Тўхтатиш",
      FINISH: "Якунлаш",
      MARGE_FILE: "Файл бириктириш",
      UPLOAD_FILE: "Файлни юклаш",
      GET_PAYMENTS: "Тўловлар",
      VIEW_DETAILS: "Тафсилотлар",
      CHECK: "Тасдиқлаш",
      ACTIVATION: "Фаоллаштириш",
      CONFORMATION: "Тасдиқлаш",
      BLOCK: "Блоклаш",
      UN_BLOCK: "Блокни очиш",
      WARNING: "Огоҳлантириш",
      WARNING_ACT: "Огоҳлантирилган актларни бекор қилиш",
      APPROVED: "Қабул қилиш",
      CANCEL: "Бекор қилиш",
      ACTION_CANCEL: "Амални бекор қилиш",
      EDIT_HOME: "Участкани ўзгартириш",
      EDIT_STREET: "Кўчани ўзгартириш",
      EDIT_PERSON_COUNT: "Яшовчилар сонини ўзгартириш",
      CANCEL_CONTRACT: "Шартномани бекор қилиш",
      PRIMARY_INV: "Бирламчи Инв.",
      FIND_FROM_CADASTR: "Кадастр базасидан излаш",
      SEARCH_FROM_CADASTR: "Кадастр базасидан онлайн излаш",
      CHEKING_PERSONS_OF_HOME: "Хонадонда рўйхатда турувчиларни текшириш",
      SEARCH_PERSON_BY_PASSPORT: "ЖШШИР ва Паспорт серияси орқали излаш",
      ADD_COMPANY: "Корхона қайта ҳисоби",
      TOTAL: "Жами",
      INSTALL_LIMIT: "Лимит ўрнатиш",
      CONFIRMED_CANCELLED: "Тасдиқлаганган актни бекор қилиш",
      NEW_VERSION: "Янги версия мавжуд, янгилашни хоҳлайсизми?",
      FORMA_1_PDF: "Форма-1ни юклаб олиш",
    },
    SPECIAL_ACTION_DROPDOWN: {
      ACTION: "Махсус ҳаракатлар",
      TITLE: "Электр энергия ҳисоб рақамини ўзгартириш",
      TITLE_2: "Абонентларни белгилаб ўчириш",
      IMPORT: "Aбонентларни импорт қилиш",
      IMPORT_EDIT: "Импорт орқали таҳрирлаш",
      NARYAD: "Наряд",
      PAYMENT: "Абонент тўлови",
      IMPORT_FIRST_INV: "Импорт орқали бирламчи инвентаризация",
      IMPORT_PERIOD_SALDO: "Импорт давр бошига салдо",
      WARNING_RESIDENTS: "Абонентларни огоҳлантириш",
      WARNING_BY_HET: "ҲЭТ орқали огоҳлантириш",
      NO_DATA_IN_HET: "ҲЭТда маълумот топилмади",
      ERROR_IN_HET: "ҲЭТда хатолик юз берди",
      ADD_SUB_ACCOUNT: "Суб-ҳисоб рақам қўшиш",
      DELETE_SUB_ACCOUNT_TITLE: "Суб-ҳисоб рақамни ажратиш",
      DELETE_SUB_ACCOUNT_CONFIRM:
        "Сиз ҳақиқатан ҳам танланган абонентни асосий ҳисоб рақамдан ажратмоқчимисиз? Амалиёт бажарилгандан сўнг бу абонент суб-ҳисоб рақам ҳисобланмайди.",
      ATTACHMENT_SUB_ACCOUNT: "Суб-ҳисоб рақам бириктириш",
      SEARCH_AND_SELECT_FROM_HET: "ҲЭТдан излаш ва танлаш",
      GET_DATA_FROM_HET: "ҲЭТдан маълумот олиш",
      MAIN_ACCOUNT: "Асосий ҳисоб рақам",
      SUB_ACCOUNT: "Суб-ҳисоб рақам",
      ATTACH_ACCOUNT_CADASTRAL_WARNING:
        "Бу ерда суб-ҳисоб рақамнинг кадастр рақами ўчирилади ва асосий ҳисоб рақамнинг кадастр рақами автоматик ёзилади!",
      ATTACH_ACCOUNT_MAHALLA_WARNING:
        "Бу ерда суб-ҳисоб рақамнинг маҳалласи ўчирилади ва асосий ҳисоб рақамнинг маҳалласи автоматик ёзилади!",
      ATTACH_ACCOUNT_STREET_WARNING:
        "Бу ерда суб-ҳисоб рақамнинг кўчаси ўчирилади ва асосий ҳисоб рақамнинг кўчаси автоматик ёзилади!",
      MOVE_RESIDENT_FROM_TO_MAHALLA:
        "Абонентларни бир маҳалладдан бошқасига кўчириш",
      HET_BLOCK_CHECK: "ҲЕТ блоклашини текшириш",
    },
    ACTION_DROPDOWN_FILE: {
      FILE: "Файл",
      PRINT: "Чоп этиш",
      EXCEL: "Ехcеl",
    },
    TRANSLATOR: {
      SELECT: "Тилни танланг",
      WAITING: "Илтимос, кутинг...",
    },
    SELECT: {
      SELECT_COMPANY: "Корхонани танланг",
      NOT_FOUND: "Топилмади",
      SELECT_DISTRICT: "Туманни танланг",
      MAHALLA: "Маҳалла",
      SUB_MAHALLA: "Суб-маҳалла",
      ERROR_CALCULATION_BY_MAHALLA_PAGE:
        "Бу абонент маҳалла ҳудудига бириктирилмаган!",
    },
    DATAPICKER: {
      TITLE: "Сана",
      FROM: "Дан:",
      TO: "Гача:",
      ONE_MONTH: "Максимал 30 кун оралиқни танлашингиз мумкин.",
      IN_PERIOD: "Бир давр оралиғида танлаш мумкин.",
    },
    NAVBAR: {
      CURRENT_PERIOD: "Жорий давр:",
    },
    FILTER: "Филтр",
    SELECTED_RESIDENTS: "Танланган абонентлар",
    SELECTED_ACTS: "Танланган актлар",
    SELECTION_DELETE: "Танлаб ўчириш",
    TABLE_NO_DATA: "Маълумот йўқ",
    TYPE_TO_SEARCH: "Қидириш учун ёзинг",
    STATUS: "Ҳолат",
    VIEW: "{{items3}} тадан {{items}} дан {{items2}} гача ",
    LOADING: "Юкланмоқда...",
    ACCESS_DENIED: "Кириш чекланган",
    CONFIRMATION: {
      DELETE: "Сиз ҳақиқатан ҳам бу файлни ўчириб ташламоқчимисиз?",
      CONFIRM: "Тасдиқлаш",
      CANCEL: "Бекор қилиш",
    },
    GEO_DASHBOARD: {
      ON_DEBT: "Қарздорлик бўйича",
      ON_FROZEN: "Музлатилганлик бўйича",
      NOT_FOUND_POLYGON: "{{count}} та майдон маълумоти топилмади.",
    },
    USER_PROFILE: {
      TITLE: "Фойдаланувчи профили",
    },
    MENU: {
      DASHBOARD: "Статистика",
      GEO_DASHBOARD: "Гео таҳлил",
      LEASING: "Лизинг",
      DXSH: {
        TITLE: "ДХШ",
        INVESTITION_INFO: "Корхоналар",
        CONTRACTS: "Шартномалар",
        DXSH_INVESTMENT: "Шартнома бажарилганлик факти",
        INVESTITION_CATEGORIES: "Категориялар",
        DXSH_REPORT: "Ҳисобот",
        STATISTICS: "Статистика",
        FACT_OF_NEW_WORK_POSOTIONS: "Янги иш ўрин яратилганлик факти",
        REPORTS_BY_CONTRACT: "Шартнома бўйича ҳисобот",
      },
      TOOLS: {
        TITLE: "Жисмоний aбонентлар",
        RESIDENTS: "Абонентлар",
        CHANGE_PHONE_NUMBER_RESIDENT_REQUEST_TITLE:
          "Рақамни таҳрирлаш сўровлари",
        IIB_SINXRONIZATSIYA: "ИИБ синхронизация",
        BLOCKED_RESIDENTS: "Блокланган абонентлар",
        DELETED_RESIDENTS: "Ўчирилган абонентлар",
        WARNING_RESIDENTS: "Огоҳлантирилган абонентлар",
        LEGAL_RESIDENTS: "Юридик абонентлар",
        HET_SEARCH_DATA: "ҲЭТ базасидан маълумотларни излаш",
        PAYMENTS: "Электрон тўловлар",
        MUNIS: "Мунис",
        APPEAL: "Онлайн мурожаат",
        ALLPAYMENTS: "Тўловлар",
        NARYAD: "Наряд",
        OPERATIONS: "Давр операциялари",
        PLANS: "Тариф",
        ACCRUAL: "Ҳисобланди",
        COURT: "Суд",
        COURT_WARNING: "Суд огоҳлантиришлари",
        CREATE_COURT_WARNING: "Суд огоҳлантиришлари яратиш",
        COURT_ACTION: "Суд жараёнлари",
        LIMITS: "Хабарнома чекловлари",
        MVD_INFO: "МВД малумотлар",
        KADASTR_INFO: "Кадастр малумотлари",
        ACTS: "Актлар",
        ACT_PACK: "Актлар пачкаси",
        ACT_FORMS: "Акт бланклари",
        INVENT_ACTS: "Инвентаризация актлари",
        CHANGING_ACTS: "Яшовчилар сонини ўзгартириш актлари",
        FROZEN_DEBT_ACTS: "Музлатилган қарздорлик актлари",
        FIRST_INVENTORY_ACTS: "Бирламчи инвентаризация актлари",
        NOTIFICATION_RESTRICTIONS: "Хабарнома чекловлари",
        CASH_PAYMENTS: "Нақд пул тўловлари",
        ORG_EMPLOYEES: "Корхона ходимлари",
        ACTIONS: "Амаллар",
        EMPLOYEE_ACTIONS: "Ходим амаллари",
        RESIDENT_ACTIONS: "Абонент амаллари",
        USERS_SPECIAL_ACTIONS: "Фойдаланувчилар махсус ҳаракатлари",
        RECEIPT_FORMS_COUNT: "Квитанциялар бланкалари ҳисоби",
        FREEZING: "Музлатиш",
        FREEZING_MAHALLA: "Маҳаллалар",
        FROZEN_RESIDENTS: "Абонентлар",
        FROZEN_STREETS: "Кўчалар",
        EDIT_RESIDENT_INFORMATION: "Маълумоти нотўғри абонентлар",
        NON_EXISTENT_RESIDENTS_IN_SYSTEM: "Солиқдан олинган абонентлар",
        MY_GOV: "MyGov дан келган аризалар",
        MY_GOV_APPEAL: "Тизимда абоненти бор аризалар",
        MY_GOV_APPEAL_RESIDENT_NULL: "Абоненти номаълумлар",
        CADASTR_PUSH: "Кадастр ўзгаришлари",
      },
      GENERAL: {
        TITLE: "Умумий",
        RECEIPT_ISSUERS: "Квитанция берувчилар",
      },

      SETTINGS: {
        TITLE: "Созламалар",
        USER_ROLES: "Фойдаланувчилар роли",
        EMPLOYEES: "Ҳодимлар",
        OPERATIONS: "Даврлар операциялари орг.",
        REPORT_CURRENT_PERIOD: "Жорий давр учун ҳисобот",
      },
      WORK1031: {
        TITLE: "МИБ ва 1031 тартиби бўйича ишлаш",
        PAYMENT_LIST: "Тўловлар рўйхати",
        EMPLOYEE_LIST: "Ташкилот ходимлари рўйхати билан ишлаш",
        ORGANIZATION_LIST: "Ташкилотлар рўйхати",
        ORGANIZATION_DEPARTMENT_LIST: "Ташкилот бўлимлари рўйхати билан ишлаш",
        ORGANIZATION_EMPLOYEES_TITLE: "Ташкилот ходимлари",
      },
      GEOGRAPHY: {
        TITLE: "География",
        VILLAGES: "Маҳаллалар",
        MAHALLA_AREA: "Маҳалла ҳудудлари",
        MAHALLA_AREA_BIND_RESIDENTS: "Ҳудудга абонент бириктиш",
        STREETS: "Кўчалар",
        REGIONS: "Вилоятлар",
        DISTRICTS: "Туманлар",
        POLIGON: "Майдон",
        WASTE_COLLECTION_AREA: "Чиқинди йиғиш майдони",
        AREA_BRICKING_OF_LEGAL_RESIDENTS: "Юридик абонентлар",
        VILLAGE_CLASSIFIER: "Маҳаллаларни синхронлаш",
      },
      MANAGEMENT: {
        ROLES: "Роллар",
        USERS: "Фойдаланувчилар",
        USERS_LIST: "Рўйхат",
        TITLE: "Умумий",
        COMPANIES: "Корхоналар",
        COMPANY_OPERATIONS: "Корхоналар давр операциялари",
        REPORTING_PERIOD: "Ҳисобот даври",
        EMPLOYEES: "Ҳодимлар",
        BLOCKED_USERS: "Блокланган фойдаланувчилар",
        INVESTITION_CATEGORIES: "Инвестиция категориялари",
        INTEGRATIONS: "Интеграциялар",
        SYSTEM_CONFIGURATIONS: "Тизим созламалари",
        PARAMETER_NAME: "Параметр номи",
        PARAMETER_VALUE: "Параметр қиймати",
        BANK_OPERATIONS: "Банк операциялари",
        BANK_BILLING_COMPARISON:
          "Банк ва биллинг тушумлари солиштирма ҳисоботи",
        ACT_PERMISSION_BY_COMPANIES: "Aкт шакллантиришни бошқариш",
        WORK_1031_PERMISSION_BY_ORGANIZATION:
          "МИБ ва 1031 шакллантиришни бошқариш",
        PAYMENTS_PERMISSION_BY_ORGANIZATION:
          "Нақд тўловлар шакллантиришни бошқариш",
        MUNIS_SVERKA: "Munis сверка",
        COM_GR_ADMIN: "Корхона гуруҳи директори",
        COMPANY_LOGIN: "Корхонага СМС логинлари",
        MY_GOV_APPEAL_REPORT: "MyGov дан келган аризалар ҳисоботи",
        GNK_RESIDENTS_REPORT: "Солиқдан олинган абонентлар ҳисоботи",
        HET_WARNING_MAHALLAS: "HET орқали огоҳлантириш",
      },
      COVERAGE_REPORT: {
        TITLE: "Корхоналар томонидан қамраб олинган ҳудудлар бўйича ҳисобот",
        REGION_NAME: "Ҳудуд номи",
        STATISTIKA_BOYICHA_YIL_HOLATIGA:
          "Статистика бўйича 01.01.2025 йил ҳолатига",
        BILLING_TIZIMIGA_KIRITILGAN: "Биллинг тизимига киритилган",
        MAHALLA_COUNT: "Маҳалла сони",
        RESIDENT_COUNT: "Абонент сони",
        TOTAL_INHABITANTS: "Аҳоли сони",
        TOZA_HUDUD_DUK_QAMRAB_OLGAN:
          "Тоза худуд-Махсустранс-ДУК қамраб олган  ",
        KLASTERLAR_QAMRAB_OLGAN: "Кластерлар қамраб олган",
        HUSUSIY_KORXONALAR_QAMRAB_OLGAN: "Хусусий корхоналар қамраб олган",
        DXSH_KORXONALAR_QAMRAB_OLGAN: "ДХШ корхоналар қамраб олган",
        HAQIQATDA_XIZMAT_KILUVCHI_MAHALLA_PERCENT:
          "Ҳақиқатда хизмат кўрсатувчи маҳалла %",
        HAQIQATDA_XIZMAT_KILUVCHI_AHOLI_PERCENT:
          "Ҳақиқатда хизмат кўрсатувчи аҳоли %",
      },
      GNK_RESIDENTS_REPORT: {
        TITLE: "Солиқдан олинган абонентлар ҳисоботи",
        REGIONS: "Вилоятлар",
        TOTAL_RESIDENTS: "Жами абонентлар сони",
        ALL_ATTACHED_RESIDENTS: "Жами бириктирилган абонентлар сони",
        UNATTACHED_RESIDENTS: "Бириктирилмаган абонентлар сони",
        ATTACHED_RESIDENTS_COUNT_BY_DATE:
          "Танланган вақтдаги бириктирилганлар сони",
        ATTACHED_GNK_RESIDENTS: "Абонент Ф.I.O",
        GNK_RESIDENT: "Солиқдан олинган Ф.I.O",
        ACCOUNT_NUMBER: "Ҳисоб рақами",
        DISTRICT: "Туман",
        MAHALLA: "Маҳалла",
        HOUSE_TYPE: "Уй тури",
        PLOSHAD: "Майдон",
        ADDRESS: "Манзил",
        CADASTRAL_NUMBER: "Кадастр рақами",
        PNFL: "ЖШШИР",
        INN: "ИНН",
      },
      COMPANY_LOGIN: {
        ADD_TITLE: "Корхонага СМС логинлари қўшиш",
        EDIT_TITLE: "Корхонага СМС логинларини таҳрирлаш",
        FORM_TITLE: "Корхона учун ушбу login смс юборишни ёқиш ёки ўчириш",
      },
      MY_GOV_APPEAL_REPORT: {
        TITLE: "MyGov дан келган аризалар ҳисоботи",
        TABLE_HEADERS: {
          CREATED_COUNT: "Яратилганлар сони",
          ACCEPTED_COUNT: "Қабул қилинганлар сони",
          COMPLETED_COUNT: "Бажарилганлар сони",
          CANCELLED_COUNT: "Бекор қилинганлар сони",
          TOTAL_COUNT: "Жами аризалар сони",
        },
      },
      SMS_GATEWAY: {
        TITLE: "СМС тарихи",
        PURPOSE: "Мақсади",
        PAYMENT: "Тўлов учун",
        DEBIT: "Қарздорлик учун",
        CONFIRM_CODE: "Тасдиқлаш коди",
      },
      REPORTS: {
        GPS_REPORT: "Ҳисоботлар",
        TITLE: "Ҳисоботлар",
        GENERAL: "Барча ҳисоботлар",
        REPORT1: "ДҲЖ-1 Ҳисобот",
        REPORT2: "Ф-2 ДҲЖ Ҳисобот",
        REPORT3: "ДҲЖ-2 тушумлар рўйҳати",
        REPORT4: "Маҳаллалар кесимида қарздорлар таҳлили",
        REPORT5: "Мунис тўловлари бўйича ҳисобот",
        REPORT6: "Маҳаллалар кесимида ҳақдорлар таҳлили",
        REPORT7: "Электрон тўловлар бўйича ҳисобот",
        REPORT8: "Тўлов қилмаган абонентлар",
        REPORT9: "Хабарнома чекловлари ҳисоботи",
        REPORT10: "Хатлов далолатномалар таҳлили",
        REPORT11: "Хатлов далолатномалари ҳисоботи",
        REPORT12: "Суд жараёнлари устида даврий амаллар ҳисоботи",
        REPORT13: "Аҳоли сони бўйича ҳисобот",
        REPORT14: "Онлайн мурожаат ҳисоботи",
        REPORT15: "Фойдаланувчилар сессияси ҳақида свод ҳисоботи",
        REPORT16: "ДХШ тушумлар ҳисоботи",
        REPORT17: "Фойдаланувчи сессияси ҳақида ҳисобот",
        REPORT18: "Қарздорлиги юқори бўлган абонентлар",
        REPORT19: "Қарздорлиги юқори бўлган абонентлар тўғрисида суд ҳисобот",
        REPORT20: "Тушумлар - ходимлар кесимида",
        REPORT21: "ЖШШИР ва кадастр рақам тўлдирилганлиги ҳисоботи",
        REPORT22: "Суд жараёнлари ҳолатлари бўйича таҳлил",
        REPORT23: "МФА-1 ДҲЖ ҳисоботи",
        REPORT24: "МUNIS",
        REPORT26: "МФА-2 ДҲЖ Жорий давр бўйича",
        REPORT27: "МФА-4 Актлар ҳисоботи",
        REPORT31: "Рўйхатдаги абонентлар мониторинги",
        REPORT33: "Аналитик SMS ҳисоботи",
        REPORT28: "МФА-16 Жами тушумлар таҳлили",
        REPORT29: "МФА-8 СМС Хабарномалар ҳисоботи",
        REPORT40: "СМС лар бўйича йиғма ҳисобот",
        REPORT38: "Маҳаллалар кесимида кунлик киритилган абонентлар",
        REPORT39: "Идентификацияланган абонентлар ҳисоботи",
        REPORT41: "Актлар ҳолати ҳисоботи",
        REPORT43: "Ф-3 ДҲЖ ҳисобот",
        REPORT42: "Абонентлар ўзгариш ҳисоботи",
        REPORT45: "Суд жараёнлари ҳолаталари кесимида ҳисобот",
        REPORT46: "МФА-6 Вақтинча ўчирилган абонентлар бўйича ҳисобот",
        REPORT47: "Тушумлар - ходимлар кесимида",
        REPORT48: "Абонентларга CHYM ташриф учун ҳисобланган сумма",
        REPORT49: "Дебиторлик қопланиши таҳлилий ҳисоботи",
        REPORT50: "Акт турлари бўйича ҳисобот",
        DUPLICATE_CADASTRAL: "Такрорий кадастр рақамлари ҳисоботи",
        REPORT_GPS_VISIT_CONTROL:
          "GPS чиқинди йиғиш майдони ва суб-маҳаллага бириктирилган абонентлар сони",
        ELECTRICITY: "Электр энергия солиштирма ҳисоботи",
        REPORT_CREDITORS: "Маҳаллалар кесимида хақдорлар таҳлили",
        REPORT_RESIDENTS_DEBT: "Қарздорлиги юқори бўлган абонентлар",
        RESIDENTS_WITH_HIGH_INDEBTEDNESS_REPORT:
          "Қарздорлиги юқори бўлган абонентлар тўғрисида свод ҳисобот",
        REPORT_ANALYTICAL_SMS: "Aналитик смс ҳисоботи",
        REPORT_GPS_WORKING_TIME:
          "Махсус чиқинди ташувчи техникалар ишга чиққанлиги",
        INPUT_OUTPUT: "Техникаларнинг ҳудудларга кириш-чиқиш вақти",
        HET_BLOCK_USERS: "ҲЭТ томонидан блокланган фойдаланувчилар",
        HET_WARNING_USERS: "ҲЭТ томонидан огоҳлантирилган абонентлар",
        HET_WARNING_POSSIBLE_USERS:
          "ҲЭТ томонидан огоҳлантирилиши мумкин бўлган фойдаланувчилар",
        RESIDENT_IDENTIFICATION_CANCEL_REASON_REPORT_TITLE:
          "Идентификацияси бекор қилинган абонентлар тўғрисида ҳисобот",
        RESIDENT_IDENTIFICATION_CANCEL_REASON_REPORT_CANCELED_RESIDENTS_TITLE:
          "Идентификацияси бекор қилинган абонентлар",
        GPS_ACCRUALS_REPORT:
          "GPS тизими орқали жорий қилинган тўловларни ҳисоблаш ҳудудлар бўйича ҳисоботи",
        FEED_BACK_REPORT_TITLE:
          "Шахсий кабинет орқали абонентлар томонидан берилган баҳолар бўйича ҳисобот",
      },
      NOTIFICATIONS: {
        TITLE: "Хабарномалар",
        MODULE: "Хабарнома модули",
        REQUIREMENTS: "Талаблар",
      },
      GPS_TRACKING: {
        TITLE: "GPS кузатув",
        GPS: "GPS",
        MONITORING: "Мониторинг",
        COMPANY_AUTOS_WORK_GRAPHICS_TITLE: "Техникалар иш графиги",
        ACTION_REPORT: "Ҳаракатлар ҳисоботи",
        AUTOMOBILE_TYPES: "Автомобил турлари",
        AUTOMOBILES: "Автомобиллар",
        TRACKER_MODELS: "GPS қурилма моделлари",
        ATTACH_AUTO_TO_COMPANY: "Aвтомобил бириктириш",
        SECONDS: "Дақиқа",
        MAHALLA_VISIT_ANALYZE: "Маҳаллага ташрифлар таҳлили",
        VISITS_TO_POLYGON: "Техникаларнинг полигонларга ташрифлар сони",
        VISITS_TO_LEGAL: "Техникаларнинг юридик абонентларга ташрифлар сони",
        VISITS_GRAPHS_CONTROL: "Ташрифлар графиги бошқаруви",
        GPS_VISITS_GRAPH_ANALYZE_TITLE:
          "Автомобиллар графикка амал қилаётганини назорат қилиш",
      },
      LEGAL_ENTITIES: {
        STATISTICS: "Статистика",
        TITLE: "Юридик aбонентлар",
        ABONENTS: "Абонентлар",
        ADDITIONAL_TYPES: "Қўшимча хизмат турлари",
        INDUSTRY_TYPES: "Соҳа турлари",
        TARIFFS: "Тарифлар",
        CONTRACTS: "Ҳудудлар кесимида шартномалар",
        NORMATIVES: "Норматив",
        ORGANIZATIONS: "Ташкилотлар",
        MONEY_TRANSFERS: "Пул ўтказмалари",
        ONLINE_PAYMENTS: "Онлайн тўловлар",
        MUNIS: "Мунис тўловлар",
        ACTS: "Актлар",
        CASH_PAYMENTS: "Нақд пул тўловлари",
        SCHET_FAKTURA: "Счет-фактура",
      },
      SPRAVOCHNIK: {
        TITLE: "Справочниклар",
        PAYMENT_PARTNERS: "Тўлов ҳамкорлари",
        STATUS_TYPES: "Статуслар ва турлар",
        NOTIFICATION_TYPES: "Хабарнома турлари",
        TEMPLATES_TITLE: "Шаблон турлари",
        CONTRACT_TEMPLATES_TITLE: "Шартнома",
        EVIDENCE_TEMPLATES_TITLE: "Далолатнома",
        NOTIFICATION_TEMPLATES_TITLE: "Хабарнома",
        COMPANY_SETTINGS_TYPES_TITLE: "Корхона созламалари турлари",
        ACTS_TITLE: "Актлар",
        SMS_TEMPLATES_TITLE: "SMS",
      },
      POLYGON: {
        TITLE: "Полигон",
        POLYGONS: "Лицензияга эга ташкилотлар",
        COMPANY: "Корхоналар",
        POLYGONS_INFO: "Полигонлар",
        CARS_LICENSED: "Автомобиллар лицензияси",
        TARIFF: "Тарифлар",
        STATISTICS: "Статистика",
        REPORTS: "Ҳисоботлар",
        EMPLOYEES: "Ҳодимлар",
      },
    },
    TOAST: {
      TITLE: {
        SUCCESS: "Муваффақиятли",
        WARNING: "Огоҳлантириш",
        CANCELLED: "Бекор қилинган",
        ERROR: "Хатолик",
        INFO: "Маълумот",
        DOWNLOAD: "Юклаб олиш",
        EXPORT_EXCEL: "Excel файл муваффақиятли юклаб олинди!",
        IMPORT_EXCEL: "Excel файл муваффақиятли импорт қилинди!",
        RESIDENT_ID: "Жадвал қаторида абонент ID мавжуд эмас",
        SEND_SMS_WARNING_SUCCESS: "Хабарнома муваффақиятли жўнатилди",
        SEND_SMS_WARNING_ERROR: "Хабарнома жўнатилишида хатолик содир бўлди",
      },
      TOAST_DELETE: "Танланган жадвал қатори муваффақиятли ўчирилди!",
      TOAST_SELECT_ROW: "Илтимос, қаторни тангланг!",
      TOAST_SUCCESS: "Маълумот муваффақиятли қўшилди!",
      TOAST_ATTACH: "Маълумот муваффақиятли бириктирилди!",
      TOAST_UPDATE: "Маълумот муваффақиятли таҳрирланди!",
      TOAST_UPDATE_ERROR: "Таҳрирлашда хатолик содир бўлди!",
      TOAST_MULTIPLE_SELECT_ROW: "Илтимос, қаторларни танланг!",
      TOAST_WARNING:
        "Агар файл структураси қандай кўринишда бўлишини билмасангиз намуна учун файлни юклаб олишингиз мумкин",
      TOAST_WARNING_RESIDENT: "Бу абонент корхона ходими эмас!",
      TOAST_ERROR_NOT_EMPLOYEE: "Бу абонент корхона ходими эмас!",
      TOAST_WARNING_RESIDENT_SEARCH: "Абонент топилмади",
      TOAST_WARNING_RESIDENT_NOT_FOUND: "Ушбу кўчада абонентлар топилмади",
      UPLOAD_FILE: "Файл муваффақиятли юкланди",
    },
    THEME_MODE: {
      LIGHT: "Кундузги",
      DARK: "Тунги",
      SYSTEM: "Тизим",
    },
    HEADER_INPUT: {
      REGION: "Вилоят",
      DISTRICTS: "Туман",
      COMPANY: "Корхона",
    },
    USER_INNER: {
      PROFILE: "Профил",
      EXIT: "Чиқиш",
    },
    CHANGE_PHONE_NUMBER_RESIDENT_REQUEST: {
      TABS: {
        SENT_REQUESTS: "Жўнатилган",
        INCOME_REQUESTS: "Келиб тушган",
      },
      TABLE_HEADERS: {
        RESIDENT_ID: "Абонент ИД",
        PHONE: "Телефон",
        ADDRESS: "Манзил",
        CREATED_BY_NAME: "Ким томонидан яратилган",
        CREATED_DESCRIPTION: "Яратилганлиги ҳақидаги изоҳ",
        CANCELLED_DESCRIPTION: "Рад этилганлиги ҳақидаги изоҳ",
        CREATED_AT: "Яратилган сана",
        ACCOUNT_NUMBER: "Ҳисоб рақами",
        COMPLETE: "Тасдиқлаш",
        CANCEL: "Бекор қилиш",
        STATUS: "Ҳолати",
        CREATED: "Яратилган",
        COMPLETED: "Тасдиқланган",
        CANCELLED: "Бекор қилинган",
      },
      STATUS: {
        CREATED: "Яратилган",
        COMPLETED: "Тасдиқланган",
        CANCELLED: "Бекор қилинган",
      },
      FORM: {
        TITLE: "Сўров жўнатиш",
        ACCOUNT_NUMBER: "Ҳисоб рақами",
        PHONE_NUMBER: "Телефон рақами",
        DESCRIPTION: "Изоҳ",
        SEND: "Жўнатиш",
        CANCEL: "Бекор қилиш",
        CANCELLED_DESCRIPTION: "Рад этилганлиги ҳақидаги изоҳ",
      },
      MODAL: {
        CONFIRMATION_COMPLETE_MODAL_COMPLETE: "Тасдиқлаш",
        CONFIRMATION_COMPLETE_MODAL_TITLE: "Сўровни тасдиқлаш",
        CONFIRMATION_COMPLETE_MODAL_TEXT:
          "Сиз ҳақиқатан ҳам рақамни ўзгартириш сўровларини тасдиқламоқчимисиз?",
        CONFIRMATION_CANCEL_MODAL_CANCEL: "Бекор қилиш",
        CONFIRMATION_CANCEL_MODAL_TITLE: "Сўровни бекор қилиш",
        CONFIRMATION_CANCEL_MODAL_TEXT:
          "Сиз ҳақиқатдан ҳам сўровни бекор қилмоқчимисиз?",
      },
    },
    AUTH: {
      LOGIN: {
        TITLE: "Кириш",
        SUB_TITLE: "Тоза Макон Биллинг тизими",
        BUTTON: "Кириш",
        FORGOT_BUTTON: "Паролни унутдингизми?",
        LABEL_LOGIN: "Логин",
        LABEL_PASSWORD: "Парол",
        CONFIRM_PASSWORD: "Паролни тасдиқланг",
        PLACEHOLDER_LOGIN: "Логин киритинг",
        PLACEHOLDER_PASSWORD: "Парол киритинг",
        ERROR: "Маълумотлар нотоʻгʻри киритилди!",
        CHANGE_PASSWORD: "Паролни ўзгартириш",
        CURRENT_PASSWORD: "Жорий парол",
        OLD_PASSWORD: "Эски парол",
        NEW_PASSWORD: "Янги парол",
        CONFIRM_NEW_PASSWORD: "Янги паролни тасдиқланг",
      },
      FORGOT: {
        TITLE: "Паролни унутдингизми?",
        DESC: "Паролни тиклаш учун электрон почтангизни киритинг",
        SUCCESS: "Ҳисобингиз қайта тикланди.",
      },
      VALIDATION: {
        REQUIRED_LOGIN: "Логин киритилиши шарт!",
        REQUIRED_PASSWORD: "Парол киритилиши шарт!",
        INVALID_LOGIN: "Яроқсиз логин киритилди!",
        MIN_LOGIN: "Логин камида 3 та белгидан иборат бўлиши керак!",
        MIN_PASSWORD: "Парол камида 3 та белгидан иборат бўлиши керак!",
        MAX_LOGIN: "Логин кўпи билан 24 та белгидан иборат бўлиши керак!",
        MAX_PASSWORD: "Парол кўпи билан 24 та белгидан иборат бўлиши керак!",
        INVALID_PASSWORD: "Яроқсиз парол киритилди!",
        PASSWORD_MISMATCH: "Киритилган пароллар бир-бирига мос эмас!",
      },
    },
    LEGAL_ENTITIES: {
      INTEGRATION: {
        RESIDENTS: {
          ORG_ID: "Санитар корхона СТИР",
          ORG_NAME: "Санитар корхона номи",
          FACTURA_SUM: "Фактуралар суммаси",
          FACTURA_COUNT: "Фактура сони",
          REVENUE: "Транзит рақамга тушган сумма",
          DEBIT_SUM: "Истеъмолчиларнинг санитар корхонадан қарзи",
          CREDIT_SUM: "Истеъмолчининг санитар корхонага ортиқча тўлови",
          EQUIPMENT_COUNT: "Техникалари сони",
          AREA_ZONE: "Хизмат кўрсатадиган жойлари",
        },
        TARIFF: {
          OBL_NAME: "Вилоят номи",
          CITY_FEE: "Шаҳар учун тариф суммаси",
          AREA_FEE: "Туман учун тариф суммаси",
          UNIT_ID: "Ўлчов бирлиги",
          ORG_NAME: "Санитар корхона номи",
          AREA_NAME: "Туман номи",
          ORDER_DATE: "Тариф чиқарилган қарор санаси",
        },
        INFO: {
          TOTAL_CONTRACT_COUNT: "Шартнома сони",
          TOTAL_CONTRACT_SUM: "Шартнома суммаcи",
          TOTAL_CANDIDATES: "Номзодлар сони",
          COVERAGE: "Қамрови",
          DISPOSAL_COUNT: "Чиқинди йиғиш майдончалари сони",
        },
      },
      RESIDENT_CARD: {
        DATA_EDIT: "Таҳрирлаш",
        RESIDENT_INFO: "Абонент маълумотлари",
        LEARN_MORE: "Батафсил маълумот",
        LEFT_CARD: {
          LEGAL_RESIDENT: "Юридик абонент",
          INDUSTRY_TYPES: "Соҳа тури",
          BANK: "Банк",
          BANK_OKED: "ОКЭД",
          BANK_MFO: "Банк МФО",
          ACCOUNT_NUMBER: "Ҳисоб рақами",
          CADASTRAL_NUMBER: "Кадастр рақами",
          EMPLOYEE_COUNT: "Ҳодимлар сони",
          BUTTONS: {
            PAYMENT: "Тўлов",
            ACCOUNT_INVOICE: "Ҳисоб фактура",
            COURT_LAWSUIT: "Судга даъво",
          },
        },
        TABLE_HEADERS: {
          TARIFFS: "Тарифлар",
          CONTRACTS: "Шартномалар",
          PAYMENTS: "Тўловлар",
          ACCOUNT_INVOICE: "Ҳисоб фактура",
          SERVICES: "Хизматлар",
          VISITS: "Ташрифлар",
        },
      },
      RESIDENTS: {
        TABLE_HEADERS: {
          NAME: "Юридик шахс номи",
          ACCOUNT_NUMBER: "Ҳисоб рақами",
          DIRECTOR_FIO: "Директор Ф.И.Ш",
          BANK: "Банк",
          BANK_ACCOUNT: "Банк ҳисоб рақами",
          BANK_MFO: "Банк МФО",
          BANK_OKED: "Банк ОКЭД",
          CONTRACT_DATE: "Шартнома санаси",
          CONTRACT_NUMBER: "Шартнома рақами",
          CONTRACT_CLOSED_AT: "Шартнома тугаш санаси",
          CREATED_AT: "Яратилган сана",
          CREATED_BY: "Яратган шахс",
          DELETED_AT: "Ўчирилган сана",
          DELETED_BY: "Ўчирувчи",
          DESCRIPTION: "Изоҳ",
          ELECTRICITY_ACCOUNT_NUMBER: "Электр энергия ҳисоб рақами",
          ELECTRICITY_COATO: "Электр энергия COATO",
          FAX: "Факс",
          HOME_PHONE: "Уй телефон рақами",
          IS_BUDGET: "Бюджетми?",
          CADASTRAL_NUMBER: "Кадастр рақами",
          RESIDENT_TYPE: "Абонент тури",
          SUP_ORGANIZATION: "Юқори ташкилот",
          TIN: "СТИР",
          TYPE: "Тури",
          PERCENT: "Фоиз",
          UPDATED_AT: "Янгиланган сана",
          UPDATED_BY: "Янгилаган шахс",
        },
        FORM: {
          MAP_POSITION: "Картадаги жойлашув",
          COMPANY: "Корхона",
          TYPE: "Ташкилот тури",
          RESIDENT_TYPE: "Абонент тури",
          INDUSTRY_TYPES: "Соҳа тури",
          TIN: "СТИР",
          NAME: "Номи",
          OWNERSHIP_TYPES: "Эгалик тури",
          DIRECTOR_FIO: "Директор Ф.И.Ш",
          STATUS: "Ҳолати",
          HOME_PHONE: "Телефон рақами",
          FAX: "Факс",
          ELECTRICITY_COATO: "Электр энергия CОАТО",
          ELECTRICITY_ACCOUNT_NUMBER: "Электр энергия ҳисоб рақами",
          CADASTRAL_NUMBER: "Кадастр рақами",
          BANK: "Банк",
          BANK_ACCOUNT: "Банк ҳисоб рақами",
          BANK_MFO: "Банк МФО",
          BANK_OKED: "ОКЭД",
          MAHALLA_NAME: "Маҳалла номи",
          STREET_NAME: "Кўча номи",
          BUILDING_NUMBER: "Уй рақами",
          ZIPCODE: "Почта индекси",
          EMPLOYEE_COUNT: "Ҳодимлар сони",
          IS_BUDGET: "Бюджет ташкилоти",
          SUP_ORGANIZATION: "Юқори турувчи ташкилот",
          DESCRIPTION: "Изоҳ",
          FIRM_OR_ORGANIZATION: "Фирма/ташкилот",
          SOLE_ENTREPRENEUR: "Якка-тадбиркор",
          WASTE_VOLUME: "Контейнер ҳажми",
          GEOZONA: "Геозона (номини киритинг)",
          RESIDENTAL: "Жисмоний",
          NON_RESIDENTAL: "Юридик",
          PROPERTY_TYPE: "Мулк тури",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Юридик шахс қўшиш",
          EDIT_MODAL_TITLE: "Юридик шахсни таҳрирлаш",
          DELETE_MODAL_TITLE: "Танланган абонентни ўчириш",
          DELETE_MESSAGE:
            "Сиз ҳақиқатан ҳам танланган юридик шахсни тизимдан олиб ташламоқчимисиз?",
        },
        TABS: {
          MAIN: "Асосий маълумотлар",
          ADDITIONAL: "Қўшимча маълумотлар",
          LOCATION: "Жойлашув",
        },
      },
      ADDITIONAL_TYPES: {
        TABLE_HEADERS: {
          ID: "ID",
          COMPANY_ID: "Корхона номи",
          NAME: "Номи",
          SHORT_NAME: "Қисқа номи",
          RATE: "Нархи",
        },
        ADD_EDIT_MODAL: {
          COMPANY: "Корхона",
          RATE: "Нархи",
          SHORT_NAME: "Қисқа номи",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Хизмат тури қўшиш",
          EDIT_MODAL_TITLE: "Хизмат турини таҳрирлаш",
          DELETE_MODAL_TITLE: "Хизмат турини ўчириш",
          DELETE_MESSAGE:
            "Сиз ҳақиқатан ҳам танланган хизмат турини тизимдан олиб ташламоқчимисиз?",
        },
      },
      INDUSTRY_TYPES: {
        TABLE_HEADERS: {
          NAME: "Номи",
          DESCRIPTION: "Изоҳ",
          UNIT_NAME: "Бирлик номи",
          UNIT_NAME_UZ: "Бирлик номи (UZ)",
          UNIT_NAME_RU: "Бирлик номи (РУ)",
          UNIT_NAME_CRL: "Бирлик номи (УЗ)",
          DESCRIPTION_UZ: "Изоҳ (UZ)",
          DESCRIPTION_RU: "Изоҳ (РУ)",
          DESCRIPTION_CRL: "Изоҳ (УЗ)",
          BEGINNING: "Бошланиши",
          END: "Тугаши",
          OKONX: "ОКОНХ",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Соҳа тури қўшиш",
          EDIT_MODAL_TITLE: "Соҳа турини таҳрирлаш",
          DELETE_MODAL: "Соҳа турини ўчириш",
          DELETE_MODAL_TITLE:
            "Сиз ҳақиқатан ҳам танланган соҳа турини тизимдан олиб ташламоқчимисиз?",
        },
      },
      TARIFFS: {
        TABLE_HEADERS: {
          ID: "ID",
          COMPANY_ID: "Корхона ID",
          NAME: "Номи",
          INDUSTRY_TYPES: "Саноат турлари",
          RATE: "Нархлар",
          START_DATE: "Бошланиш санаси",
          END_DATE: "Тугаш санаси",
          DESCRIPTION: "Изоҳ",
          SOLID_WASTE_RATE: "Қаттиқ маиший чиқинди",
          LIQUID_WASTE_RATE: "Суюқ маиший чиқинди",
          CONSTRUCTION_WASTE_RATE: "Қурилиш ва бошқа чиқинди",
        },
        FORMS: {
          COMPANY: "Корхона",
          RATE: "Нархи",
          START_DATE: "Бошланиш санаси",
          DESCRIPTION: "Изоҳ",
          WASTE_CATEGORY: "Чиқинди тури",
          SOLID_WASTE: "Қаттиқ маиший чиқиндилар",
          LIQUID_WASTE: "Суюқ маиший чиқиндилар",
          CONSTRUCTION_WASTE: "Қурилиш ва бошқа чиқиндилар",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Тариф қўшиш",
          EDIT_MODAL_TITLE: "Тарифни таҳрирлаш",
          DELETE_MODAL_TITLE: "Тарифни ўчириш",
          DELETE_MESSAGE: "Танланган тарифни тизимдан олиб ташламоқчимисиз?",
        },
      },
      CONTRACTS: {
        TITLE: "Шартномалар",
        TABLE_HEADERS: {
          CONTRACTED_DATE: "Шартнома санаси",
          CONTRACT_START_DATE: "Шартнома бошланиш санаси",
          CONTRACT_END_DATE: "Шартнома тугаш санаси",
          OVERALL_AMOUNT: "Жами суммаси",
          LEGAL_CONTRACT_TYPE: "Шартнома тури",
          LEGAL_RESIDENT: "Юридик шахс",
          TARIFF: "Тариф",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Шартнома қўшиш",
          EDIT_MODAL_TITLE: "Шартномани таҳрирлаш",
          DELETE_MODAL_TITLE: "Шартномани ўчириш",
          DELETE_MESSAGE:
            "Сиз ҳақиқатан ҳам танланган шартномани тизимдан олиб ташламоқчимисиз?",
        },
        CONTRACT_TYPE: {
          YEARLY: "Бир Йиллик",
          DISPOSABLE: "Бир марталик",
        },
      },
      NORMATIVES: {
        TABLE_HEADERS: {
          NAME: "Бирлик номи",
          MIN_AMOUNT: "Бирлик қиймати",
          NORMATIVE: "Норматив (г)",
          WEIGHT_BY_VOLUME: "Ҳажм бўйича вазни (кг/м³) ",
          INDUSTRY_TYPE_NAME: "Юридик шахс тури",
          TARIFF: "Тариф",
          RATE: "Нархи",
          WASTE_SUMM: "1 кг чиқинди учун тўлов (сўм)",
          WASTE_MONTH_SUMM: "Ойлик тўлов суммаси (сўм)",
        },

        MODALS: {
          ADD_MODAL_TITLE: "Норматив қўшиш",
          EDIT_MODAL_TITLE: "Нормативни таҳрирлаш",
          DELETE_MODAL_TITLE: "Нормативни ўчириш",
          DELETE_MESSAGE:
            "Сиз ҳақиқатан ҳам танланган нормативни тизимдан олиб ташламоқчимисиз?",
        },
      },
      VISITS: {
        TABLE_HEADERS: {
          COMPANY_NAME: "Корхона номи",
          AUTOMOBILE_NUMBER_AND_MODEL: "Автомобил рақами ва модели",
          VISIT_DATE: "Ташриф санаси",
          TIME_IN: "Кириш вақти",
          TIME_OUT: "Чиқиш вақти",
          PARKING_DURATION_IN_SECONDS: "Парковка давомийлиги (мин)",
          MIN_MOVING_DURATION: "Ҳаракатланиш вақти (мин)",
          MIN_DURATION_IN: "Кириш давомийлиги (мин)",
          MILEAGE: "Юрган масофа (км)",
          MAX_SPEED: "Максимал тезлик (км/с)",
          AVG_SPEED: "Ўртача тезлик (км/с)",
        },
      },
      STATISTICS: {
        FIELD_TYPES: {
          TITLE: "Соҳа турлари бўйича",
        },
      },
    },
    GPS_TRACKING: {
      ATTACH_STREET_TO_MAHALLA: {
        TITLE: "Кўчаларни маҳаллага бириктириш",
        STREET_BINDING_TITLE: "Кўчалар",
        MAHALLA_VISIT_ANALYZE: "Маҳаллага ташрифлар таҳлили",
        STREET_BINDING: "Кўча бириктириш",
        SELECTED_STREETS_COUNT: "Танланган кўчалар сони",
        DELETE_BINDING_STREET: "Бириктирилган кўчани ўчириш",
        DELETE_MESSAGE:
          "Сиз ҳақиқатан ҳам танланган кўчани маҳалладан олиб ташламоқчимисиз?",
      },
      ATTACH_AUTO_TO_COMPANY_NO_WIALON_ID: "Aвтомобил Wialon ID топилмади",
      AUTOMOBILE_TYPES: {
        TABLE_HEADERS: {
          MODEL: "Модел",
          DESCRIPTION: "Изоҳ",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Автомобил тури қўшиш",
          EDIT_MODAL_TITLE: "Автомобил турини таҳрирлаш",
          DELETE_MODAL_TITLE: "Автомобил турини ўчириш",
          DELETE_MESSAGE:
            "Сиз ҳақиқатан ҳам танланган автомобил турини тизимдан олиб ташламоқчимисиз?",
        },
      },
      AUTOMOBILES: {
        TABLE_HEADERS: {
          AUTOMOBILE_NUMBER: "Автомобил рақами",
          TRACKER_SERIAL_NUMBER: "Кузатув серия рақами",
          TRACKER_SIMCARD_NUMBER: "Кузатув SIM карта рақами",
          DESCRIPTION: "Изоҳ",
          STATUS: "Ҳолат",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Автотехника қўшиш",
          EDIT_MODAL_TITLE: "Автотехника таҳрирлаш",
          DELETE_MODAL_TITLE: "Автотехника ўчириш",
          DELETE_MESSAGE:
            "Сиз ҳақиқатан ҳам танланган автотехникани тизимдан олиб ташламоқчимисиз?",
        },
        FORM: {
          AUTOMOBILE_NUMBER: "Автотехника рақами",
          TRACKER_SERIAL_NUMBER: "GPS қурилма серия рақами",
          TRACKER_SIMCARD_NUMBER: "GPS қурилма SIM карта рақами",
          DESCRIPTION: "Изоҳ",
          STATUS: "Ҳолат",
          AUTOMOBILE_TYPE: "Автотехника тури",
          TRACKER_MODEL: "GPS қурилма модели",
          AUTOMOBILE_NUMBER_AND_MODEL: "Рақам ва модел",
          M_KUB: "Чиқинди ҳажми (м³)",
        },
      },
      TRACKER_MODELS: {
        TABLE_HEADERS: {
          NAME: "Номи",
          DESCRIPTION: "Изоҳ",
        },
        MODALS: {
          ADD_MODAL_TITLE: "GPS қурилма моделини қўшиш",
          EDIT_MODAL_TITLE: "GPS қурилма моделини таҳрирлаш",
          DELETE_MODAL_TITLE: "GPS қурилма моделини ўчириш",
          DELETE_MESSAGE:
            "Сиз ҳақиқатан ҳам танланган GPS қурилма моделини тизимдан олиб ташламоқчимисиз?",
        },
      },
      ATTACH_AUTO_TO_COMPANY: {
        EDIT_TITLE: "Корхона автотехникасини таҳрирлаш",
        COMPANY_NAME: "Корхона номи",
        COMPANY_TECH: "Корхона автотехникалари",
        AUTOMOBILE_NUMBER: "Автомобил",
        SELECT_COMPANY: "Корхонани танланг",
        AUTOMOBILE_WIALON: "Wialon автотехника",
        DRIVER: "Ҳайдовчилар",
        TABLE_HEADERS: {
          AUTOMOBILE_NUMBER: "Автомобил рақами",
          DRIVERS: "Ҳайдовчилар",
          WIALON_ID: "Wialon тизимидаги ID",
        },
        DELETE_MODAL_TITLE: "Бириктирилган автомобилни ўчириш",
        DELETE_MESSAGE:
          "Сиз ҳақиқатан ҳам ушбу бириктирилган автомобилни тизимдан олиб ташламоқчимисиз?",
      },
      GPS_WATCH: {
        AUTO_REFRESH: "Харитани автоматик янгилаш",
        SECOND: "сония",
        KM_H: "км/с",
        KM: "км",
        H: "с.",
        IMPORTANCE_OF_INDICATORS: "Кўрсаткичлар аҳамияти",
        ON: "Ёқилган",
        OFF: "Ўчирилган",
        CUSTOM_FIELDS: "Одатий майдонлар",
        NO_COORDINATES_WARNING: "Координаталар мавжуд эмас!",
      },
      STATISTICS: {
        INFO_CARD: {
          TITLE: "Географик бирликлар",
          REGION_COUNT: "Вилоятлар сони",
          DISTRICT_COUNT: "Туманлар сони",
          MAHALLA_COUNT: "Маҳаллалар сони",
          STREET_COUNT: "Кўчалар сони",
          POLYGON_COUNT: "Полигонлар сони",
          WASTE_COLLECTION_AREA_COUNT: "Чиқинди йиғиш майдонлари",
          AUTOMOBILE_COUNT: "Тизимдаги автомобиллар сони",
          ASSIGNED_AUTOMOBILE_COUNT: "Wialonга бириктрилганлар сони",
          ASSIGNED_AUTOMOBILE_ALL_COUNT: "Wialonдаги жами автомобиллар сони",
          WASTE_COLLECTION_AREA_MAHALLA_NAME: "Чиқинди йиғиш майдони маҳалласи",
          WASTE_COLLECTION_AREA_NAME: "Чиқинди йиғиш майдони номи",
          WASTE_COLLECTION_AREA_STREET_NAME: "Чиқинди йиғиш майдони кўчаси",
        },
        CARS_STATISTICS: {
          TITLE: "Автомобиллар статистикаси",
          TITLE1: "Автомобиллар турлари",
          TITLE2: "ГПС қурилмалар турлари",
        },
        NEIGHBORHOODS: {
          TITLE1: "Ҳафта давомида энг кам ташриф буюрилган маҳаллалар",
          TITLE2: "Ҳафта давомида энг кўп ташриф буюрилган маҳаллалар",
          COUNT: "Ташрифлар сон",
        },
      },
      MAHALLA_VISIT_ANALYZE: {
        FILTER: {
          VILLAGE: "Маҳалла",
        },
        TABLE_HEADERS: {
          MAHALLA_NAME: "Маҳалла номи",
          DATE: "Сана",
          INDEX: "Хизмат кўрсатиш индекси",
          ACTION: "Ҳаракат",
        },
        MAHALLA_VISIT_ANALYSIS_ITEMS_TABLE_HEADERS: {
          MARKED_AS_SERVICED: "Хизмат кўрсатилган деб белгилаш",
          MARKED_AS_GRAPHED: "Ташриф графигига мос",
          INDEX: "Хизмат кўрсатиш индекси",
          AUTOMOBILE_NUMBER: "Автомобил рақами",
          AVG_SPEED: "Ўртача тезлик (км/соат)",
          MAX_SPEED: "Энг юқори тезлик (км/соат)",
          DURATION_IN_TIME: "Ҳудудда бўлиш давомийлиги",
          MILEAGE: "Босиб ўтган масофаси (км)",
          MOVING_DURATION_IN_TIME: "Ҳаракатда бўлган вақти давомийлиги",
          PARKING_DURATION_IN_TIME: "Харакатсиз бўлган вақти давомийлиги",
          STOPS_COUNT: "Тўхташлар сони",
          TIME_IN: "Кириш вақти",
          TIME_OUT: "Чиқиш вақти",
          VISIT_DATE: "Ташриф санаси",
          ACTION: "Ҳаракат",
          ON_MAP: "Харитада",
        },
        MODALS: {
          TITLE_UPDATE: "Таҳрирлаш",
          CONFIRMATION_EDIT_STATUS_MODAL_TEXT:
            "Хизмат кўрсатилган деб белгилаш",
          CONFIRMATION_EDIT_STATUS_MODAL_TEXT_CANCEL:
            "Хизмат кўрсатилганликни бекор қилиш",
        },
      },
      VISITS_GRAPHS_CONTROL: {
        TABLE_HEADERS: {
          MAHALLA_NAME: "Маҳалла номи",
          DISTRICT_NAME: "Туман номи",
          DESCRIPTION: "Изоҳ",
          REGION_NAME: "Вилоят номи",
          COMPANY_NAME: "Корхона номи",
          END_DATE: "Вақтдан олдин тугаш санаси",
          FROM_DATE: "Бошланиш санаси",
          TO_DATE: "Тугаш санаси",
          FILE_PATH: "Бириктрилган файл",
          STATUS: "Ҳолат",
          ACTION: "Ҳаракат",
          NEW: "Янги",
          ACTIVE: "Фаол",
          INACTIVE: "Фаол эмас",
        },
        MODALS: {
          MAHALLA_NAME: "Маҳалла номи",
          FROM_TO_DATE: "Бошланиш ва тугаш санаси",
          DESCRIPTION: "Изоҳ",
          COMPANY_NAME: "Корхона номи",
          FILE_PATH: "Файл бириктириш",
          ADD_MODAL_TITLE: "Ташриф бошқаруви қўшиш",
          EDIT_MODAL_TITLE: "Ташриф бошқарув ҳолатини таҳрирлаш",
          DELETE_MODAL_TITLE: "Ташриф бошқарувини ўчириш",
          DELETE_MESSAGE:
            "Сиз ҳақиқатдан ҳам танланган ташриф бошқарувини тизимдан олиб ташламоқчимисиз?",
        },
      },
      GPS_ACCRUALS_REPORT: {
        TABLE_HEADERS: {
          NAME: "Номи",
          TOTAL_MAHALLAS_COUNT: "Жами маҳаллалар сони",
          GPS_BASED_MAHALLAS_COUNT:
            "Жами GPS асосида начисления ёқилган маҳаллалар сони",
          GPS_BASED_ACTIVE_MAHALLAS_COUNT:
            "Жорий даврда GPS начисления актив маҳаллалар сони",
          SUB_MAHALLAS_COUNT: "Жами суб-маҳаллалар сони",
          GPS_BASED_SUB_MAHALLAS_COUNT:
            "GPS асосида начисление ёқилган суб-маҳаллалар сони",
          ACTUAL_BALANCE_CALCULATED_MAHALLAS_COUNT:
            "GPS орқали ҳисобланган сумма жорий қилинган маҳаллалар сони",
          TOTAL_MAHALLAS_MONTHLY_TRIPS_NUMBER:
            "Жами маҳаллалар ойлик қатновлар сони",
          TOTAL_SUB_MAHALLAS_MONTHLY_TRIPS_NUMBER:
            "Жами суб-маҳаллалар ойлик қатновлар сони",
          TOTAL_GPS_BASED_SUB_MAHALLAS_MONTHLY_TRIPS_NUMBER:
            "GPS асосида суб-маҳаллалар ойлик қатновлар сони",
          MAHALLA_TOTAL_RESIDENTS_COUNT: "Жами маҳалла абонентлари сони",
          MAHALLA_TOTAL_GPS_BASED_RESIDENTS_COUNT:
            "GPS начисление ёқилган маҳалла абонентлари сони",
          SUB_MAHALLA_UNASSIGNED_RESIDENTS_COUNT:
            "Умумий бириктирилмаган абонентлар сони",
          SUB_MAHALLA_TOTAL_RESIDENTS_COUNT:
            "Жами суб-маҳалла абонентлари сони",
          SUB_MAHALLA_TOTAL_GPS_BASED_RESIDENTS_COUNT:
            "GPS начисление ёқилган суб-маҳалла абонентлари сони",
          TOTAL_VISITS_COUNT: "Жами ташрифлар сони",
          TOTAL_MAKED_AS_SERVICED_VISITS_COUNT:
            "Хизмат кўрсатилган деб белгиланган ташрифлар сони",
          TOTAL_DEFAULT_ACCRUAL_AMOUNT: "Жами одатий начисления суммаcи",
          TOTAL_SUB_MAHALLAS_ACCRUAL_AMOUNT:
            "Жами маҳалла ҳудудлари начисления суммаcи",
          TOTAL_AMOUNT: "Жами сумма",
          TOTAL_GPS_BASED_ACCRUAL_AMOUNT: "Жами GPS начисления суммаcи",
          TOTAL_CHYM_ACCRUAL_AMOUNT: "Жами ЧЙМ бўйича ҳисобланган сумма",
          ACCRUAL_TYPE: "Начисления тури",
          DEFAULT_ACCRUAL_AMOUNT: "Одатий начисления суммаси ",
          GPS_ACCRUAL_AMOUNT: "GPS начисления суммаси",

          CHYM_BASED: "ЧЙМ ташрифлар асосида",
          MAHALLA_BASED: "Махалла ташрифлар асосида",
        },
        MODAL: {
          TITLE: "Aбонентлар",
        },
      },
      GPS_VISITS_GRAPH_ANALYZE: {
        TABLE: {
          PLANNED: "Графикда",
          ACTUAL: "Амалда",
          MAHALLA_NAME: "Маҳалла номи",
          TIME_IN: "Кириш вақти",
          TIME_OUT: "Чиқиш вақти",
          DURATION_IN_TIME: "Ҳудудда бўлиш давомийлиги",
          MILAGE_KM: "Босиб ўтилган масофа (км)",
          STOPS_COUNT: "Тўхташлар сони",
        },

        CHOOSE_COMPANY_TITLE:
          "Ташриф графиги таҳлилини кўриш учун, корхона ва санани танланг",
      },
    },
    MANAGEMENT: {
      TABLE_HEADERS: {
        NUMBERS: "№",
        ID: "ID",
        NAME: "Номи",
        COMPANY: "Корхоналар",
        DATE1: "03.2023",
        DATE2: "04.2023",
        DATE3: "05.2023",
        DATE4: "06.2023",
        DATE5: "07.2023",
        DATE6: "08.2023",
        DATE7: "09.2023",
        ACTION: "Ҳаракат",
      },
      USER_ROLE: {
        TABLE_HEADERS: {
          ID: "ID",
          PREFIX: "Рол префикси",
          NAME: "Рол номи",
          LEVEL: "Даражаси",
          USERS_COUNT: "Фойдаланувчилар сони",
          TYPE: "Типи",
          COMMENT: "Изоҳ",
          COMMENT_UZ: "Изоҳ (UZ)",
          COMMENT_CRL: "Изоҳ (CRYL)",
          COMMENT_RU: "Изоҳ (RU)",
        },
        FILTER: {
          FILTER_BUTTON: "Мавжуд ҳаракатлар",
          TITLE: "Рухсат этилган ҳаракатлар",
        },
        INSERT_MODAL: "Янги рол қўшиш",
        UPDATE_MODAL: "Ролни таҳрирлаш",
        DELETE_MODAL: {
          TITLE: "Ролни ўчириш",
          TEXT: "Сиз ҳақиқатан ҳам танланган ролни тизимдан олиб ташламоқчимисиз?",
        },
        TOAST_EXISTS_ROLENAME:
          'Бу "Рол номи" тизимда мавжуд.\nИлтимос бошқа ном киритинг!',
      },
      USERS: {
        ROLE: "Рол",
        ADD_MODAL_TITLE: "Фойдаланувчи қўшиш",
        EDIT_MODAL_TITLE: "Фойдаланувчи маълумотларини таҳрирлаш",
        EDIT_USER: "Маълумотларини таҳрирлаш",
        UPDATE_STATUS_MODAL_TITLE: "Фойдаланувчи статуси",
        UPDATE_PASS_MODAL_TITLE: "Фойдаланувчи паролини ўзгартириш",
        UPDATE_STATUS: "Статусни ўзгартириш",
        UPDATE_PASS: "Паролини ўзгартириш",
        ACTIVE: "Фаол",
        IN_ACTIVE: "Фаол эмас",
        TOAST_EXISTS_LOGIN:
          'Бу "Логин" номи тизимда мавжуд.\nИлтимос бошқа ном киритинг!',
        RESPUBLIC: "Республика",
      },
      COMPANY_GROUP_ADMIN: {
        DELETE_ADMIN_TEXT:
          'Сиз ҳақиқатан ҳам танланган "Корхона гуруҳи директори"ни тизимдан олиб ташламоқчимисиз?',
        DETACH_COMPANY_TEXT:
          'Сиз ҳақиқатан ҳам танланган корхонани "Корхона гуруҳи директори"дан олиб ташламоқчимисиз?',
        GPS_ADMIN: "GPS админи сифатида яратиш",
      },
      COMPANY_OPERATIONS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Номи",
          T_PERIOD: "Техник. давр",
          ADDRESS: "Манзил",
          PHONE: "Телефон",
          TASK: "Вазифалар",
          START_DATE: "Бошланиш санаси",
          END_DATE: "Тугаш санаси",
          STATUS: "Ҳолат",
          RESULT: "Натижа",
          KOD: "Код",
          ACTION: "Ҳаракат",
        },
        SELECT: {
          REGION: "Вилоятни танланг",
          DISTRICT: "Туманни танланг",
          YEAR: "Йил",
          MONTH: "Ой",
        },
        MODAL: {
          TITLE: "Жорий ойни қайта ҳисоблаш",
          TEXT: "Сиз ҳақиқатан ҳам бир вақтнинг ўзида қайта ҳисоблашни ва кейин ушбу Корхонани янги даврга ўтказишни хоҳлайсизми?",
          SAVE: "Ҳа бажаринг",
        },
      },
      COMPANY_SETTINGS: {
        TITLES: {
          HYBRID_SETTINGS: "Гибрид почта созламалари",
          PERMISSION_SETTINGS: "Рухсат созламалари",
          MENU_RESTRICTIONS: "Меню чекловлари",
        },
      },
      ACT_PERMISSION_BY_COMPANIES: {
        TABLE_HEADERS: {
          ID: "ID",
          REGION_NAME: "Вилоят номи",
          COMPANY_NAME: "Корхона номи",
          CREATED_AT: "Яратилган сана",
          ENDED_AT: "Вақтдан олдин тугаш санаси",
          FROM_DATE: "Бошланиш санаси",
          TO_DATE: "Тугаш санаси",
          FILE_PATH: "Бириктрилган файл",
          CREATED_BY: "Яратган фойдаланувчи",
        },
        MODALS: {
          ADD_TITLE: "Корхона учун актларни бошқаришни фаоллаштириш",
          FROM_DATE: "Бошланиш санаси:",
          TO_DATE: "Тугаш санаси:",
          FILE_PATH: "Бириктрилган файл:",
          WANT_BLOCK: "Бу корхонани блоклашни хохлайсизми?",
          WANT_UNBLOCK: "Ушбу корхонани фаоллаштиришни хоҳлайсизми?",
        },
      },
      WORK_1031_PERMISSION_BY_ORGANIZATION: {
        MODALS: {
          ADD_TITLE: "Корхоналар учун 1031ни бошқаришни фаоллаштириш",
        },
      },
      PAYMENTS_PERMISSION_BY_ORGANIZATION: {
        MODALS: {
          ADD_TITLE: "Корхоналар учун тўловлар бошқаришни фаоллаштириш",
        },
      },

      BLOCKED_USERS: {
        TABLE_HEADERS: {
          ID: "ID",
          USER_NAME: "Фойдаланувчи номи",
          ROLE_NAME: "Рол номи",
          IPADDRESS: "IP манзил",
          UN_SUCCESS_FULATTEMPTS_COUNT: "Муваффақиятсиз уринишлар сони",
          BLOCKED_AT: "Блокланган сана",
          BLOCKED_UNTIL: "Блокланиш тугаш санаси",
          CURRENTLY_BLOCKED: "Блок ҳолати",
          UNBLOCK: "Блокдан чиқариш",
          BLOCKED: "Блокланган",
          UNBLOCKED: "Блокдан чиқарилган",
        },
      },
      SYSTEM_CONFIGURATIONS: {
        COURT_WARNING: "Тизим созламалари",
        COURT_WARNING_PUT: "Суд огоҳлантириш созламаларини янгилаш",
        COURT_WARNING_TO_COURT_PROCESS_DAY_INTERVAL:
          "Суд жараёни куни оралиғи(ой)",
        COURT_WARNING_VALIDATION_MONTH_INTERVAL:
          "Такрорий суд огоҳлантириш яратиши мумкин бўлган минимал оралиқ (ой)",
        COURT_WARNING_DEBT_PARTIAL_COVERAGE_PERCENTAGE:
          "Қарздорлик қисман қопланганлик фоизи",
        QQS_PERCENTAGE: "ҚҚС фоизи",
        QSS_STARTS_AT: "ҚҚС ҳисоблаш бошланган сана",
        MINIMUM_CHYM_TIME_IN_MINUTES:
          "ЧЙМ га ташриф бўлди деб ҳисоблаш учун минимал ҳудудда бўлиш дақиқаси",
        MINIMUM_MAHALLA_SERVICE_ABILITY_INDEX:
          "Махаллага ташрифни инобатга олиш учун минимал хизмат кўрсатиш индекси",
        STATE_DUTY_AMOUNT: "Суд огоҳлантириши учун давлат божи",
        POST_FREE_AMOUNT: "Суд огоҳлантириши учун почта харажатлари",
        PUBLIC_FILE_DOWNLOAD_URL_PREFIX: "QR cоде орқали файл юклаб олиш URLи",
        MAX_COURT_WARNING_CREATE_LIMIT:
          "Суд огоҳлантиришининг максимал яратилиш чегараси",
        WASTE_COLLECTION_AREA_RADIUS: "Чиқинди йиғиш ҳудуди радиуси",
        AFFECT_CHYM_VISIT_TO_BALANCE:
          "CHYM га ташрифлар асосида начисления ҳисоблаш",
        AFFECT_MAHALLA_VISIT_TO_BALANCE:
          "Маҳаллага ташрифлар асосида начисления ҳисоблаш",
        GPS_WEIGHT_DURATION: "Харакатда бўлиш давомийлигининг аҳамияти",
        GPS_WEIGHT_MILEAGE: "Босиб ўтилган масофанинг аҳамияти",
        GPS_WEIGHT_STOPS: "Тўхташлар сонининг аҳамияти",
        GPS_WEIGHT_SPEED: "Ўртача тезликнинг аҳамияти",
        CHANGE_VALUE:
          "Маҳаллага ташриф параметрлари аҳамиятини умумий созламалардан олмасдан individual белгилаш",
        LAST_MIA_SYNC_MONTH:
          "ИИБ билан охирги муваффақиятли синхронизация қилинган ой",
        RESIDENT_CRON_OPEN_HOUR: "Абонентлар учун крон очилиш вақти (соат)",
        RESIDENT_CRON_CLOSE_HOUR: "Абонентлар учун крон ёпилиш вақти (соат)",
      },
    },
    SMS_GATEWAY: {
      TABLE_HEADERS: {
        PHONE_NUMBER: "Телефон рақами",
        SENDING_DATE: "Юборилган сана",
        SENDING_TIME: "Етказиб берилган вақти",
        PROVIDER_TYPE: "Хизмат тури",
        MESSAGE_TEXT: "Хабар матни",
        SEND_SMS: "Жўнатилган СМС",
        ACTION: "Ҳаракатлар",
        COMPANY_NAME: "Корхона номи",
        TIME: "Вақт",
      },
      SEND: "Юборилган",
      DELIVERED: "Етказилган",
      TRANSFERRED: "Узатилган",
      NOT_DELIVERED: "Етказилмаган",
      REJECTED: "Рад этилган",
      UNSUCCESSFUL: "Муваффақиятсиз",
      EXPIRED: "Муддати тугаган",
      COMPANY_NAME: "Корхона номи",
      MODAL_TITLE: "Хабар матни",
      NOT_TEMPLATE: "Шаблонга мос емас",
      NO_CONTRACT: "Шартнома мавжуд емас",
      AUTHFAILED: "Авторизация хатоси",
      WARNED: "Огоҳлантирилган",
    },

    DXSH: {
      DXSH_COMAPANIES: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Nomi",
          INN: "INN",
          ADDRESS: "Manzil",
          PHONE: "Telefon",
          EMAIL: "Elektron pochta",
          DIRECTOR_FIO: "Direktor F.I.Sh",
          LEGAL_ACCOUNT_NUMBER: "Yuridik shaxs hisob raqami",
        },
      },
      INVESTITION_CATEGORIES: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Номи",
          DESCRIPTION: "Изоҳ",
        },
        NAMES: {
          SPECIAL_EQUIPMENT: "Махсус техника",
          CONTAINER: "Контейнер",
          SORTING_EQUIPMENT: "Саралаш ускунаси",
          PROCESSING_EQUIPMENT: "Қайта ишлаш ускунаси",
          REBOOT_STATION: "Қайта юклаш стансияси",
          WASTE_COLLECTION_TANK: "Чиқинди тўплаш шахобчаси",
          CONSTRUCTION_OF_BUILDINGS: "Бино иншоотлар қурилиши",
          JOB_VACANCY: "Иш ўринлари",
          OTHER: "Бошқалар",
        },
        MODALS: {
          NAME_UZ: "Номи (UZ)",
          NAME_RU: "Номи (RU)",
          NAME_CRL: "Номи (CRL)",
          ADD_MODAL_TITLE: "Инвестициявий категория қўшиш",
          EDIT_MODAL_TITLE: "Инвестициявий категорияни таҳрирлаш",
          DELETE_MODAL_TITLE: "Инвестициявий категорияни ўчириш",
          DELETE_MESSAGE:
            "Сиз ҳақиқатан ҳам танланган Инвестициявий категорияни тизимдан олиб ташламоқчимисиз?",
        },
      },
      DXSH_INVESTMENT: {
        TABLE_HEADERS: {
          ID: "ID",
          INVOICE_NUMBER: "Ҳисоб-фактура рақами",
          INVOICE_PURPOSE: "Ҳисоб-фактура мақсади",
          INVOICE_DATE: "Санаси",
          INVESTMENT_CATEGORY_ID: "Инвестиция тури",
          INVESTMENT_CATEGORY_NAME: "Инвестиция категорияси",
          QUANTITY: "Сони",
          AMOUNT: "Суммаси",
          FILE: "Буғгалтерия ҳисоботи",
        },
        MODALS: {
          INVOICE_NUMBER: "Ҳисоб-фактура рақами:",
          INVOICE_PURPOSE: "Ҳисоб-фактура мақсади:",
          INVOICE_DATE: "Санаси:",
          INVESTMENT_CATEGORY: "Инвестиция тури:",
          NAME: "Номи:",
          QUANTITY: "Сони:",
          AMOUNT: "Суммаси:",
          FILE: "Асословчи файл:",
          VEHICLE_NUMBER: "Транспорт рақами:",
          TEX_PASSPORT_SERIES: "Тех. паспорт серияси:",
          TEX_PASSPORT_NUMBER: "Тех. паспорт рақами:",
          PURCHASE_AMOUNT: "Харид қилинган сумма:",
          GET_CAR_INFO: "Транспорт маълумотларини олиш",
          DELETE_CAR_INFO: "Транспорт маълумотларини ўчириш",
          ADD_NEW_TRANSPORT: "Янги транспорт қўшиш",
          ADD_MODAL_TITLE: "Шартнома бажарилганлик факти қўшиш",
          EDIT_MODAL_TITLE: "Шартнома бажарилганлик фактини таҳрирлаш",
          DELETE_MODAL_TITLE: "Шартнома бажарилганлик фактини ўчириш",
          DELETE_MESSAGE:
            "Сиз ҳақиқатан ҳам танланган шартнома бажарилганлик фактини тизимдан олиб ташламоқчимисиз?",
          CAR_NUMBER: "Avtomobil рақами:",
          CAR_DOCUMENT: "Автомобил ҳужжати:",
          CAR_DOCUMENT_FILE: "Автомобил ҳужжати файли:",
          CAR_INFO_CONFIRMATION_TITLE: "Автомобил маълумотлари тасдиқлаш",
        },
        CONFIRM_CAR_INFO: {
          TITLE: "Автомобил маълумотларини тасдиқлаш",
          CONFIRM: "Тасдиқлаш",
          CANCEL: "Бекор қилиш",
          CAR_YEAR: "Автомобил йили",
          CAR_MODEL: "Автомобил модели",
          CAR_NUMBER: "Автомобил рақами",
          CAR_COLOR: "Автомобил ранги",
          CAR_REGISTRATION_DATE: "Автомобил рўйхатга олинган сана",
          CAR_DOCUMENT_SERIES_NUMBER: "Автомобил ҳужжати серия ва рақами",
        },
        ERRORS: {
          INVESTMENT_CATEGORY_NOT_FOUND:
            "Бу шартномада танланган категория бўйича маълумот топилмади",
        },
      },
      INVESTITION_INFO: {
        TABLE_HEADERS: {
          ID: "ID",
          COMPANY_NAME: "Корхона номи",
          COMPANY_INN: "Корхона ИНН",
          CONTRACTS: "Шартномалар",
          CONTRACT_INFO: "Шартнома маълумотлари",
          CONTRACT_NUMBER: "Шартнома рақами",
          NUMBER: "Рақами",
          CONTRACT_DATE: "Шартнома санаси",
          DATE: "Санаси",
          CONTRACT_AMOUNT: "Шартнома суммаси",
          CATEGORIES: "Инвестиция категориялари",
          CATEGORY_NAME: "Категория номи",
          QUANTITY: "Сони",
          AMOUNT: "Суммаси",
          EMPLOYEES_COUNT: "Ходимлар сони",
          POSITIONS_COUNT: "Бош иш ўринлари сони",
        },
        MODALS: {
          COMPANY_NAME: "Корхона номи:",
          CONTRACT_NUMBER: "Шартнома рақами:",
          CONTRACT_DATE: "Шартнома санаси:",
          CONTRACT_AMOUNT: "Шартнома суммаси:",
          INVESTITION_AMOUNT: "Инвестиция суммаси:",
          CATEGORY_NAME: "Категория номи:",
          QUANTITY: "Сони:",
          AMOUNT: "Суммаси:",
          COMPANY_NOT_FOUNT: "ДХШ асосидаги корхона топилмади",
          ADD_MODAL_TITLE: "Янги шартнома қўшиш",
          EDIT_MODAL_TITLE: "Шартномани таҳрирлаш",
          DELETE_MODAL_TITLE: "Шартномани ўчириш",
          DELETE_MESSAGE:
            "Сиз ҳақиқатан ҳам танланган Шартномани тизимдан олиб ташламоқчимисиз?",
          POPULATION_USERS_COUNT: "Хизмат кўрсатётиладиган аҳоли сони:",
        },
      },
      DXSH_REPORT: {
        DATE: "Сана",
        TABLE_HEADERS: {
          ID: "№",
          REGIONS: "Вилоятлар",
          ATTACHED_DISTRICS: "Бириктирилган туман (шаҳарлар)",
          PRIVATE_PARTNER: "Хусусий шерик",
          DXSH_AGREEMENT: "ДХШ битими",
          CONTRACT_AMOUNT: "Жами киритиладиган инвестиция миқдори",
          TOTAL_AMOUNT: "ҳолатига инвестиция миқдори",
          TOTAL_INVESMENT_AMOUNT: "Жами киритилган инвестиция миқори",
          COMPLECTED_IN_PERCENT: "Бажарилиши (фоиз)",
          CATEGORY_COUNT: "Режа (сони)",
          CATEGORY_SUMMA: "Суммаси",
          CATEGORY_PRACTIC_COUNT: "Амалда (сони)",
          CONTRACT_DATE: "Шартнома санаси",
          CONTRACT_NUMBER: "Шартнома рақами",
          TOTAL: "Жами:",
        },
        MODAL: {
          EXCEL_TITLE: "Инвестициялар ҳисоботи {{date}}",
        },
      },
      STATISTICS: {
        INCOME_BY_REGION: {
          TITLE: "Вилоятлар бўйича инвестиция суммалари",
        },
        INFO_CARD: {
          TITLE: "Маълумотлар",
          TOTAL_AMOUNT: "Режадаги сумма",
          CURRENT_AMOUNT: "Жорий сумма",
          CONTRACT_NUMBER: "Шартнома рақами",
          PROTSENT: "Фоиз",
          COMPANIES_COUNT: "Корхоналар сони",
          CONTRACTS_COUNT: "Шартномалар сони",
          CATEGORIES_COUNT: "Категориялар сони",
        },
        COMPANIES_CHART: {
          TITLE: "Корхоналар тузган шартнома инвестиция суммалари",
        },
        CONTRACTS_CHART: {
          TITLE: "Шартномалар режадаги  ва ҳозирги инвестиция суммалари",
        },
        CATEGORIES_CHART: {
          TITLE: "Категориялар режадаги ва ҳозирги инвестиция суммалари",
        },
      },
      FACT_OF_NEW_WORK_POSOTIONS: {
        TABLE_HEADERS: {
          ID: "ID",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Янги иш ўрин яратилганлик факти қўшиш",
        },
      },
    },
    BANK_OPERATIONS: {
      COMPANY_INN: "Корхона ИНН",
      COMPANY_BANK_MFO: "Корхона банк МФО cи",
      COMPANY_TRANZIT_ACCOUNT: "Корхона транзит ҳисоб рақами",
      CORRESPONDENT_ACCOUNT: "Корреспондент ҳисоб рақами",
      CORRESPONDENT_NAME: "Корреспондент номи",
      CORRESPONDENT_BANK_MFO: "Корреспондент банк МФО cи",
      PAYMENT_PURPOSE: "Тўлов мақсади",
      DEBIT: "Кирим",
      CREDIT: "Чиқим",
      OPENING_BALANCE: "Давр бошига қолдиқ",
      CLOSING_BALANCE: "Давр охирига қолдиқ",
      LAST_UPDATE: "Охирги янгиланиш вақти",
    },
    BANK_BILLING_COMPARISON: {
      LAST_PERIOD_DIFFERENCE: "Давр бошидаги қолдиқ",
      BILLING_AMOUNT: "Биллинг тизимидаги тушум",
      PARTNER_STAFF: "Тўлов ҳамкори фоиз улуши",
      BILLING_AMOUNT_PARTNER_STAFF:
        "Тўлов ҳамкорлари ўтказиши керак бўлган сумма",
      BANK_AMOUNT:
        "Жорий давр давомида тўлов ҳамкорларидан келиб тушган сумма (банк маълумоти)",
      DIFFERENCE: "Давр охиридаги қолдиқ",
    },
    COMPANY: {
      TABLE_HEADERS: {
        NUMBERS: "№",
        TRANSIT_ACC_MFO: "Транзит ҳисоб рақами (МФО)",
        ID: "ID",
        NAME: "Номи",
        TYPE: "Тури",
        REGION: "Туман",
        REGIONS: "Вилоят",
        TURNOVER: "Банк МФО",
        COMPANY_ACCOUNT: "Корхона ҳисоб рақами",
        TRANSIT_NUMBER: "Транзит ҳисоб рақам",
        TREASURY_ACC_NUMBER: "Корхона ғазна хисоб рақами",
        LEGAL_ACCOUNT: "Юридиклар учун ҳисоб рақами",
        TRANZIT_ACCOUNT: "Транзитлар учун ҳисоб рақами",
        INN: "ИНН",
        CONTRACT_NUMBER: "Рақами",
        CONTRACT_START_DATE: "Бошланиш санаси",
        CONTRACT_END_DATE: "Тугаш санаси",
        CONTRACT_LEFT_DATE: "Шартнома тугаш муддати (кун)",
        CONTRACT_FILE: "Шартнома файли",
        COMMENT: "Изоҳ",
        STATUS: "Ҳолат",
        TYPE_COMPANY: "Корхона тури",
        EMAIL: "Электрон почта",
        ADDRESS: "Манзил",
        DIRECTOR_FIO: "Директор Ф.И.Ш",
        BANK_NAME: "Банк номи",
        PHONE_NUMBER: "Телефон рақами",
        CONTRACT_CREATED_AT: "Яратилган сана",
        CONTRACT_CREATED_BY_NAME: "Бириктирган фойдаланувчи",
      },
      MODAL: {
        SEND_SMS: "СМС жўнатиш",
        ADD_TITLE: "Корхона қўшиш",
        EDIT_TITLE: "Корхонани таҳрирлаш",
        DELETE_TITLE: "Танланган Корхонани ўчириш",
        EDIT_CONTRACT_TITLE: "Корхона шартномасини таҳрирлаш",
        DELETE_TEXT:
          "Сиз ҳақиқатан ҳам Корхонани тизимдан олиб ташламоқчимисиз?",
        INPUT_MODAL_TEXT: "Корхона номи: ",
        SEND_SMS_DEBIT_RESIDENT_CONFIRMATION_TEXT:
          "Сиз ҳақиқатдан ҳам ушбу абонентга СМС жўнатишни тасдиқламоқчимисиз?",
        SEND_SMS_DEBIT_RESIDENTS_CONFIRMATION_TEXT:
          "Сиз ҳақиқатан ҳам қарздор абонентларга СМС жўнатишни тасдиқламоқчимисиз!",
        BLOCK_CONFIRMED_MAHALLA_TITLE: "Огоҳлантирилганларни блоклаш",
        BLOCK_CONFIRMED_MAHALLA_SUB_TITLE:
          "Сиз ҳақиқатдан ҳам огоҳлантирилган абонентларни блокламоқчимисиз?",
        AUTO_LIST_CONFIRMED_MAHALLA_TITLE: "Рўйҳат шакилланиришни",
        AUTO_LIST_CONFIRMED_MAHALLA_SUB_TITLE:
          "Сиз ҳақиқатдан ҳам танланган маҳаллалар учун рўйҳат шакиллантимоқчимисиз?",
        REMOVE_FROM_AUTO_LIST_TITLE: "Рўйхатдан олиб ташлаш",
        REMOVE_FROM_AUTO_LIST_SUB_TITLE:
          "Сиз ҳақиқатдан ҳам танланган маҳаллаларни рўйхатдан олиб ташламоқчимисиз?",
      },
      NUMBER_OF_RESIDENTS_SELECTED: "Танланган абонентлар сони: ",
      LIMITED: "Жўнатиш мумкин бўлган СМС миқдори:",
      RESIDENTS_WITH_BALANCE_FROM_BALANCE_TO:
        "Баланси {{ from }} дан {{ to }} гача бўлган қарздор абонентлар",
      LIMITED_SMS: "СМС лимити",
      NAME_FOR_SMS: "СМС учун корхона номи",
      DXSH_PERCENTAGE: "ДХШ фоизи",
    },
    EMPLOYEES: {
      TABLE_HEADERS: {
        NUMBERS: "№",
        ID: "ID",
        FIRST_NAME: "Исм",
        LAST_NAME: "Фамилия",
        PATRONYMIC: "Отасининг исми",
        EMAIL: "Электрон почта",
        PHONE_NUMBER: "Телефон рақами",
        ADDRESS: "Манзил",
        COMMENT: "Изоҳ",
        LOGIN: "Логин",
        STATUS: "Ҳолат",
        ATTACHED_FILE: "Бириктирилган файллар",
        TABEL_NUMBER: "Табел рақами",
        LAST_OPERATION_DATE: "Сўнги амалиёт вақти ",
      },
      MODAL: {
        ADD_TITLE: "Янги ходим қўшиш",
        EDIT_TITLE: "Ходимни таҳрирлаш",
        DELETE_TITLE: "Танланган ходимни ўчириш",
        DELETE_TEXT:
          "Сиз ҳақиқатан ҳам танланган ходимни тизимдан олиб ташламоқчимисиз?",
        TOAST_SELECT_ROW: "Илтимос, қаторни тангланг!",
        EMPLOYEE_INFO: "Ходим маълумотлари",
        FIRST_NAME: "Исм:",
        LAST_NAME: "Фамилия:",
        PATRONYMIC: "Отасининг исми:",
        EMAIL: "Электрон почта:",
        PHONE_NUMBER: "Телефон рақами:",
        ADDRESS: "Манзил:",
        COMMENT: "Изоҳ:",
        ROLES: "Роллар:",
        POSITIONS: "Лавозими:",
        PHOTO: "Ходим суратини юклаш",
        CHANGE_PASSWORD: "Паролни ўзгартириш",
        PASSWORD: "Парол",
      },
    },
    TOOLS: {
      RESIDENTS: {
        TABLE_HEADERS: {
          ID: "ID",
          FISH: "Ф.И.Ш",
          FOREIGN_CITIZEN: "Чет эл фуқароси",
          CITIZENSHIP: "Фуқаролиги",
          CITIZEN_OF_UZBEKISTAN: "Ўзбекистон фуқароси",
          LITSEVOY: "Ҳисоб рақам",
          ETK_NUMBER: "ЭТК ҳисоб рақам",
          ETK_SOATO: "ЭТК СОАТО",
          COMPANY_NAME: "Корхона номи",
          REGION: "Ҳудуд",
          VILLAGES: "Маҳалла",
          STREET: "Кўча",
          ACTION: "Ҳаракат",
          CADASTRAL_NUMBER: "Кадастр рақами",
          TEMPORARY_CADASTRAL_NUMBER: "Нотурар кадастр рақами",
          HOME_NUMBER: "Уй рақами",
          HOUSE_TYPE: "Уй тури",
          CONTRACT_NUMBER: "Шартнома рақами",
          CONTRACT_DATE: "Шартнома санаси",
          ELECTRICITY_COATO: "Электр тармоқ СОАТО",
          ELECTRICITY_ACCOUNT_NUMBER: "Электр тармоқ ҳисоб рақами",
          PHONE: "Телефон",
          HOME_PHONE: "Уй телефони",
          RESIDENT_TYPE: "Абонент тури",
          OLD_ACCOUNT_NUMBER: "Эски ҳисоб рақами",
          ACCOUNT_NUMBER: "Ҳисоб рақами",
          PNFL: "ЖШШИР",
          PASSPORT_EXPIRE_DATE: "Паспорт амал қилиш муддати",
          PASSPORT_NUMBER: "Паспорт рақами",
          PASSPORT_ISSUE_DATE: "Паспорт берилган сана",
          PASSPORT: "Паспорт",
          PASSPORT_SERIAL: "Паспорт серияси",
          PASSPORT_GIVEN_DATE: "Паспорт берилган сана",
          BIRTH_DATE: "Туғилган сана",
          TYPE: "Тури",
          PASSPORT_GIVEN_BY: "Паспорт ким томонидан берилган",
          RESIDENTS: "Aбонентлар",
          APPARTMENT: "Хонадон",
          ALL_PAYMENTS: "Барча тўловлар",
          N_SALDO: "Салдо боши",
          N_SALDO_DEBIT: "Салдо боши қарздорлик",
          N_SALDO_KREDIT: "Салдо боши хақдорлик",
          K_SALDO: "Салдо охири",
          QQS: "ҚҚС",
          K_SALDO_DEBIT: "Салдо охири қарздорлик",
          K_SALDO_KREDIT: "Салдо охири хақдорлик",
          HOME_TYPE: "Хонадон тури",
          HOME: "Уй",
          HOME_INDEX: "Уй индекси",
          FLAT: "Кв",
          NUMBER_OF_OWNERS: "Мулкдорлар сони",
          OWNERS: "Мулкдорлар",
          LAST_PAYMENT_DATE: "Охирги тўлов cанаси",
          LAST_PAYMENT_AMOUNT: "Охирги тўлов суммаси",
          LAST_PAYMENT_TYPE: "Охирги тўлов тури",
        },
        RESIDENT_INFO: {
          PERIOD: "Давр",
          INHABITANT_COUNT: "Яшовчилар ўзгариш тарихи",
          N_SALDO: "Салдо боши",
          ACCRUAL: "Ҳисобланди",
          ADDITIONAL_ACCRUAL: "Ҳисобланди (Кўш.хизмат)",
          ACT: "Акт",
          CHANGE_PHONE_NUMBER: "Телефон рақамини ўзгартириш",
          NACHISLENIA_TYPE: "Начисления тури",
          DEFAULT: "Одатий",
          CHYM_BASED: "ЧЙМ ташриф",
          MAHALLA_BASED: "Маҳалла ташриф",
          IIB_BASED: "ИИБ яшовчилари асосида",

          CONNECTED_RESIDENT: "Боғланган абонент",

          ACT_AMOUNT: "Акт суммаси",
          LAST_PAY_DATE: "Охирги тўлов куни",
          LAST_PAY_AMOUNT: "Охирги тўлов суммаси",
          FROZEN_N_SALDO: "Музлатилган қарздорлик салдо боши",
          FROZEN_K_SALDO: "Музлатилган қарздорлик салдо охири",
          FROZEN_ACT_AMOUNT: "Музлатилган акт суммаси",
          INDEX: "Индекс",
          HOME_LETTER: "Уй ҳарфи",
          FLAT_NUMBER: "Квартира рақами",

          CHASH_AMOUNT: "Нақд тушум",
          EL_AMOUNT: "Эл.тушумлар",
          MUNIS_AMOUNT: "Мунис",
          Q_1031_AMOUNT: "МИБ ва 1031 тушумлари",
          K_SALDO: "Салдо охири",
          PENALTY_FEE: "Пеня",
          ENTITLEMENT: "Хакдорлик",
          SURCHARGE: "Доплата",
          FRONZEN_DEBT: "Музлатилган қарздорлик",
          FROZEN_REVENUE: "Тушум",
          DEBT_ACT: "Қарздорлик акти",
          FROZEN_DEBT_SETTLEMENT: "Қарздорликни сўндириш акти",
          RESIDENT_REFERENCE_CONFIRMATION_TEXT_PREFIX:
            "МАИШИЙ ЧИКИНДИ УЧУН ТЎЛОВЛАРДАН",
          RESIDENT_REFERENCE_CONFIRMATION_TEXT_MIDDLE: "",
          RESIDENT_REFERENCE_CONFIRMATION_TEXT_BY_YEAR: "ЙИЛ «01»",
          RESIDENT_REFERENCE_CONFIRMATION_TEXT_SUFIX:
            "КУНИГА КАРЗДОРЛИГИ МАВЖУД ЭМАС. МАЪЛУМОТНОМА СЎРАЛГАН ЖОЙГА ТАКДИМ ЭТИШ УЧУН БЕРИЛДИ",
          RESIDENT_REFERENCE_ACCOUNT_NUMBER: "Ҳисоб рақам",
          RESIDENT_REFERENCE_FIO: "Абонент Ф.И.Ш",
          RESIDENT_REFERENCE_MAHALLA: "Маҳалла",
          RESIDENT_REFERENCE_ADDRESS: "Манзил",
          RESIDENT_REFERENCE_INHB: "Яшовчилар сони",
          RESIDENT_REFERENCE_PHONE: "Телефон",
          RESIDENT_REFERENCE_COMPANY_DIRECTOR: "МЧЖ РАХБАРИ",
          RESIDENT_REFERENCE_COMPANY_COMPANY: "Ташкилот",
          RESIDENT_REFERENCE_COMPANY_BANK_NAME: "Банк номи",
          RESIDENT_REFERENCE_COMPANY_INN: "ИНН",
          RESIDENT_REFERENCE_COMPANY_BANK_REK: "Банк реквизити",
          CHECKING_DATA_FROM_THE_HET_DATABASE:
            "ҲЭТ базасидан маълумотларни текшириш",
          CHANGE_HET_ACCOUNT_NUMBER: "ҲЭТ ҳисоб рақамини ўзгартириш",

          NOT_IDENTIFIED_RESIDENTS:
            "Абонентни идентификацияланмаган сифатида белгилаш",
          IDENTIFIED_RESIDENTS:
            "Абонентни идентификацияланган сифатида белгилаш",
          IDENTIFIED_RESIDENTS_TEXT:
            "Сиз ҳақиқатдан ҳам ушбу амални амалга оширишни хоҳлайсизми?",
          IDENTIFIED: "Идентификацияланган",
          IDENTIFIED_DATE: "Идентификацияланган сана",
          NOT_IDENTIFIED: "Идентификацияланмаган",
          CRITERIES: {
            TITLE: "Идентификация критерийлари",
            MAIN_TITLE: "Абонентни идентификация қилиш учун критерийлар",
            PASSPORT: {
              TITLE: "Паспорт:",
              PINFL_INFO1:
                "ПИНФЛ тўлдирилган бўлиши, 14 та белгидан иборат бўлиши, шунингдек ПИНФЛнинг 2-ва 7-рақамлари оралиғида туғилган сана тўғри жойлашиши керак;",
              PINFL_INFO2:
                "Паспорт серияси ва рақами тўлдирилган бўлиши, серия 2 та лотин ҳарфидан, паспорт рақами 7 та белгидан иборат бўлиши керак;",
            },
            CADASTRAL: {
              TITLE: "Кадастр:",
              CADASTRAL_INFO1:
                "Кадастр рақами тўлдирилган бўлиши, узунлиги камида 15 та белгидан иборат бўлиши ва камида 4 та иккитали нуқта иштирок этиши керак;",
              CADASTRAL_INFO2: "Кадастр коди ҳудуд кодига мос бўлиши лозим;",
              CADASTRAL_INFO3: "Кадастр рақами дубликат бўлмаслиги керак;",
            },
            HET: {
              TITLE: "ҲЭТ:",
              HET_INFO1:
                "COATO ва ҳисоб рақам киритилган бўлиши, COATO 5 та белгидан иборат бўлиши ва туманга мос бўлиши керак;",
              HET_INFO2: "Ҳисоб рақам тизимга киритилган бўлиши керак;",
              HET_INFO3:
                "Тизимдаги электр ҳисоб рақам ҲЭТдаги билан мос келиши керак (интеграция орқали текширилади);",
              HET_INFO4:
                "COATO ва ҳисоб рақам такрорланмаслиги керак (суб абонентлар бундан мустасно);",
            },
            PERSONAL_IMAGE: {
              TITLE: "Шахсий расм:",
              PERSONAL_IMAGE_INFO1: "Шахсий расм бўлиши керак;",
              PERSONAL_IMAGE_INFO2:
                "Расм файли номида фуқаронинг ПИНФЛ ва паспорт рақами бўлиши лозим;",
            },
          },

          TABLE_HEADERS: {
            ID: "ID",
            PERIOD: "Давр",
            KVIT_DATE: "Квит санаси",
            KVIT_NO: "Квит. №",
            SUM: "Сумма",
            PAYER_FIO: "Тўловчи Ф.И.Ш",
            PAYMENT_INFO: "Тўлов маълумотлари",
            EMPLOYEE_INFO: "Ходим Ф.И.Ш",
            PACHKA_ID: "Id пачка",
            DATE: "Сана",
          },

          HET_INTEGRATION: {
            TABLE_HEADERS: {
              COATO_CODE: "CОАТО коди",
              ELECTRICITY_ACCOUNT_NUMBER: "Электр тармоқ ҳисоб рақами",
              FULL_NAME: "Ф.И.Ш",
              ADDRESS: "Манзил",
              MAHALLA: "Маҳалла",
              PHONE: "Телефон",
              PINFL: "ЖШШИР",
              PASSPORT: "Паспорт",
              INN: "ИНН",
              CADASTRAL_NUMBER: "Кадастр рақами",
            },
          },
        },

        MODAL: {
          ADD_TITLE: "Абонент қўшиш",
          EDIT_TITLE: "Абонентни таҳрирлаш",
          DELETE_TITLE: "Танланган абонентни ўчириш",
          DELETE_TEXT:
            "Сиз ҳақиқатан ҳам танланган абонентни тизимдан олиб ташламоқчимисиз?",
          DELETE_MULTIPLE_TITLE: "Танланган абонентларни ўчириш",
          DELETE_MULTIPLE_TEXT:
            "Сиз ҳақиқатан ҳам танланган абонентларни тизимдан олиб ташламоқчимисиз?",
          TITLE_SEARCH: "Қидириш",
          BUTTONS: {
            EXIT: "Чиқиш",
            ADD: "Cақлаш",
            NEXT: "Кейинги",
            BACK: "Ортга",
          },
          PRINT_CONTRACT: "Шартномани чоп этиш",
          PRINT_ACT: "Далолатномани чоп этиш",
          FILE_ADD: "Файл қўшиш:",
          TYPE: "Тури:",
          IMPORT: "Импорт",
          COUNTRY: "Давлат:",
          REGION: "Вилоят:",
          DISTRICT: "Туман:",
          VILLAGE: "Маҳалла:",
          STREET: "Кўча:",
          HOME_NUMBER: "Уй рақами:",
          FULL_ADDRESS: "Тўлиқ манзил:",
          REGISTER_DATE: "Рўйхатдан ўтиш санаси:",
          PASSPORT_NUMBER: "Паспорт рақами:",
          PNFL: "ЖШШИР:",
          STIR: "СТИР:",
          CADASTRAL_NUMBER: "Кадастр рақамини киритинг:",
          COMPANY: "Корхона:",
          INHABITANT_CNT: "Яшовчилар сони:",
          IMPORT_RESIDENTS: "Абонентлар",
          INN: "ИНН",
          PASSPORT: "Паспорт маълумотлари",
          CADASTR: "Кадастр рақами",
          FISH: "Ф.И.Ш",
          PHONE: "Телефон рақами",
          RESIDENT_CARD: "Aбонент картаси",
          RESIDENT_CARD_PRINT: "Aбонент картасини чоп этиш",
          RESIDENT_REFERENCE_DOC: "Маълумотномани чоп этиш",
          CURRENT_PERIOD: "Жорий давр",
          CURRENT_YEAR: "Жорий йил",
          ALL_PERIOD: "Барча давр",
          CURRENT_RESIDENTS:
            "Ҳозир саҳифада кўрсатилиб турган абонентларни Ехcелга экспорт қилиш",
          ALL_RESIDENTS:
            "Бошқа филтерлар бўйича абонентларни Ехcелга экспорт қилиш",
          NOT_FOUND_PASSPORT_SYSTEM:
            "Паспорт-Виза тизимидан ушбу ЖШШИР бўйича маълумот топилмади!",
          UPDATE_RESIDENT_DATA: "Маълумотларни янгилаш",
          SEARCHING_SAME_RESIDENTS:
            "Ушбу ЖШШИР билан мавжуд бўлган абонентлар қидирилмоқда",
          RESULT_OF_SEARCHED_RESIDENTS:
            " Ушбу ЖШШИР билан мавжуд бўлган абонентлар сони",
          SEE_ALL: "Барчасини кўриш",
          WITH_FROZEN_DEBT: "Музлатилган қарздорлик маълумотлари",
          FROM_MAHALLA: "Қайси маҳалладдан",
          TO_MAHALLA: "Қайси маҳаллага",
          SELECT_RESIDENTS: "Абонентларни танлаш",
          SELECT_MOVEABLE_RESIDENTS: "Кўчириладиган абонентларни танлаш",
          ATTENTION_NODE_1:
            "Абонент кўчирилганда, у олдинги бириктирилган маҳалла ҳудуди ва чиқинди йиғиш майдонидан ажратилади.",
          ATTENTION_NODE_2:
            "Агар олдинги маҳалла музлатилган бўлса, янги маҳаллага кўчирилгандан сўнг ҳам жорий даврда абонент музлатилган ҳолда қолади. Агар янги маҳалла музлатилмаган бўлса — абонент кейинги даврдан бошлаб музлатишдан чиқарилади.",
          ATTENTION_NODE_3:
            "Агар олдинги маҳалла музлатилмаган бўлса ва янги маҳалла музлатилган бўлса — абонент жорий даврда музлатилмаган ҳолда ўтади, аммо кейинги даврдан бошлаб музлатилади.",
        },
        MODAL_SEARCH_BY_IIB: {
          COUNTRY: "Давлат",
          REGION: "Вилоят",
          DISTRICT: "Туман",
          VILLAGE: "Маҳалла",
          STREET: "Кўча",
          FULL_ADDRESS: "Тўлиқ манзил",
          REGISTRATION_DATE: "Рўйхатдан ўтган сана",
          CADASTRE: "Кадастр раками",
          PERMANENT_RESIDENCE: "Доимий яшаш жойи",
          TEMPORARY_RESIDENCE: "Вақтинчалик яшаш жойи",
        },
        MODAL_CHEKING_PERSONS_OF_HOME: {
          WARNING_MESSAGES:
            "Кадастр базасидан маълумотларни олишда хатолик юз берди!",
          MODAL_TITLE: "Хонадонда рўйхатда турувчиларни текшириш",
          WARNING_MESSAGE_MVD: "ИИБ базасидан маълумотлар топилмади!",
          BUTTON: "Излаш",
          RESIDENTS_DETAIL: {
            NAME: "Ф.И.Ш",
            ABONENT_ADDRESS: "Тўлиқ манзил",
            CADASTRAL_NUMBER: "Уй кадастр рақами",
            PASSPORT: "Паспорт рақами",
            PNFL: "ЖШШИР",
            TITLE:
              "Миграция ва фуқароликни расмийлаштириш бош бошқармаси (Passport-Viza tizimi) электрон манзил бўйича доимий ва вақтинча рўйхатга олинганлар",
          },
          PRINT_RESIDENT_TABLE: {
            NAME: "Ф.И.Ш",
            STATUS: "Aбонент ҳолати",
            PNFL: "ЖШШИР",
            REGISTRATION_DATE: "Рўйхатга олинган сана",
            DATE_EXCEPTIONS: "Рўйхатдан чиқарилган сана",
            DATE_BIRTH: "Туғилган сана",
            GENDER: "Жинси",
            MALE: "Эркак",
            FEMALE: "Aёл",
            ACTIVE: "Доимий рўйхатда",
            OTHER_PLEASE_OUT: "Бошқа сабаб билан чиқарилган",
            COURT_OUT: "Суд қарори билан чиқарилган",
            OTHER_OUT: "Чет елда доимий яшашга кўчиб кетган",
            DEATH_OUT: "Ўлим сабаби билан чиқарилган",
            PLEASE_OUT: "Уй эгасини илтимосига биноан чиқарилган",
            TEMPORARILY_REGISTERED: "Вақтинчалик рўйхатда бўлган",
          },
        },
        MODAL_TAB: {
          TAB_1: "Паспорт маълумотлари",
          TAB_2: "Абонент ҳақида маълумот",
        },
        INFORMATION_BASED_ON_PINFL_AND_CADASTRAL_NUMBER:
          "ЖШШИР орқали кадастр базасидан излаш",
        SEARCH_RESIDENT_BY_PINFL_FROM_MIA_DATABASE:
          "ЖШШИР орқали ИИБ базасидан фуқаро маълумотларини излаш",
        CHANGE_RESIDENT_ELECTRCITY:
          "Абонентнинг электр ҳисоб рақамини ўзгартириш учун Электр энергия ҳисоб рақами устига икки марта босинг!",
        ABONENT: "Мижоз:",
        PERSON_COUNT: "Яшовчилар сони:",
        PERSON_COUNT_EDIT_ERROR:
          "Бу абонентда жорий давр учун баланс мавжуд эмас!",
        PINFL_DELETED:
          "Абонентнинг ПИНФЛ маълумоти муваффақиятли олиб ташланди.",
        CADASTRAL_DELETED:
          "Абонентнинг Кадастр Рақами муваффақиятли олиб ташланди.",
        PINFL_DELETED_MSG:
          "Сиз ҳақиқатан ҳам танланган абонентнинг ПИНФЛ маълумотини тизимдан олиб ташламоқчимисиз?",
        CADASTRAL_DELETED_MSG:
          "Сиз ҳақиқатан ҳам танланган абонентнинг Кадастр Рақамини тизимдан олиб ташламоқчимисиз?",
        RESIDENT_FILTER: {
          FILTER: "Филтр",
          COMPANY_NAME: "Корхона номи",
          ACCOUNT_NUMBER: "Ҳисоб рақами",
          RESIDENT_ID: "Абонент ID",
          ZONE: "Ҳудуд",
          VILLAGE: "Маҳалла",
          STREET: "Кўча",
          RESIDENT_TYPE: "Абонент тури",
          HOME_TYPE: "Хонадон тури",
          HOUSE_NUMBER: "Уй",
          FLAT_NUMBER: "Кв",
          INHABITANT_CNT: "Яшовчилар сони",
          ELECTRICITY_ACCOUNT_NUMBER: "Электр энергия ҳисоб рақами",
          FULL_NAME: "Ф.И.Ш",
          OLD_ACCOUNT_NUMBER: "Эски ҳисоб рақами",
          PHONE_NUMBER: "Телефон рақами",
          SUBMIT_BUTTON: "Излаш",
          RESET_BUTTON: "Тозалаш",
          IDENTIFIED: "Идентификация ҳолати",
          ACCOUNT_NUMBER_STATUS: "Ҳисоб рақам ҳолати",
          ACCOUNT_NUMBER_CHANGED: "Ҳисоб рақами ўзгарганлар",
          ACCOUNT_NUMBER_NOT_CHANGED: "Ҳисоб рақами ўзгармаганлар",
        },
        RESIDENTS_SEARCH: {
          REGION: "Вилоят",
          DISTRICT: "Туман",
          TITLE: "Aбонент излаш",
          JURIDICAL_SUBS: "Юридик шахслар",
          PHYSICAL_SUBS: "Жисмоний шахслар",
          RESIDENT_ID: "Абонент ID",
          COMPANY_NAME: "Корхона номи",
          ACCOUNT_NUMBER: "Ҳисоб рақами",
          OLD_ACCOUNT_NUMBER: "Эски ҳисоб рақами",
          RESIDENT_FIO: "Абонент Ф.И.Ш",
          MAHALLA_NAME: "Маҳалла",
          STREET_NAME: "Кўча",
          HOUSE_NUMBER: "Уй",
          FLAT_NUMBER: "Кв",
          INDEX: "Индекс",
          INN: "ИНН",
        },
        INCORRECT_RESIDENT_DATA: {
          FILTER_BY_RESIDENTS: "Абонентлар бўйича филтр",
          OPTIONS: {
            PASSPORT_INFORMATION_IS_INCORRECT: "Паспорт маълумотлари нотўғри",
            THE_CADASTRAL_NUMBER_IS_INCORRECT: "Кадастр рақами нотўғри",
            PHONE_NUMBER_NOT_ENTERED: "Телефон рақами киритилмаган",
            ADDRESS_INFORMATION_IS_INCORRECT: "Манзил маълумотлари нотўғри",
            ELECTRICITY_ACCOUNT_INVALID_LENGTH: "Manzil ma’lumotlari notoʻgʻri",
            NO_ELECTRICAL_INFORMATION_INCLUDED:
              "Электр энергия маълумотлари йўқ",
          },
          ERROR_OPTIONS: {
            TITLE: "Хатоликлар",
            PASSPORT_NOT_PROVIDED: "Паспорт рақами киритилмаган",
            PASSPORT_INVALID_LENGTH:
              "Паспорт рақами 9 та белгидан иборат бўлиши керак",
            PASSPORT_INVALID_LETTER_FORMAT:
              "Паспорт рақамининг дастлабки 2 та белгиси катта ҳарф бўлиши керак",
            PASSPORT_INVALID_NUMBER_FORMAT:
              "Паспорт рақамининг охирги 7 та белгиси рақам бўлиши керак",
            PNFL_NOT_PROVIDED: "ЖШШИР киритилмаган",
            PNFL_INVALID_LENGTH: "ЖШШИР 14 та рақамдан иборат бўлиши керак",
            PNFL_INVALID_FORMAT: "ЖШШИР фақат рақамлардан иборат бўлиши керак",
            BIRTH_DATE_NOT_PROVIDED: "Туғилган сана киритилмаган",
            BIRTH_DATE_FUTURE:
              "Туғилган сана келажакдаги сана бўлиши мумкин эмас",
            CADASTRAL_NUMBER_NOT_PROVIDED: "Кадастр рақами киритилмаган",
            CADASTRAL_NUMBER_INVALID_FORMAT: "Кадастр рақами нотўғри форматда",
            CADASTRAL_NUMBER_REGION_CODE_MISMATCH:
              "Кадастр рақами вилоят коди билан мос келмайди",
            CADASTRAL_NUMBER_DISTRICT_CODE_MISMATCH:
              "Кадастр рақами туман коди билан мос келмайди",
            CADASTRAL_NUMBER_DUPLICATE: "Кадастр рақами такрорланган",
            STREET_NOT_SELECTED: "Кўча танланмаган",
            MAHALLA_NOT_SELECTED: "Маҳалла танланмаган",
            ELECTRICITY_ACCOUNT_NOT_PROVIDED:
              "Электр энергияси ҳисоб рақами киритилмаган",
            ELECTRICITY_ACCOUNT_INVALID_LENGTH:
              "Электр ҳисоб рақами узунлиги нотўғри",
            ELECTRICITY_ACCOUNT_INVALID_FORMAT:
              "Электр ҳисоб рақами формати нотўғри",
            ELECTRICITY_ACCOUNT_ALL_ZEROS:
              "Электр ҳисоб рақами фақат нол бўлиши мумкин эмас",
            PHONE_NUMBER_NOT_PROVIDED: "Телефон рақами киритилмаган",
          },
          DUPLICATES: {
            TITLE: "Идентификация қилишда хатолик",
            DUPLICATE_FOUND: "Такрорий абонент топилди",
            DUPLICATE_FOUND_VALUE: "{{value}} та такрорий абонент топилди",
            RESIDENT_ID: "Абонент ID",
            DUPLICATE_RESIDENT_ID: "Такрорий абонент ID",
            CADASTRAL_NUMBER: "Кадастр рақами",
            DUPLICATE_CADASTRAL_NUMBER: "Такрорий кадастр рақами",
            COMPANY_NAME: "Корхона номи",
            DISTRICT: "Туман",
            ACCOUNT_NUMBER: "Ҳисоб рақами",
          },
        },
        NON_EXISTENT_RESIDENTS_IN_SYSTEM: {
          PNFL: "ЖШШИР",
          INN: "ИНН",
          CADASTRAL_NUMBER: "Кадастр рақами",
          FISH: "Ф.И.Ш",
          ALL: "Ҳаммаси",
          IS_EXISTENT_IN_SYSTEM: "Тизимда мавжуд",
          IS_NOT_EXISTENT_IN_SYSTEM: "Тизимда мавжуд эмас",
          IS_NOT_EXISTENT_IN_SYSTEM_EXCEL_DOWNLOAD:
            "Солиқдан олинган абонентлар (Excel).xlsx",

          TABLE_HEADERS: {
            ID: "ID",
            FISH: "Ф.И.Ш",
            PNFL: "ЖШШИР",
            INN: "ИНН",
            CADASTRAL_NUMBER: "Кадастр рақами",
            ADDRESS: "Манзил",
            HOUSE_TYPE: "Уй тури",
          },
        },
      },
      IIB_SINXRONIZATSIYA: {
        TABLE_HEADERS: {
          DISTRICT_NAME: "Туман",
          CREATED_USER_NAME: "Синхронлашни бошлаган фойдаланувчи",
          CREATED_AT: "Бошланган сана",
          FINISHED_AT: "Тугатилган сана",
          TOTAL_COUNT: "Жами",
          SUCCESS_COUNT: "Мувофақиятли",
          FAILED_COUNT: "Мувофақиятсиз",
          OLD_MIA_INHABITANT_COUNT:
            "Янгиланишдан олдинги ИИБда яшаувчилар сони",
          NEW_MIA_INHABITANT_COUNT:
            "Янгиланишдан кейингги ИИБда яшаувчилар сони",
          OLD_ACCRUAL_AMOUNT: "Эски начисления",
          NEW_ACCRUAL_AMOUNT: "Янги начисления",
          DIFFERENCE: "Фарқи",
        },
        TABLE_HEADERS_OLD: {
          NAME: "Номи",
          RESIDENT_COUNT: "Абонентлар сони",
          MIA_INHABITANT_COUNT: "ИИБда яшовчилар сони",
          RESIDENT_INHABITANT_COUNT: "Тизимдаги яшовчилар сони",
          SYNCHRONIZATION: "Синхронизация",
          STATUS: "Ҳолат",
          FINISHED: "Тугалланган",
          IN_PROGRESS: "Жараёнда",
        },
        MODAL: {
          SYNC_HISTORY: "Синхронизация тарихи - {{title}}",
          TITLE: "ИИБ синхронизацияси",
          TEXT: "Сиз ҳақиқатан ҳам ИИБ синхронизациясини амалга оширмоқчимисиз?",
          BUTTON: "Синхронизацияни бошлаш",
          SUCCESS_MESSAGE: "Синхронизация муваффақиятли амалга оширилди!",
        },
      },
      BLOCKED_RESIDENTS: {
        TABLE_HEADERS: {
          ID: "ID",
          BLOCK_DATE: "Блоклаш санаси",
          COATO: "COATO",
          CUSTOMER_CODE: "Мижоз коди",
          ACCOUNT_NUMBER: "Ҳисоб рақами",
          STATUS: "Ҳолат",
          SALDO: "Салдо",
          MESSAGE: "Хабар",
          SEND_SMS_WARNING_STATUS: "СМС хабарни ҳолати",
          WARNING_DATE: "Огоҳлантириш санаси",
          CURRENT_DEBT: "Жорий қарздорлик",
          CURRENT_YEAR_DEBT: "Жорий йилдаги қарздорлик",
          CURRENT_YEAR: "Жорий йил",
          PAYMENT: "Тўлов",
          ACT_PAYMENT: "Акт тўлови",
          UNBLOCK_REASON: "Блокдан чиқариш сабаби",
          TOTAL_DEBT_COUNT: "Жами қарздорлар сони",
          WARNING_DEBT_SUM: "Огоҳлантирилган қарздорлик суммаси",
          WARNING_DEBT_COUNT: "Огоҳлантириладиган қарздорлар сони",
        },
        MODAL: {
          BLOCK_TITLE: "Абонент(лар)ни блоклаш",
          UNBLOCK_TITLE: "Абонент(лар)ни блокдан чиқариш",
          WARNING_TITLE: "Абонент(лар)ни огоҳлантириш",
          POTEMTIAL_WARNING_TITLE: "Огоҳлантириш мумкин бўлган абонентлар",
          ALL_DEBIT_WARNING: "Барча қарздорларни огоҳлантириш",
          ALL_DEBIT_BLOCK: "Барча қарздорларни блоклаш",
          CONFIRMATION_WARNING_TEXT: "Абонент(лар)ни огоҳлантирмоқчимисиз?",
          CONFIRMATION_BLOCK_TEXT: "Абонент(лар)ни блокламоқчимисиз?",
          CONFIRMATION_ALL_DEBIT_WARNING_TEXT:
            "Барча қарздорларни огоҳлантирмоқчимисиз?",
          CONFIRMATION_UNBLOCK_TEXT: "Абонент(лар)ни блокдан чиқармоқчимисиз?",
          CONFIRMATION_ALL_DEBIT_BLOCK_TEXT:
            "Барча қарздорларни блокламоқчимисиз?",
          WARNING_RESIDENTS: "Огоҳлантирилган абонентлар",
          BLOCKED_RESIDENTS: "Блокланган абонентлар",
        },
        REPORT: {
          TOTAL_BLOCK_COUNT: "Жами блокланган абонентлар сони",
          TOTAL_DEBIT: "Блокланган абонентлар жами қарздорлик суммаси",
          BLOCK_DEBIT:
            "Блокланган абонентларнинг 07.2025 дан ҳозиргача қарздорлик суммаси",
          PAYMENT: "Блокланган абонентлар томонидан амалга оширилган тўловлар",
          PAYMENT_SUM:
            "Блокланган абонентлар томонидан амалга оширилган тўловлар суммаси",
          ACT_PAYMENT: "Блокланган абонентлар учун тузилган актлар",
          ACT_PAYMENT_SUM: "Блокланган абонентлар учун тузилган актлар суммаси",
          CREATED_COUNT: "Тизимда яратилган блоклаш аризалари сони",
          BLOCK_COUNT: "Амалда блокланган ҳолатдаги абонентлар сони",
          UNBLOCK_COUNT: "Блокдан чиқарилган абонентлар сони",
          OPERATION_FAILED_COUNT:
            "Блоклаш операцияси муваффақиятсиз тугаган ҳолатлар сони",
          CANCEL_BLOCK_COUNT:
            "Ходим томонидан блоклаш бекор қилинган ҳолатлар сони",
          CANCEL_CONTRACT_COUNT: "Бекор қилинган шартномалар сони",
          NOT_FOUND_ELECTRICITY_ACCOUNT_COUNT:
            "Электр ҳисоб-рақами ҲЭТ тизимида аниқланмаган ҳолатлар сони",
          SERVER_ERROR_MESSAGE_COUNT:
            "Тизимдаги хатоликлар сабабли юборилмаган хабарлар сони",
          CREATED: "Яратилган",
          BLOCK: "Блокланган",
          ALREADY_BLOCKED_COUNT: "Аллақачон блокланган абонентлар сони",
          UNBLOCK: "Блокдан чиқарилган",
          OPERATION_FAILED: "Блоклаш операцияси муваффақиятсиз тугаган",
          CANCEL_BLOCK: "Блоклаш бекор қилинган",
          CANCEL_CONTRACT: "Шартномаси бекор қилинган",
          NOT_FOUND_ELECTRICITY_ACCOUNT: "Электр ҳисоб-рақами топилмаган",
          SERVER_ERROR_MESSAGE: "Блоклашда хатолик юз берган",
          USER_FULL_NAME: "Блоклашни бекор қилган ходим Ф.И.Ш",
          ERROR_WHEN_BLOCKING:
            "Хатоликлар сабабли блоклаш амалга ошмаган абонентлар",
          CANCEL_BLOCK_OPERATION:
            "Маълум сабабларга кўра блоклаш бекор қилинган абонентлар",
          ALREADY_BLOCK: "Аллақачон блокланган",
        },
      },
      POTENSIAL_WARNING_RESIDENT: {
        TABLE_HEADERS: {
          ACCOUNT_NUMBER: "Ҳисоб рақами",
          FULL_NAME: "Ф.И.Ш",
          K_SALDO: "{{date}} Салдо охири ",
        },
      },
      CHANGING_ACTS: {
        TABLE_HEADERS: {
          ID: "ID",
          DATA: "Маълумот",
          NAME: "Номи",
          COMPANY_NAME: "Компаня номи",
          NUMBER_ACTS: "Ҳаракатлар сони",
          ACTS_INCREASING_NUMBER: "Рақамларни кўпайтириш ҳаракатлари",
          ACTS_REDUCTION_NUMBER: "Рақамларни қисқартириш актлари",
          TOTAL: "Жами",
          APPROVED: "Тасдиқланган",
          CONTRACT_TERMINATED: "Шартнома тугатилади",
        },
      },
      OPERATIONS: {
        TABLE_HEADERS: {
          ID: "ID",
          COMPANY_NAME: "Корхона номи",
          COMPLETED_TIME: "Якунланган вақти",
          EXCEPTION_MESSAGE: "Натижа хабари",
          EXECUTED_BY: "Ижрочи",
          OPERATION_STATUS: "Ҳолат",
          PERIOD: "Давр",
          START_TIME: "Бошланиш вақти",
        },
        MODAL: {
          CONFIRMATION_TEXT: " Жорий давр қайта ҳисоби",
        },
      },
      CASH_PAYMENTS: {
        TABLE_HEADERS: {
          ID: "ID",
          DATE: "Сана",
          COMPANY_NAME: "Корхона",
          CHECKSUM: "Назорат суммаси",
          TERMINAL: "Терминал",
          CASH: "Нақд",
          PACKAGE_SUMM: "Пачка суммаси",
          TOTAL: "Жами",
          SPECIAL_PACKAGE: "Махсус пачка",
          WEBSITE: "Веб сайт",
          MOBILE: "Мобил",
          ANDROID: "Андроид",
          STATUS: "Ҳолат",
          FROM_BANK: "Банк томонидан",
          PACKAGE_DESCRIPTION: "Пачка изоҳи",
          USER_FULLNAME: "Фойдаланувчи Ф.И.Ш",

          //CASH-PAYMENT-ENTITY
          PERIOD: "Давр",
          ACCOUNT_NUMBER: "Ҳисоб рақам",
          SUM: "Сумма",
          KVIT_DATE: "Квитанция санаси",
          PAYMENT_INFO: "Тўлов маълумотлари",
          PAYMENT_TYPE: "Тўлов тури",
          KVIT_NO: "Квитанция №",
          RESIDENT_FIO: "Абонент Ф.И.Ш",
          MAHALLA_NAME: "Маҳалла",
          STREET_NAME: "Кўча",
          KVIT_TYPE: "Квитанция тури",
          HOUSE: "Уй",
          APARTMENT: "Квартира",
          INDEX: "Индекс",
          PAYER: "Тўловчи Ф.И.Ш",
          EMPLOYEE_INFO: "Ходим Ф.И.Ш",
          ALL: "Жами",
          TO_CART: "Картага ўтиш",
          PACHKA_ID: "Пачка ID",
          INHABITANT_CNT: "Яшовчи сони",
          CONTRACT_DATE: "Шартнома санаси",
          K_SALDO: "Салдо охири",
          FILE_ID: "Бириктирилган файл",
        },
        ACTIONS: {
          CREATE_PACHKA: "Янги пачка",
          POSTING: "Разноска",
        },
        STATUS: {
          ACTIVE: "Ҳа",
          INACTIVE: "Йўқ",
        },
        MODAL: {
          TITLE: "Янги пачка қўшиш",
          TITLE_UPDATE: "Пачкани таҳрирлаш",
          DOWNLOAD_EXCEL: "Excel юклаб олиш",
          EDIT_KVIT: "Квитанцияни таҳрирлаш",
          DELETE_CONFIRMATION:
            "Сиз ҳақиқатан ҳам танланган квитанцияни тизимдан олиб ташламоқчимисиз?",
          DELETE_TITLE: "Квитанцияни ўчириш",

          DELETE_PACK_CONFIRMATION:
            "Сиз ҳақиқатан ҳам танланган пачкани тизимдан олиб ташламоқчимисиз?",
          DELETE_PACK_TITLE: "Пачкани ўчириш",
          NEW_RECEIPT: "Янги квитанция",
          ADDRESS: "Манзил",

          // ADDITIONAL ASIDE
          RESIDENT_SEARCH: "Абонент кидируви",
          RESIDENT_HOUSE: "Уй",
          RESIDENT_INDEX: "Индекс",
          RESIDENT_APARTMENT: "Кв.",
          COMPANY_NAME: "Корхона номи",
          OLD_ACCOUNT_NUMBER: "Эски ҳисоб рақами",
          MAHALLA: "Маҳалла",
        },
        FORM: {
          CREATED_DATE: "Сана",
          CONTROL_SUM_AMOUNT: "Назорат суммаси",
          STATUS: "Cтатус",
          STATUS_SPECIAL_PACK: "Махсус пачка",
          INSPEKTOR: "Назоратчи",
          STATUS_IS_BANK_CREATED: "Банк томонидан",
          COMMENT: "Изох",
          COMPANY_NAME: "Пачка изохи",
          PAYMENT_PARTNERS: "Тўлов ҳамкорлари",
          KVIT_NO: "Квит. №",
          SUM: "Сумма",
          PAYMENT_TYPE: "Тўлов тури",
          PAYMENT_PURPOSE: "Тўлов маълумотлари",
          FILE_ATTACHMENT: "Файл бириктириш",
          KVIT_TYPE: "Квитанция тури",
          RESIDENT_FIO: "Абонент Ф.И.Ш",
          RESIDENT_PHONE: "Абонент телефони",
        },
        EXCEL: "Нақд пул тўловлари",
      },
      ACT_PACK: {
        TABLE_HEADERS: {
          ID: "ID",
          USER_ID: "Фойдаланувчи Ф.И.Ш",
          RESIDENT_FIO: "Абонент Ф.И.Ш",
          COMPANY_NAME: "Корхона номи",
          PACK_TYPE_ID: "Пачка тури",
          NAME: "Номи",
          STATUS: "Ҳолат",
          CONTROL_LIMIT: "Назорат сони",
          IS_SPECIAL_PACK: "Махсус пачка",
          ACTS_COUNT: "Актлар сони",
          ACT_AMOUNT_SUM: "Актлар суммаси",
          ACT_CREDIT_COUNT: "Кредиторлик",
          ACT_DEBIT_COUNT: "Дебиторлик",
          ACT_CREDIT_AMOUNT_SUM: "Кредиторлик (Сумма)",
          ACT_DEBIT_AMOUNT_SUM: "Дебиторлик (Сумма)",
          INVENTORY_COUNT: "Бирламчи инвен.",
          INVENTORY_AMOUNT_SUM: "Бирламчи инвен. (Сумма)",
          CREATED_DATE: "Яратилган сана",
          FILE_ID: "Бириктирилган файл",
          DESCRIPTION: "Изоҳ",
        },
        MODAL: {
          NAME: "Номи:",
          DESCRIPTION: "Изоҳ:",
          CREATED_DATE: "Cана:",
          COMPANY_ID: "Корхона:",
          PACK_TYPE_ID: "Пачка тури:",
          FILE_ID: "  Бириктирилган файл:",
          CONTROL_LIMIT: "Назорат сони:",
          SELECT_STATUS: "Ҳолат:",
          IS_SPECIAL_PACK: "Махсус пачка:",
          CHOOSE_ACT_PACK: "Актлар пачкасини танланг",

          MODAL_TITLE: "Янги актлар пачкаси қўшиш",
          UPDATE_MODAL: "Актлар пачкасини таҳрирлаш",
          FILE_ATTACHMENT: "Файл бириктириш",
          DELETE_MODAL: "Актлар пачкасини ўчириш",
          EXCEL_TITLE: "Актлар пачкаси {{date}}",
          ACTS_EXCEL_TITLE: "Актлар {{date}}",
          DELETE_MODAL_SUBTITLE:
            "Сиз ҳақиқатан ҳам танланган aктлар пачкасини тизимдан олиб ташламоқчимисиз?",
          TOAST_DELETE: "Танланган актлар пачкаси муваффақиятли ўчирилди!",
          TOAST_SUCCESS: "Янги актлар пачкаси муваффақиятли қўшилди!",
          TOAST_UPDATE: "Танланган актлар пачкаси муваффақиятли янгиланди!",
        },
        ACT_PACK_TYPES: {
          SIMPLE: "Тўлов келиб тушмаган",
          SERVICE_NOT_PROVIDED: "Хизмат кўрсатилмаган",
          SPECIAL: "Махсус",
          CANCEL_CONTRACT: "Шартнома бекор қилиш",
          INVENTORY: "Одам сонини ўзгартириш",
          MIB: "Миб томонидан",
          ECO_PAY_INVENTORY: "EcoPay Инвентаризация учун",
          FROZEN: "Музлатилган қарздорлик",
        },
        ACTS: {
          TABLE_HEADERS: {
            ID: "ID",
            ACT_NUMBER: "Акт рақами",
            ACT_PACK_ID: "Пачка номи",
            PACK_TYPE_ID: "Пачка тури",
            RESIDENT_ID: "Абонент",
            STATUS: "Ҳолат",
            ACT_TYPE_ID: "Акт тури",
            AMOUNT: "Сумма",
            USER_ID: "Фойдаланувчи Ф.И.Ш",
            UPDATED_BY_FULL_NAME: "Таҳрирлаган фойдаланувчи Ф.И.Ш",
            UPDATED_AT: "Таҳрирланган сана",
            FILE_ID: "Бириктирилган файл",
            ACT_ACTION_ID: "Акт ҳаракати",
            OLD_INHABITANT_COUNT: "Олдинги яшовчилар сони",
            START_PERIOD: "Бошланиш давр",
            END_PERIOD: "Тугаш даври",
            CURRENT_INHABITANT_COUNT: "Янги яшовчилар сони",

            CREATED_AT: "Яратилган сана",
            CREATED_BY: "Яратган фойдаланувчи",

            CONFIRMED_AT: "Тасдиқланган сана",
            CONFIRMED_BY: "Тасдиқлаган фойдаланувчи",

            WARNED_AT: "Огоҳлантирилган сана",
            WARNED_BY: "Огоҳлантирган фойдаланувчи",
            WARNING_CONCLUSION: "Огоҳлантирилганлик хулосаси",

            CANCELLED_AT: "Бекор қилинган сана",
            CANCELLED_BY: "Бекор қилган фойдаланувчи",
            CANCELLATION_CONCLUSION: "Бекор қилинганлик хулосаси",

            DESCRIPTION: "Изоҳ",
          },
          MODAL: {
            WARNING_TITLE: "100 тадан кўп актлар танлай олмайсиз!",

            FILTER_RESIDENT_TITLE: "Дастлабки 50 та натижа кўрсатилмоқда",

            MODAL_TITLE: "Янги акт қўшиш",
            UPDATE_MODAL: "Актни таҳрирлаш",

            CHECK_MODAL: "Актни тасдиқлаш",
            APPROVED_MODAL: "Актларни қабул қилиш",
            WARNING_MODAL: "Огохлантириш",
            CANCEL_MODAL: "Актни бекор қилиш",
            DELETE_MODAL: "Актни ўчириш",
            DELETE_MODAL_SUBTITLE:
              "Сиз ҳақиқатан ҳам танланган актни тизимдан олиб ташламоқчимисиз?",
            CHECK_MODAL_SUBTITLE:
              "Сиз ҳақиқатан ҳам танланган актларни тасдиқламоқчимисиз?",
            APPROVED_MODAL_SUBTITLE:
              "Сиз ҳақиқатан ҳам танланган актларни қабул қилишни истайсизми?",
            CANCEL_MODAL_SUBTITLE:
              "Сиз ҳақиқатан ҳам танланган актларни бекор қилишни истайсизми?",
            WARNING_MODAL_SUBTITLE:
              "Сиз ҳақиқатан ҳам танланган актларни огоҳлантирмоқчимисиз?",
            FILD_REQUARED_TITLE: "Ҳозирги давр учун файл юклаш шарт емас!",

            CONFIRMED_SUCCESS: "Танланган актлар муваффақиятли тасдиқланди",
            WARNING_SUCCESS: "Танланган актлар муваффақиятли огоҳлантирилди",
            CANCELLED_SUCCESS: "Танланган актлар муваффақиятли бекор қилинди",
            NO_PERMISSION: "Сизда ушбу амални бажариш учун рухсат йўқ",

            TOAST_DELETE: "Танланган акт муваффақиятли ўчирилди!",
            TOAST_SUCCESS: "Янги акт муваффақиятли қўшилди!",
            TOAST_UPDATE: "Танланган акт муваффақиятли янгиланди!",
            SUCCESS: "Амал муваффақиятли бажарилди!",

            ACT_NUMBER: "Акт рақами:",
            ACT_PACK_ID: "Пачка акт ID:",
            PACK_TYPE_ID: "Пачка тури:",
            RESIDENT_ID: "Абонент:",
            STATUS: "Акт тури:",
            AMOUNT: "Сумма:",
            FILE_ID: "Бириктирилган файл:",
            DESCRIPTION: "Изоҳ:",
            K_SALDO: "Салдо охири:",
            MAIN: "Асос",
            INHABITANTS_CNT: "Яшовчилар сони:",
            CURRENTLY_INHABITANTS_CNT: "Жорий даврда яшовчилар сони:",
            DATA_PERIOD: "Қачондан:",
            DATA_PERIOD_TO: "Қачонгача:",
            ACT_SUM_BY_QQS: "ҚҚС давр бўйича акт суммаси:",
            ACT_SUM_NO_QQS: "ҚҚС сиз давр бўйича акт суммаси:",
            TOTAL_ACT_SUM: "Жами акт суммаси:",
            SHOW_PERIOD: "Давр бўйича",
            PERIOD_SALDO: "Давр бошига салдо:",
            PERIOS_N_SALDO: "Давр охирига салдо:",
            ADDRESS: "Манзил:",
            THIS_PERIOD_ACT_AMOUNT: "Жорий даврдаги акт суммаси:",
          },
        },
        EXCEL: "Нақд пул тўловлар  пачкаси",
      },
      TARIFFS: {
        TARIFFS_POPULATION: {
          TITLE: "Аҳоли",
          DESC: "1 ойга 1 киши учун",
        },
        TARIFFS_JURIDICAL_SUBS: {
          TITLE: "Юридик абонентлар",
          DESC: "1м3 чиқинди учун",
        },
        TARIFFS_JURIDICAL_SUBS_BUDGET: {
          TITLE: "Юридик абонентлар (Бюджет)",
          DESC: "1м3 чиқинди учун",
        },
        FORM: {
          QQS: "ҚҚС:",
          RATE_WITH_QQS: "Нархи (ҚҚС билан)",
          NEW_TARIFF: "Янги тариф",
          CATEGORY_SELECT: "Категория:",
          COMPANY_SELECT: "Корхона:",
          START_DATE: "Бошлангич сана:",
          END_DATE: "Тугаш сана:",
          RATE: "Нархи:",
          SMCH_RATE: "КМЧ нархи:",
          QMCH_RATE: "СМЧ нархи:",
          POLIGON_RATE: "Полигон хизмати нархи:",
          NAME_UZ: "Тариф номи:",
          NAME_RU: "Тариф номи:",
          NAME_CRL: "Тариф номи:",
          NAME_EN: "Тариф номи:",
          DESCRIPTION_UZ: "Тариф тавсифи:",
          DESCRIPTION_RU: "Тариф тавсифи:",
          DESCRIPTION_CRL: "Тариф тавсифи:",
          DESCRIPTION_EN: "Тариф тавсифи:",
        },
        MODAL: {
          ADD_SERVICE: "Қўшимча хизматлар:",
          MODAL_TITLE: "Таъриф қўшиш",
          UPDATE_MODAL: "Таърифни таҳрирлаш",
          DELETE_MODAL: "Таърифни ўчириш",
          DELETE_MODAL_SUBTITLE: "Танланган таърифни  олиб ташламоқчимисиз?",
          TOAST_DELETE: "Танланган таъриф муваффақиятли ўчирилди!",
          TOAST_UPDATE: "Танланган таъриф муваффақиятли таҳрирланди!",
          TOAST_SUCCESS: "Танланган таъриф муваффақиятли қўшилди!",
        },
      },
      PLANS: {
        POPULATION: {
          TABLE_NAME: "Аҳоли",
          TABLE_HEADERS: {
            ID: "ID",
            NAME: "Номи",
            START_DATE: "Бошлангич сана",
            END_DATE: "Тугаш сана",
            RATE: "Нархи",
            ADD_SERVICE: "Қўшимча хизматлар",
            SMCH_RATE: "КМЧ(м\u00B3)",
            QMCH_RATE: "СМЧ(тонна)",
            POLIGON_RATE: "Полигон хизмати(м\u00B3)",
            DESCRIPTION: "Изоҳ",
            ACTION: "Ҳаракатлар",
          },
        },
        LEGAL_S: {
          TABLE_NAME: "Юридик абонентлар",
        },
        LEGAL_S_B: {
          TABLE_NAME: "Юридик абонентлар (Бюджет)",
        },
        MODAL: {
          PLAN: "Категорияни танланг:",
          START_DATE: "Бошлангич сана:",
          END_DATE: "Тугаш сана:",
          RATE: "Нархи:",
          ADD_SERVICE: "Қўшимча хизматлар:",
          SMCH_RATE: "КМЧ нархи:",
          QMCH_RATE: "СМЧ нархи:",
          POLIGON_RATE: "Полигон хизмати нархи:",
          NAME_UZ: "Тариф номи:",
          NAME_RU: "Тариф номи:",
          NAME_CRL: "Тариф номи:",
          NAME_EN: "Тариф номи:",
          DESCRIPTION_UZ: "Тариф тавсифи:",
          DESCRIPTION_RU: "Тариф тавсифи:",
          DESCRIPTION_CRL: "Тариф тавсифи:",
          DESCRIPTION_EN: "Тариф тавсифи:",
          MODAL_TITLE: "Таъриф қўшиш",
          UPDATE_MODAL: "Таърифни таҳрирлаш",
          DELETE_MODAL: "Таърифни ўчириш",
          DELETE_MODAL_SUBTITLE: "Танланган таърифни  олиб ташламоқчимисиз?",
          TOAST_DELETE: "Танланган таъриф муваффақиятли ўчирилди!",
          TOAST_UPDATE: "Танланган таъриф муваффақиятли таҳрирланди!",
          TOAST_SUCCESS: "Танланган таъриф муваффақиятли қўшилди!",
        },
      },
      APPEAL: {
        APPEAL_BUTTON: "Кўриш",
        APPEAL_TEXT: "Мурожаат матни",
        REJECT_TEXT: "Рад этиш матни",
        ANSWER_TEXT: "Жавоб матнини киритиш",
        ANSWER: "Жавоб матни",
        FILE_ATTACHMENT: "Файл бириктириш",
        TABLE_HEADERS: {
          ID: "ID",
          ABONENT_FIO: "Мурожaат муаллифининг Ф.И.Ш",
          ABONENT_LICSHET: "Ҳисоб рақам",
          REQUEST_TYPE_NAME: "Сўров тури",
          ABONENT_REQUEST_STATUSES_ID: "Сўров ҳолати",
          PHONE: "Телефон",
          ABONENT_AREA: "Туман/Шаҳарлар",
          ABONENT_COMPANY: "Корхона номи",
          ABONENT_ADRES: "Манзил",
          EMAIL: "E-mail",
          CHANNEL: "Канал",
          CREATED_DATE: "Келиб тушган сана",
          ACCEPTED_DATE: "Қабул қилинган сана",
          EXECUTED_DATE: "Бажарилган сана",
          CANCELED_DATE: "Бекор қилинган сана",
        },
        ADDRESS: "Манзил",
        SELECT: {
          APPLICATIONS_STATUS: "Сўров ҳолати",
          APPLICATIONS_TYPE: "Сўров тури",
          COMPANY_NAME: "Корхона номи",
          NEIGHBORHOOD: "Маҳалла",
        },
        CAN_NOT_ACCEPT: "Мурожаатни қабул қила олмайсиз",
        CAN_NOT_REJECT: "Мурожаатни рад қила олмайсиз",

        SUBMIT_ANSWER: "Жавоб юбориш",
        REJECT_REQUEST: "Мурожаатни таҳрирлаш",
        EDIT_APPLICATION: "Мурожаатни таҳрирлаш",
        CREATED: "Яратилди(Навбатда)",
        ACCEPTED: "Қабул қилинди(Ўрганилмоқда)",
        COMPLETED: "Бажарилди",
        CANCELLED: "Бекор қилинди",
        SYSTEM_CANCELLED: "Тизим томонидан бекор қилинди",
        BUTTONS_ACCEPTANCE_APPLICATION: "Қабул қилиш",
        ACCEPTED_CONFIRMATION_TEXT:
          "Мурожаатни ростан ҳам қабул қилмоқчимисиз?",
        BUTTONS_REFUSAL_APPLICATION: "Рад этиш",
        REJECTED_CONFIRMATION_TEXT: "Мурожаатни ростан ҳам рад етмоқчимисиз?",
        GO_TO_CARD: "Картага ўтиш",
        WRITE_ANSWER: "Жавоб ёзиш",
        DELETE_MODAL: "Аризани ўчириш",
        DELETE_MODAL_SUBTITLE:
          "Ҳақиқатан ҳам танланган аризани тизимдан олиб ташламоқчимисиз?",
        TOAST_DELETE: "Танланган ариза муваффақиятли ўчирилди!",
        TOAST: {
          REJECT_REQUEST: "Aмал муваффақиятли бажарилди!",
          SUBMIT_ANSWER: "Aмал муваффақиятли бажарилди!",
        },
        RESIDENT_FILTER: {
          TABLE_HEADERS: {
            ID: "ID",
            ACCEPTED_DATE: "Қабул қилинган сана",
            ACCOUNT_NUMBER: "Ҳисоб рақами",
            CANCELED_DATE: "Бекор қилинган сана",
            CHANNEL: "Канал",
            COMPLETED_AT: "Якунланган сана",
            CREATED_AT: "Яратилган сана",
            DISTRICT: "Туман",
            EMAIL: "E-mail",
            FIRST_NAME: "Исм",
            LAST_NAME: "Фамилия",
            MAHALLA_NAME: "Маҳалла номи",
            ONLINE_APPEAL_STATUS: "Онлайн мурожаат ҳолати",
            ONLINE_APPEAL_TYPE: "Онлайн мурожаат тури",
            PATRONYMIC: "Отасининг исми",
            PHONE: "Телефон",
            RESIDENT_ID: "Абонент ID",
            STREET: "Кўча номи",
          },
        },
        MODAL_GEOLOCATION: "Харитадан кўриш",
        TITLE_ASIDE_DETAIL: "Мурожаат",
        DOWNLOAD_FILE: "Бириктирилган файл",
        APPEAL_FILE: "Мурожаат файллари",
      },
      MY_GOV_APPEAL: {
        TABLE_HEADERS: {
          APPLICATION_NUMBER: "Ариза рақами",
          ABONENT_FIO: "Мурожаат муаллифининг Ф.И.Ш",
          ABONENT_LICSHET: "Абонент ҳисоб рақами",
          ABONENT_REQUEST_STATUSES_ID: "Сўров ҳолати",
          ANSWER: "Жавоб матни",
          ACCEPTED_DATE: "Ижрога қаратилган сана",
          ACCEPTED_FULL_NAME: "Ижрочи Ф.И.Ш",
          COMPLETED_DATE: "Бажарилган сана",
          COMPLETED_FULL_NAME: "Якунловчи Ф.И.Ш",
          CANCELLED_DATE: "Бекор қилинган сана",
          CANCELLED_FULL_NAME: "Бекор қилувчи Ф.И.Ш",
          COMMENT_CREATED_DATE: "MyGovда яратилган сана",
          MY_GOV_ACCOUNT_NUMBER: "Мурожаатчининг ҳисоб рақами",
          COMMENT: "Ариза матни",
          CREATED_DATE: "Тизимда яратилган сана",
        },
        FILTER: {
          PLACEHOLDER_ACCOUNT_NUMBER: "Ҳисоб рақам",
        },
        ACCEPTED_TO: "Ижрога қаратиш",
        ANSWER_TO: "Жавоб қайтариш",
        CREATED: "Яратилди(Навбатда)",
        ACCEPTED: "Қабул қилинди",
        ERROR: "Хатолик",
        COMPLETED: "Бажарилди",
        CANCELLED: "Бекор қилинди",
        BUTTONS_ACCEPTANCE_APPLICATION: "Қабул қилиш",
        ACCEPTED_CONFIRMATION_TEXT: "Мурожаатни ростан ҳам ижро қилмоқчимисиз?",
        BUTTONS_ANSWER_APPLICATION: "Жавоб ёзиш",
      },
      ORG_EMPLOYEES: {
        TABLE_HEADERS: {
          NUMBERS: "№",
          ID: "ID",
          COMPANY_NAME: "Корхона номи",
          FIO: "Ф.И.Ш",
          JOB_TITLE: "Лавозими",
          EMAIL: "E-mail",
          PHONE: "Телефон",
          LOGIN: "Логин",
          ATTACHED_FILE: "Бириктирилган файл",
          STATUS: "Ҳолат",
          ADDRESS: "Манзил",
          ROLE_DESCRIPTION: "Рол тавсифи",
        },
        JOB_TITLE: {
          TITLE_1: "Бошқарув",
          TITLE_2: "Ҳайдовчи",
          TITLE_3: "Назоратчи",
          TITLE_4: "Оператор",
          TITLE_5: "Ҳисобчи",
          TITLE_6: "Марказ Operator",
          TITLE_7: "Марказ Назоратчи",
          TITLE_8: "DXSH",
        },
        ACTION: {
          ADD_EMPLOYEES: "Ходим қўшиш",
          CHANGE_DATA: "Маълумотларни ўзгартириш",
          CHANGE_PASSWORD: "Паролни ўзгартириш",
        },
        STATUS: {
          ACTIVE: "Фаол",
          INACTIVE: "Нофаол",
          BUTTON: "Янги",
        },
        ORG_EMPLOYEES_MODAL: {
          TITLE: "Ходим қўшиш",
          TITLE_2: "Ходим маълумотларини таҳрирлаш",
          FISH: "Ф.И.Ш.:",
          TABEL_NUMBER: "Табел номери:",
          ADDRESS: "Манзил:",
          COMMENT: "Изоҳ:",
          FILE: "Файл бириктириш:",
          SELECT_FILE: "Файлни танлаш",
          EMPLOYEE: "Танланган ходимни ўчириш",
          CONFORMATION: "Ходимни рўйхатдан олиб ташламоқчимисиз?",
          CONFIRMATION_MODAL_TEXT:
            "Танланган, ходимлар рўйхатидан муваффақиятли ўчирилди!",
          SUBMIT_MODAL: "Ходим муваффақиятли қўшилди!",
          SUBMIT_MODAL_EDITED: "Танланган ходим муваффақиятли ўзгартирилди!",
          ROLE_DESCRIPTION: "Рол тавсифи",
        },
        ENGANGE: {
          TITLE: "Бириктирилган маҳаллалар рўйхати",
          BUTTON: "Ажратиш",
          MAHALLA_NAME: "Маҳалла номи",
          ACTION: "Ҳаракат",
          ENGANGE_MODAL_TITLE: "Маҳалла бириктириш",
        },
        EMPTY_COMPONENT: {
          TITLE: "Ходим маълумотлари",
          TEXT: "Рўйхатдан абонентни танланг",
        },
        TOAST_SUCCESS: {
          TITLE: "Амал муваффақиятли бажарилди!",
        },
        DELETE_MODAL: {
          TITLE: "Бириктирилган маҳаллани ажратиш",
          TEXT: "Сиз ҳақиқатан ҳам танланган маҳаллани ажратмоқчимисиз?",
        },
      },
      PAYMENTS: {
        TABLE_HEADERS: {
          NUMBERS: "№",
          ID: "ID",
          DATE: "Давр",
          FACIAL: "Ҳисоб рақами",
          HOUSE_NUMBER: "Уй",
          FLAT_NUMBER: "Кв",
          TERMINAL_NUMBER: "Терминал рақами",
          ZIPCODE: "Индекс",
          PAID: "Тўланган",
          PAID_CANCELED: "Тўланмаган",
          TRANSACTION_TIME: "Транзакция вақти",
          SUM: "Сумма",
          USER_FULLNAME: "Абонент Ф.И.Ш",
          TRANSACTION: "Транзакция",
          FILE: "Файл",
          PARTNER_PAYMENT_NAME: "Тўлов ҳамкори",
          STATUS: "Ҳолати",
          NEIGHBORHOOD: "Турар жой даҳаси",
          STREET: "Кўча",
          ACTION: "Ҳаракат",
        },
        MODAL: {
          DELETE_MODAL: "Тўловни ўчириш",
          DELETE_MODAL_SUBTITLE:
            "Сиз ҳақиқатан ҳам танланган тўловни тизимдан олиб ташламоқчимисиз?",
          TOAST_DELETE: "Танланган тўлов муваффақиятли ўчирилди!",
        },
      },
      VILLAGES: {
        TABLE_HEADERS: {
          NUMBERS: "№",
          ID: "ID",
          DISTRICTS: "Туман",
          NAME: "Исм",
          INSPECTOR_FULLNAME: "Назоратчи Ф.И.Ш",
          CREATED_BY_USER: "Яратган фойдаланувчи",
          DATE_OF_CREATION: "Яратилган сана",
          COMMENT: "Изоҳ",
          ACTION: "Ҳаракат",
        },
      },
      COURT_WARNING: {
        COURT_CREATE: "Огоҳлантириш вақти",
        COURT_UPDATE: "Янгиланган вақти",
        LANG_PDF: "PDF тили",
        UZ: "Ўзбек тили (UZ)",
        UZ_CYRL: "Кирилл (УЗ)",
        RU: "Рус тили (РУ)",
        COURT_STATUS: "Суд ҳолати",
        FOR_GMAIL: "Почта учун",
        PRINT: "Чоп этиш учун",
        SUM: "сўм",
        DEBT: "қарздор",
        COURT_WARNING_IN_CABINET: "Суд огоҳлантириш",
        DOWNLOAD_FILE_NAME: "Суд-огоҳлантиришлар.pdf",
        CONFIRM_TEXT:
          "Тасдиқланган файл киритилгандан сўнг, абонент огоҳлантирилган ҳисобланади. Форма-1 ва Абонент картаси файллари автоматик яратилади, бунинг учун абонент пасспорт маълумотлари тўғри киритилган бўлиши лозим!",
        FILE_APPROVED_LOAD: "Тасдиқланган огоҳлантириш файлни юклаш",
        FILE_APPROVED: "Тасдиқланган файл",
        TOAST_COURT_WARNING_SUCCESS: "Огоҳлантириш яратилди!",
        WARNING_FILE: "Огоҳлантириш файли",
        WARNING_FILE_PDF: "Огоҳлантириш файли.pdf",
        FORMA_1_PDF: "Форма-1.pdf",
        ABONENT_CART_PDF: "Абонент картаси.pdf",
        SENT_TO_COURT_DOCUMENT_PDF: "Судга юбориш файли.pdf",
        COURT_ORDER_PDF: "Суд қарори.pdf",
        TABLE_HEADERS: {
          ID: "ID",
          COMPANY_NAME: "Корхона номи",
          NAME: "Ф.И.Ш",
          PERSONAL_ACCOUNT: "Ҳисоб рақам",
          ADDRESS: "Манзил",
          STATUS: "Статус",
          WARNING_DATE: "Огоҳлантириш санаси",
          COURT_DATE: "Судга ўтказиш санаси",
          SUM: "Сумма",
          FILE: "Файл",
          USER_CREATED: "Яратилган фойдаланувчи",
          USER_CREATED_DATE: "Яратиш санаси",
          USER_UPDATE: "Ўзгартирган фойдаланувчи",
          USER_UPDATE_DATE: "Ўзгартирилган сана",
        },
        SUBSCRIBERS_TABLE_HEADERS: {
          ID: "ID",
          NAME: "Ф.И.Ш",
          PERSONAL_ACCOUNT: "Ҳисоб рақам",
          NEIGHBORHOOD: "Маҳалла",
          STREET: "Кўча",
          HOME: "Уй",
          APARTMENT: "Кв",
          INDEX: "Индекс",
        },
        FILTER: {
          FILTER_SEARCH: "Қидириш",
        },
        POSTING_AKT: {
          PERSONAL_ACCOUNT: "Шахсий ҳисоб",
          PERSONAL_ACCOUNT1: "Шахсий ҳисоб:",
          NAME: "Ф.И.Ш",
          ADDRESS: "Манзил",
          NUMBER_RESIDENTS: "Яшовчилар сони",
          WARNING_DATE: "Огоҳлантириш санаси",
          FILE_ADD: "Файл бириктириш",
          PLACEHOLDER_WARNING_AMOUNT: "Огоҳлантириш миқдори",
          PLACEHOLDER_WARNING_DATE: "Огоҳлантириш санаси",
          PLACEHOLDER_BASE: "Aсос",
        },
        SELECT: {
          PLACEHOLDER_COMPANY: "Корхона номи",
          PLACEHOLDER_STATUS: "Статус",
          PLACEHOLDER_QUARTER: "Маҳалла",
          PLACEHOLDER_STREET: "Кўча",
        },
        INPUT: {
          PLACEHOLDER_HOME: "Уй",
          PLACEHOLDER_IND: "Индекс",
          PLACEHOLDER_APARTMENT: "Квартира",
        },
        SUBSCRIBERS_MODAL: {
          TITLE: {
            SUBSCRIBERS: "Aбонентлар",
          },
        },
        MODAL: {
          COURT_WARNING_TITLE: "Суд жараёнига ўтказиш",
          EDIT_TITLE: "Миқдорни таҳрирлаш",
          CONFIRM_TITLE: "Холатни тасдиклаш",
          CONFIRM_TEXT:
            "Сиз ҳақиқатан ҳам ушбу огоҳлантиришларни суд жараёнига у́тказмоқчимисиз?",
          CONFIRM_TEXT_ONE:
            "Сиз ҳақиқатан ҳам ушбу огоҳлантиришни суд жараёнига у́тказмоқчимисиз?",
          CONFIRM_TEXT_FILE:
            "Сиз ҳақиқатан ҳам ушбу оммавий шартномани маҳаллага  бириктирмоқчимисиз?",
          CONFIRM_TOASTR: "Маълумот муваффақиятли тасдиқланди!",
          SUM: "Сумма",
        },
        STATUS: {
          NEW: "Янги",
          COURT_IN_PROGRESS: "Суд жараёнида",
        },
        TOAST: {
          REJECT_REQUEST: "Мурожаат муваффақиятли рад этилди!",
          SUBMIT_ANSWER: "Жавоб муваффақиятли юборилди!",
        },
        WARNING_MODAL: {
          TITLE: "Танланган абонентларни огоҳлантириш",
          TEXT: "Сиз ҳақиқатан ҳам танланган абонентларнини огоҳлантирмоқчимисиз?",
          COURT_WARNING_IN_CABINET:
            "Сиз ҳақиқатан ҳам танланган абонентни огоҳлантирмоқчимисиз?",
        },
        GREEN_TEXT: "Қарздорлик тўлиқ қопланган",
        YELLOW_TEXT:
          "Қарздорлик қисман қопланган ({{ percentage }}% дан 99.9% гача)",
        RED_TEXT: "Қарздорлик қисман қопланган (0% дан {{ percentage }}% гача)",
        SEND_COURT_ACTION: "Судга ўтказиш",
        DEBTORS_RESIDENTS_WARNING:
          "Фақатгина қарздорлигин бўлган ва {{ tem }} ой ичида судга тортилмаган абонетларни огоҳлантирш мумкин.",
      },
      COURT_ACTION: {
        COURT_DECISION_MESSAGE: "Суд қарори учун изоҳи",
        COURT_SEND_MESSAGE: "Сужа юбориш хабари",
        STATUS: "Холати",

        CANCEL_COURT_WARNING:
          "Сиз ҳақиқатан ҳам танланган абонентнинг суд жараёнини бекор қилмоқчимисиз?",
        EXCEL_NAME: "Суд жараёнлари.xlsx",
        EXPORT: "Ехcелга экспорт қилиш",
        COMMENT_STATUS: {
          ELECTRON_PAYMENT: "Электрон тўловлар",
          PAYMENT_1031: "МИБ ва 1031 тўловлар",
          CASH_PAYMENT: "Нақд пул тўловлари",
          MUNIS_PAYMENT: "Мунис тўловлари",
          ACT: "Аcт тўловлари",
        },
        PAYMENT_CONFIRM: {
          CONFIRMED: "Тасдиқланган",
          CONFIRMED_CANCELLED: "Бекор қилинган",
          PAYMENT_PERFORMED: "Тасдиқланган",
          PAYMENT_CANCELLED: "Бекор қилинган",
        },
        ADD_ADDITIONAL_DECISION_FILE: "Қўшимча қарор қўшиш",
        END_COURT: "Судни тугатиш",
        END_COURT_TOAST: "Суд якунланди",
        UPLOAD_MIB_FILE: "MIB файлини юклаш",
        SENT_TO_COURT_TEXT: "Ҳужжатлар судга юборилди",
        CLAIM_FILE_TEXT: "Судга юбориш учун даъво аризасини киритинг.",
        DOCUMENT_PREPARATION_END: "Суд ҳужжатларини расмийлаштиришни тугатиш",
        FORM_1_FILE_NAME: "Форма-1",
        ABONENT_CARD_FILE_NAME: "Абонент картаси",
        CLAIM_FILE_NAME: "Даъво аризаси",
        MAHALLA_FILE_NAME: "Маҳалла оммавий шартномаси",
        MIB: "МИБ файлни юклаш",
        DOCUMENT_PREPARATION_SUCCESS: "Ҳужжат муваффақиятли яратилди",
        FROM: "Баланс (дан)",
        TO: "Баланс (гача)",
        TAB_TITLE: {
          FILE: "Файл",
          PAYMENT: "Тўловлар",
          COURT_HISTORY: "Суд жараёни тарихи",
        },
        TABLE_HEADERS: {
          ID: "ID",
          COMPANY_NAME: "Корхона номи",
          NAME: "Ф.И.Ш",
          ACCOUNT_NUMBER: "Ҳисоб рақам",
          STATUS: "Ҳолат",
          WARNING_DATE: "Огоҳлантириш санаси",
          COURT_DATE: "Судга ўтказиш санаси",
          SUM: "Огоҳлантириш суммаси",
          DEBT_RANGE: "Салдо бошига қарз оралиги",
          USER_CREATED_DATE: "Яратилган",
          USER_UPDATE: "Ўзгартирган фойдаланувчи",
          USER_UPDATE_DATE: "Ўзгартирилган сана",
        },
        STATUS_OPTION: {
          CANCELLED: "Бекор қилинган",
          NOTIFIED: "Хабар қилинган",
          NEW: "Оголантириш яратилди",
          WARNED: "Огоҳлантирилди",
          DOCUMENT_PREPARATION: "Суд ҳужжатларини расмийлаштириш",
          DOCUMENTS_FORMALIZED: "Суд учун ҳужжатлари тайёр",
          DOCUMENTS_SENT: "Ҳужжатлар судга юборилди",
          COURT_DECISION: "Суд қарори киритилди",
          MIB_EXECUTION: "Ижрога қаратилган",
          DEBT_PAID: "Қарз тўлиқ тўланган",
        },
        DETAILS: {
          BUTTON_TITLE: "Тафсилотлар",
          TITLE: "Тафсилотлар",
          NAME: "Ф.И.Ш:",
          PERSONAL_ACCOUNT: "Ҳисоб рақам:",
          AMOUNT_OWED: "Тўланиши керак бўлган миқдор",
          TIME_DEBT: "Қарз муддати",
          NUMBER_RESIDENT: "Яшовчилар сони",
          LEFT: "Қолдиқ",
          MADE_PAYMENT: "Тўлов амалга оширилди",
          ADDRESS: "Манзил",
          ACTION: " Ҳаракатлар",
          BUTTON_FILE: "Файл",
          BUTTON_PAYMENTS: "Тўловлар",
          BUTTON_HISTORY: "Суд тарихи",
          BUTTON_ENTRY_ORDER: "Суд қарорини киритинг",
          WARNING_FILE: "Огоҳлантириш файли",
          JUDGMENT_FILE: "Суд ҳужжатлари",
          SENDING_FILE: "Файлларни судга юбориш",
          SEND_TO_COURT: " Судга юбориш",
        },
        MODAL: {
          TITLE: "Суд қарорини киритиш",
          LOAD_FILE: "Суд қарорини юклаш",
          COMMENT: "Изоҳ",
          TOAST_SUCCESS: "Суд қарори муваффақиятли сақланди!",
          TEXT: "Ушбу ҳужжат қарздорлик бўйича ўтказилган суд мажлисининг якуний қарори ҳисобланади!",
        },
        MODAL_FILE: {
          TITLE: "Файл қўшиш",
          TYPE_FILE: "Файл турини танланг",
          FILE_BUTTON: "Файл бириктиринг",
          COMMENT: "Изоҳ",
          TOAST_SUCCESS: "Файл муваффақиятли қўшилди!",
        },
        TABLE_HEADERS_PAYMENT: {
          ID: "ID",
          STATUS: "Ҳолат",
          PAYMENT: "Тўлов",
          PAYMENT_DATA: "Тўлов санаси",
          NOTE: "Изоҳ",
        },
        TABLE_HEADERS_HISTORY: {
          ID: "ID",
          CHANGE_FIELD: "Ўзгартирилган майдон",
          STATUS: "Ҳолат",
          FROM: "Дан",
          TO: "Гача",
          NOTE: "Эслатма",
        },
        CONTRACT_MAHALLA: "Маҳалла шартномаси",
      },
      EMPLOYEES_ACTIONS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Ходим Ф.И.Ш",
          OPERATION_DATE: "Операция санаси",
          SUBSCRIBER_NAME: "Aбонентнинг Ф.И.Ш",
          PERSONAL_ACCOUNT: "Шахсий ҳисоб",
          JOB_TYPE: "Иш турлари",
          COMPANY_NAME: "Корхона номи",
          CHANNEL: "Канал",
          WAS: "Эди",
          BECAME: "Бўлди",
          ACTION: "Ҳаракат",
        },
      },
      FROZEN_DEBT_ACTS: {
        TABLE_HEADERS: {
          ID: "ID",
          COMPANY_NAME: "Корхона номи",
          ACCOUNT_NUMBER: "Ҳисоб рақами",
          NAME: "Ф.И.Ш",
          NUMBER_RESIDENT: "Яшовчилар сони",
          DATA_FILE: "Aкт санаси",
          STATUS: "Ҳолат",
          SUM: "Тўлов сўндириш(сумма)",
          DEBT_SUM: "Қарздорлик сўндириш(сумма)",
          ACT_SUMMA: "Актни сўндириш(сумма)",
          ACT_NUMBER: "Aкт рақами",
          ACT_COMMENTARY: "Aкт изоҳи",
          // DETAILS_ACT: "Ҳужжат тафсилотлари",
          FILES: "Бириктирилган файллар",
          USER: "Фойдаланувчи",
          PAY_SUM: "Тўловдан сумма",
          INCOME_SUM: "Тушумдан сумма",
          ACT_SUM: "Актлардан сумма",
          ACTION: "Ҳаракат",
        },
        MODAL: {
          TITLE: "Абонентлар",
          START_SALDO: "Музлатилган қарздорлик салдо боши: ",
          END_SALDO: "Музлатилган қарздорлик салдо охири: ",
          ACT: "Музлатилган қарздорлик акти: ",
          ADDRESS: "Манзил: ",
          ALL_FROZEN_DEBT: "Жами Музлатилган қарздорлик тўлови: ",
          ALL_DEBT_ACTS: "Жами Қарздорлик акти: ",
          SUMMA: "Қарздорлик сўндириш(сумма): ",
          EXCEL_TITLE: "Музлатилган қарздорликлар {{date}}",
        },
        FILTER: {
          BUTTON_FILTER: "Қарздорлик",
          TITLE_COMPANY: "Маълумот",
          TITLE_AKT: "Қарз ҳақида маълумот",
        },
      },
      NOTIFICATION_RESTRICTIONS: {
        TABLE_HEADERS: {
          ID: "ID",
          COMPANY_NAME: "Компания номи",
          DISTRICT_NAME: "Туман",
          PERIOD: "Давр",
        },
        MODAL: {
          ID: "ID",
          DATA: "Маълумот",
          COMPANY_NAME: "Компания номи",
          YEAR: "Йил",
          MONTH: "Ой",
          SMS_QUANTITY: "СМС миқдори",
          AMOUNT: "Сумма",
          AMOUNT_FROM: "Баланс (дан)",
          AMOUNT_TO: "Баланс (гача)",
          NOTIFICATION_LIMIT_COUNT: "Хабарлар чекловчи миқдори",
          REGISTRATION_NOTIFICATION_COUNT: "Рўйхатдан ўтиш хабарлари миқдори",
          ANOTHER_NOTIFICATION_COUNT: "Бошқа хабарлар миқдори",
          CAUTION_COUNT: "Огоҳлантиришлар миқдори",
          DELETE_MODAL_SUBTITLE:
            "Ҳақиқатан ҳам танланган хабар чекловчини тизимдан олиб ташламоқчимисиз?",
          DELETE_MODAL: "Хабар чекловчини ўчириш",
          EDIT_MODAL_TITLE: "Хабар чекловчини таҳрирлаш",
        },
        FILTER: {},
      },
      MUNIS: {
        TABLE_HEADERS: {
          ID: "ID",
          PERIOD: "Давр",
          COMPANY_NAME: "Корхона номи",
          ACCOUNT_NUMBER: "Ҳисоб рақами",
          DOCUMENT_NUMBER: "Хужжат рақами",
          DOCUMENT_DATE: "Хужжат вақти",
          DAY_PAYMENT: "Тушган куни",
          TIME_PAYMENT: "Тўлов вақти",
          SUMMA: "Сумма (сўм)",
          RESIDENT_FIO: "Абонент Ф.И.Ш",
          SEND_MFO: "Юборувчи МФО",
          SELF_MFO: "Қабул қилувчи МФО",
          HASH: "HASH",
          TRANSACTION_ID: "Транзакция ID",
          X_R: "Юборувчи ҳисоб рақами",
          X_Q: "Қабул қилувчи ҳисоб рақами",
          INN: "Корхона СТИР",
          OWN_INN: "СТИР (ўзининг)",
          MAHALLA_NAME: "Маҳалла",
          STREET_NAME: "Кўча",
          HOME_NUMBER: "Уй",
          FLAT_NUMBER: "Кв",
          NAME: "Номи",
          BANK_ID: "БАНК  ID",
          KVITANTSIYA: "Квитанция ID",
          SYSTEM_ID: "Тизим ID",
          PURPOSE: "Мақсади",
          CODE: "Коди",
          DELETE: "Ҳолат",
        },
        PLACEHOLDER_COMPANY_NAME: "Корхона номи",
        DOWNLOAD_EXCEL_TITLE: "Мунис тўловлар",
        STATUS: {
          SUCCESS: "Муваффақиятли",
          DELETE: "Ўчирилган",
          ERROR_FILE: "Файл юклашда хатолик",
          CREATED: "Яратилди",
          SURCHARGES_ARE_AVAILABLE_DURING_PROCESSING: "Ортиқча тўлов мавжуд",
        },
        PREVIOUS_AMOUNT: "Олдинги сумма",
        AMOUNT: "Сумма",
      },

      FREEZING_MAHALLA: {
        TABLE_HEADERS: {
          MAHALLA_ID: "Маҳалла ID",
          MAHALLA_NAME: "Маҳалла номи",
          START_FROZEN_DATE: "Бошлангич давр",
          REGION: "Вилоят",
          DISTRICT: "Туман",
          COMPANY_NAME: "Корхона номи",
          PERIOD: "Давр",
          FILE_NAME: "Файл номи",
          DESCRIPTION: "Изоҳ",
          STATUS: "Ҳолат",
          ACTIVE: "Музлатилган",
          CANCELED: "Бекор қилинган",
          WAITING: "Кутилмоқда",
          FINISHED: "Тугатилган",
        },
        FORMS: {
          SELECT_MAHALLA: "Маҳаллани танланг",
          MAHALLA_NAME: "Маҳалла номи",
          START_FROZEN_DATE: "Бошлангич давр",
          END_FROZEN_DATE: "Тугаш даври",
          FILE: "Файл",
          DESCRIPTION: "Музлатиш асоси",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Маҳаллани музлатиш",
          EDIT_MODAL_TITLE: "Музлаган маҳаллани таҳрирлаш",
        },
        CONFIRMATION: {
          CANCEL_TITLE: "Маҳаллани музлатишни бекор қилиш",
          CANCEL_TEXT:
            "Сиз ҳақиқатан ҳам маҳаллани музлатишни бекор қилмоқчимисиз?",
          FINISHED_TITLE: "Маҳаллани музлатиш даврини тугатиш",
          FINISHED_TEXT:
            "Сиз ҳақиқатан ҳам маҳаллани музлатиш даврини тугатмоқчимисиз?",
          FINISHED_WARNING:
            "Ушбу маҳалладаги абонентлар учун кейинги даврдан тўлов ҳисоблаш бошланади!",
          DELETE_TITLE: "Маҳаллани музлатиш тугатилган даврни ўчириш",
          DELETE_TEXT:
            "Сиз ҳақиқатан ҳам ушбу маҳалла учун музлатиш даврини ўчирмоқчимисиз?",
        },
      },

      FROZEN_RESIDENTS: {
        DELETE_TITLE: "Музлатиш даври тугатилган абонентни ўчириш",
        DELETE_TEXT:
          "Сиз ҳақиқатан ҳам ушбу абонент учун музлатиш даврини ўчирмоқчимисиз?",
      },

      FREEZING_STREETS: {
        ADD_MODAL_TITLE: "Кўчани музлатиш",
        CONFIRMATION_FINISHED_TITLE: "Кўчани музлатишни бекор қилиш",
      },

      COMPARATIVE_DATA: {
        TITLE: "Маълумотларни таққослаш",
        TITLE_1: "ИИБ базасидаги маълумотлар",
        TITLE_2: "Кадастр базасидаги маълумотлар",
        TITLE_3: "ҲЭТ базасидаги маълумотлар",
        WARNING_MESSAGE: "Ушбу абонентнинг кадастр рақами киритилмаган!",
        INVALID_SOATO_NUMBER: "Абонентнинг CОАТО рақами нотўғри!",
        COLUMNS: {
          DATA: "Маълумотлар",
          IN_THE_BASE: "Базада",
          SYSTEM: "Тизимда",
          PROTSENT: "Фоиз",
          ACTIONS: "Ҳаракат",
        },
        TABLE_COLUMNS: {
          CADASTRAL_NUMBER: "Кадастр рақами",
          INHABITANT_CNT: "Яшовчилар сони",
          PNFL: "ЖШШИР",
          PASSPORT: "Паспорт",
          LAST_NAME: "Фамилия",
          FIRST_NAME: "Исм",
          PATRONYMIC: "Отасининг исми",
          ADDRESS: "Манзил",
        },
        TABLE_COLUMNS2: {
          CADASTRAL_NUMBER: "Кадастр рақами",
          STREET_NAME: "Кўча номи",
          HOME_NUMBER: "Уй рақами",
          MAHALLA_NAME: "Маҳалла номи",
          OWNER_OF_THE_HOUSE: "Уй эгаси",
          PASSPORT_NUMBER: "Паспорт рақами",
          INN: "СТИР",
          PNFL: "ЖШШИР",
          EDIT_FULL_ADDRESS: "Манзилни таҳрирлаш",
        },
      },

      CADASTR_PUSH: {
        NAME: "Номи",
        CREATED_AT: "Яратилган сана",
        TRANSACTION_CODE: "Транзаксия коди",
        ORIGIN: "Манба",
        OLD_CAD_NUM: "Эски кадастр рақами",
        CAD_NUM: "Кадастр рақами",
        REGION_NAME: "Вилоят",
        DISTRICT_NAME: "Туман",
        MAHALLA_NAME: "Маҳалла",
        STREET_NAME: "Кўча",
        HNUM_TYPE: "Уй рақами тури",
        HNUM: "Уй рақами",
        KNUM_TYPE: "Кадастр рақами тури",
        HOST_PART: "Улуш",
        HOST_PARTY_TYPE_CODE: "Томон коди",
        HOST_PARTY_TYPE_DESCRIPTION: "Томон тавсифи",
        LAND_FUND_TYPE: "Ер фонди тури",
        LAND_USE_TYPE: "Ер фойдаланиш тури",
        LEGAL_TYPE: "Ҳуқуқий тури",
      },
    },
    LEASING: {
      STATISTICS: {
        TITLE: "Статистика",
        BY_REGIONS: {
          TITLE: "Вилоятлар бўйича лизинг шартномалари сони",
          CONTRACTS_COUNT: "Лизинг шартномалари сони",
        },
        BY_STATUS: {
          TITLE: "Статус бўйича лизинг шартномалари сони",
        },
        BY_YEARLY: {
          TITLE: "Давр бўйича лизинг шартномалари сони",
        },
        BY_MONTHLY: {
          TITLE: "Ойлар бўйича",
        },
        INFO_CARD: {
          TITLE: "Маълумотлар",
        },
        BY_PRICE: {
          TITLE: "Нарх бўйича",
        },
      },
      SUB_MENU: {
        TECHNIQUES_TITLE: "Техника ва жиҳозлар",
        DOCUMENT_TYPES_TITLE: "Ҳужжат тури",
        CONFIGURATIONS_TITLE: "Созламалар",
        PROCESS_TITLE: "Лизинг жараён",
        PAYMENT_LIST_TITLE: "Тўловлар рўйхати",
        LEASING_INFO_TITLE: "Лизинг",
      },
      APROVE_LEASING: "Сиз ҳақиқатан ҳам шу лизингни тасдиқламоқчимисиз?",
      TECHNIQUES: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Номи",
          DETAIL: "Тафсилотлар",
        },
        MODAL: {
          PRICE: "Нархи",
          USD_PRICE: "USD нархи ($)",
          UZS_PRICE: "UZS нархи (сўм)",
          DESCRIPTION: "Изоҳ",
          WITH_QQS: "ҚҚС билан",
          WITHOUT_QQS: "ҚҚСсиз",
          QQS: "ҚҚС",
          DELETE_MODAL_SUBTITLE:
            "Сиз ҳақиқатан ҳам танланган техникани тизимдан олиб ташламоқчимисиз?",
        },
      },
      DOCUMENT_TYPE: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Номи",
          DESCRIPTION: "Изоҳ",
        },
        null: "Танланган",
        CREATED: "Танланган",
        UPLOADED: "Текширишга тайёр",
        APPROVED: "Тасдиқланган",
        REJECTED: "Рад этилган",

        MODAL: {
          DOCUMENT_ADD: "Ҳужжат турини қўшиш",
          DOCUMENT_REMOVE: "Ҳужжат турини ўчириш",
          DOCUMENT_UPDATE: "Ҳужжат турини таҳрирлаш",
          DOCUMENT_ADD_CONFIRMATION: "Киритилган ҳужжат қўшилмаган",
          TITLE_DELETE: "Ҳужжат турини ўчириш",
          DELETE_MODAL_SUBTITLE:
            "Сиз ҳақиқатан ҳам танланган ҳужжат турини тизимдан олиб ташламоқчимисиз?",
          APROVE_DOCUMENT: "Сиз ҳақиқатан ҳам шу ҳужжатни тасдиқламоқчимисиз?",
          REJECT_DOCUMENT: "Сиз ҳақиқатан ҳам шу ҳужжатни рад этмоқчимисиз?",
          NAME_UZ: "Номи (UZ):",
          NAME_RU: "Номи (РУ):",
          NAME_CRL: "Номи (УЗ):",
          NAME_EN: "Номи (EN):",
          COMMENTARY_UZ: "Изоҳ (UZ)",
          COMMENTARY_RU: "Изоҳ (РУ)",
          COMMENTARY_CRL: "Изоҳ (УЗ)",
        },
      },
      CONFIGURATION: {
        LEASING_CONTRACT: "Лизинг шартномаси",
        UPDATE_LEASING_CONTRACT_UZS: "Лизинг шартномасини таҳрирлаш",
        UPDATE_LEASING_CONTRACT_USD: "Лизинг валюта ($) шартномасини таҳрирлаш",
        ORGANIZATION_INFO: "Ташкилот маълумотлари",
        ORGANIZATION_NAME: "Ташкилот номи",
        ORGANIZATION_ADDRESS: "Ташкилот манзили",
        BANK_CONFIG_TITLE: "Банк маълумотлари",
        BANK_NAME: "Банк номи",
        STIR: "Банк STIR",
        BANK_MFO: "Банк МФО",
        LEASING_INFO: "Лизинг маълумотлари",
        LEASING_PERIOD: "Лизинг муддати (ой)",
        LEASING_GRACE: "Имтиёзли муддат (ой)",
        YEARLY_WARRANTY: "Кафолат муддати (ой)",
        KM_WARRANTY: "Масофа кафолати (км)",
        LEASING_PERCENTAGE: "Лизинг фоизи (%)",
        DOWN_PAYMENT_PERCENTAGE: "Дастлабки тўлов фоизи (%)",
        PENALTY_PAYMENT_PERCENTAGE: "Пеня фоизи (%)",
        COMMISSION_PERCENTAGE_PERCENTAGE: "Комиссион тўлов фоизи (%)",
        LEASING_PERIOD_1: "Лизинг муддати",
        LEASING_GRACE_1: "Имтиёзли муддат",
        YEARLY_WARRANTY_1: "Кафолат муддати",
        KM_WARRANTY_1: "Масофа кафолати",
        LEASING_PERCENTAGE_1: "Лизинг фоизи",
        DOWN_PAYMENT_PERCENTAGE_1: "Дастлабки тўлов фоизи",
        PENALTY_PAYMENT_PERCENTAGE_1: "Пеня фоизи",
        COMMISSION_PERCENTAGE_PERCENTAGE_1: "Комиссион тўлов фоизи",
        QQS_PERCENTAGE: "ҚҚС фоизи",
        QQS_PERCENTAGE_1: "ҚҚС фоизи (%)",

        ACCOUNT_NUMBERS: "Ҳисоб ракамлари",
        ACCOUNT_NUMBERS_PENALTY: "Пеня ҳисоб рақами",
        ACCOUNT_NUMBERS_DOWN_PAYMENT: "Дастлабки тўлов ҳисоб рақами",
        ACCOUNT_NUMBERS_USD: "AҚШ доллари учун ҳисоб рақамлари",

        EXCHANGE_RATES: "Валюта курслари",
        EXCHANGE_NAMES: "Валюта номлари",
        EXCHANGE: "Валюта",
        BUY: "Сотиб олиш",
        SELL: "Сотиш",
        USD: "1 AҚШ доллари, USD",
        EUR: "1 Евро, EUR",
        RUB: "1 Рубль, RUB",
      },
      PROCESS: {
        TABLE_HEADERS: {
          ID: "ID",
          NO: "№",
          AMOUNT: "Миқдор",
          COMMISSION: "Комиссия",
          DOWN_PAYMENT: "Дастлабки тўлов",
          LEASING_GRACE: "Имтиёзли муддат",
          LEASING_PERCENTAGE: "Лизинг фоизи",
          LEASING_PERIOD: "Лизинг муддати",
          PENALTY_PAYMENT: "Пеня",
          STATUS: "Ҳолат",
          APPLICATION_CREATED: "Мурожаат яратилди",
          IN_DOC_GATHERING: "Ҳужжатлар йиғилмоқда",
          CHECKING_DOCUMENTS: "Ҳужжатлар текширилмоқда",
          REJECTED_BY_CENTER: "Марказ томонидан рад этилди",
          APPROVED_BY_CENTER: "Марказ томонидан тасдиқланди",
          REJECTED_BY_DIRECTOR: "Директор томонидан рад этилди",
          WAITING_DECISION: "Қарор кутилмоқда",
          CONTRACT_APPROVED: "Ҳужжатлар тасдиқланди",
          CONTRACT_AGREED: "Шартнома учун тасдиқланган",
          CONTRACT_REJECTED: "Ҳужжатлар рад этилди",
          IN_PAYMENT_PERIOD: "Тўлов жараёнида",
          CLOSED: "Ёпилди",
          SUBMITTED_DOCUMENTS: "Топширилган ҳужжатлар",
          REVIEW: "Кўриб чиқилмоқда...",
          MORTAGAGED_PROPERTY: "Гаровга қўйилган мулк ҳақида",

          PRINCIPAL_DEBT: "Лизинг қарздорлиги қолдиғи",
          PRINCIPAL_REPAYMENT: "Aсосий қарз сўндирилиши",
          PERCENTAGE_REPAYMENT: "Фоизлар",
          DAYS_OF_MONTH: "Кунлар",
          TOTAL_MONTHLY_REPAYMENT: "Жами",
          DATE: "Сана",
        },
        MODAL: {
          PROCESS_ADD: "Лизинг қўшиш",
          PROCESS_EDIT: "Лизингни таҳрирлаш",
          TITLE_DELETE: "Лизингни ўчириш",
          DOWN_PAYMENT: "Дастлабки тўлов",
          COMPANY: "Корхона номи",
          AMOUNT: "Миқдор",
          LEASING_PERCENTAGE: "Лизинг фоизи",
          PENALTY_PAYMENT: "Пеня",
          COMMISSION: "Комиссия",
          MESSAGE_DELETE:
            "Сиз ҳақиқатан ҳам танланган лизингни тизимдан олиб ташламоқчимисиз?",
          LEASING_PERIOD: "Лизинг муддати",
          LEASING_GRACE: "Имтиёзли муддат",
          TECHNIQUES_TITLE: "Техникалар",
          TECHNIQUES_COUNT: "Техника сони",
          LEASING_CALCULATE: "Лизингни ҳисоблаш",
          CALCULATE: "Ҳисоблаш",
          PROCESS_DOCUMENT_REQUIREDMENTS: "Керакли ҳужжатлар",
          GO_SELECTED_DOCS:
            "Танланган ҳужжатларга қайтмоқчимисиз (юкланган ҳужжатлар ўчиб кетади)?",
          LIZING_INFO:
            "Aгарда сиз лизингни умумий қийматидан 10% ли олдиндан тўлов амалга оширмасангиз, у ҳолда лизингни умумий бахосини 10% дан кам бўлмаган миқдорда мулкни гаровга қўйишингиз шарт!",
          DIRECTOR: "Раҳбар:",
          PRIMARY_CHECK_STATUS: "Бирламчи текширув",
          DIRECTOR_CHECK_STATUS: "Лизинг комиссиясига юбориш",
          COMMISSION_CHECK_STATUS: "Комиссия баёноти",
          STATEMENT_LABEL: "Баённома",
          STATEMENT_EXTRACT_LABEL: "Баённомадан кўчирма",
          TERMS_OF_LEASING: "Лизинг шартлари",
          CONCLUSION_LABEL: "Хулоса",
          LEASING_DOCUMENTS_LIST:
            "Компания лизинг учун тақдим этиши керак бўлган ҳужжатлар рўйхати",
          MY_TASKS: "Менинг вазифаларим",
          CONTRACT_DATE: "Шартнома санаси",
          BRANCH_DIRECTOR_FIO: "Филиал директори Ф.И.Ш",
          FIRST_PAYMENT_DATE: "Биринчи тўлов санаси",
        },
        CALCULATION_TABLE: {
          YEAR: "йил",
          LEARNING_COUNT_DOC:
            "Лизинг тўловларини амалга ошириш графиги ({{count}} дона техника)",
          LEASING_PRICE: "Лизинг умумий миқдори",
          LEASING_DOWN_PAYMENT_PERCENTAGE: "Олдиндан тўлов",
          PERCENT: "Фоиз ставка",
          LEASING_GRACE: "Имтиёзли давр",
          LEASING_DEBT: "Лизинг қарздорлиги",
          FIRST_COMMISION_PAYMENT: "Бир маротобалик комиссион тўлов",
          TOTAL: "Жами",
        },
      },
      PAYMENT_LIST_TITLE: {
        TABLE_HEADERS: {
          ID: "ID",
          PENALTY_PAYMENT: "Пеня",
          LEASING_ID: "Лизинг ID",
          PERIOD: "Давр",
          PERCENTAGE_PAYMENT: "Фоизлар",
          MAIN_DEBT: "Асосий қарз",
          MONTHLY_PAYMENT: "Ойлик тўлов",
          PAID_DATE: "Тўланган сана",
          PAYMENT_RECEIPT_FILE: "Квитансия файли",
          DESCRIPTION: "Изоҳ",

          PAYMENT_AMOUNT: "Тўлов суммаси",
          PAID_AT: "Тизимга киритилган вақт",
        },
        MODAL: {
          ADD_TITLE: "Тўлов қўшиш",
          UPDATE_TITLE: "Тўловни таҳрирлаш",
          DELETE_TITLE: "Тўловни ўчириш",
          PAYMENT: "Сумма:",
          PAID_DATE: "Тўланган сана:",
          PAYMENT_RECEIPT: "Квитансия файли:",
          IS_USD: "Ақш доллари:",
          DESCRIPTION: "Изоҳ:",
        },
      },
    },
    ERROR_PAGE: {
      NOT_FOUND_TITLE: "Саҳифа топилмади!",
      RETURN_HOME: "Бош саҳифа",
      SYSTEM_ERROR: "Серверда хатолик юз берди!",
      ACCESS_LIMITED: "Кириш чекланган!",
    },
    DATEPICKER: {
      WEEKDAYS_SHORT: ["Ду", "Се", "Чор", "Пай", "Жу", "Шан", "Як"],
      MONTHS: [
        "Январ",
        "Феврал",
        "Март",
        "Апрел",
        "Май",
        "Июн",
        "Июл",
        "Август",
        "Сентябр",
        "Октябр",
        "Ноябр",
        "Декабр",
      ],
      WEEK: "Ҳафта",
      MONTH: "Ой",
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: "Танланган ёзувлар сони: ",
        ALL: "Ҳаммаси",
        SUSPENDED: "Тўхтатилди",
        ACTIVE: "Фаол",
        FILTER: "Филтр",
        BY_STATUS: "Статус бўйича",
        BY_TYPE: "Статус бўйича",
        BUSINESS: "Бизнес",
        INDIVIDUAL: "Индивидуал",
        SEARCH: "Қидирмоқ",
        IN_ALL_FIELDS: "барча соҳаларда",
      },
      ECOMMERCE: "электрон тижорат",
      CUSTOMERS: {
        CUSTOMERS: "Харидорлар",
        CUSTOMERS_LIST: "Мижозлар рўйхати",
        NEW_CUSTOMER: "Янги мижоз",
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: "Мижозни ўчириш",
          DESCRIPTION: "Бу мижозни бутунлай ўчириб ташламоқчимисиз?",
          WAIT_DESCRIPTION: "Мижоз ўчириб ташланмоқда...",
          MESSAGE: "Мижоз ўчирилди",
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: "Мижозларни ўчириш",
          DESCRIPTION: "Танланган мижозларни бутунлай ўчириб ташламоқчимисиз?",
          WAIT_DESCRIPTION: "Мижозлар ўчириб ташламоқда...",
          MESSAGE: "Танланган мижозлар ўчириб ташланди",
        },
        UPDATE_STATUS: {
          TITLE: "Танланган мижозлар учун ҳолат янгиланди",
          MESSAGE: "Танланган мижозлар ҳолати муваффақиятли таҳрирланди",
        },
        EDIT: {
          UPDATE_MESSAGE: "Харидор янгиланди",
          ADD_MESSAGE: "Харидор яратилди",
        },
      },
    },
    GENERAL: {
      RECEIPT_ISSUERS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Номи",
          COMPANY_NAME: "Корхона номи",
        },
        MODAL: {
          TITLE_SAVE: "Янги квитанция берувчи қўшиш",
          TITLE_UPDATE: "Квитанция берувчини таҳрирлаш",
          COMPANY: "Корхона:",
          NAME_UZ: "Номи (UZ)",
          NAME_RU: "Номи (РУ)",
          NAME_CRL: "Номи (УЗ)",
          NAME_EN: "Номи (EN)",
          CONFIRMATION_MODAL_TEXT:
            "Танланган квитанция берувчини географиянгиздан олиб ташламоқчимисиз?",
          TOAST_SUCCESS: "Танланган квитанция берувчи муваффақиятли қўшилди!",
          TOAST_DELETE: "Танланган квитанция берувчи муваффақиятли ўчирилди !",
          TOAST_UPDATE:
            "Танланган квитанция берувчи муваффақиятли таҳрирланди!",
        },
      },
    },
    NOTIFICATIONS: {
      TABLE_HEADERS: {
        ID: "ID",
        NAME: "Номи",
      },
      MODAL: {
        EXCEL_TITLE: "Ҳабарнома маълумотлари {{date}}.xls",
        MODAL_TITLE: "Янги хабарнома қўшиш",
        UPDATE_MODAL: "Хабарномани таҳрирлаш",
        DELETE_MODAL: "Хабарномани ўчириш",
        DELETE_MODAL_SUBTITLE:
          "Сиз ҳақиқатан ҳам танланган хабарномани тизимдан олиб ташламоқчимисиз?",
      },
    },
    GEOGRAPHY: {
      MODAL_BUTTON: {
        ADD_BUTTON: "Сақлаш",
        CANCEL: "Бекор қилиш",
        SOATO: "СОАТО коди",
      },
      REGIONS: {
        CAB_TAB_1: "Ўзбек тили",
        CAB_TAB_2: "Кирилл",
        CAB_TAB_3: "Рус тили",
        TABLE_HEADERS: {
          NUMBERS: "№",
          ID: "ID",
          NAME: "Номи",
          CREATE_DATE: "Яратилган санаси",
          CADASTRAL_CODE: "Кадастр коди",
        },
        MODAL: {
          MODAL_TITLE: "Вилоят қўшиш",
          UPDATE_MODAL: "Вилоятни таҳрирлаш",
          DELETE_MODAL: "Вилоятни ўчириш",
          DELETE_MODAL_SUBTITLE:
            "Сиз ҳақиқатан ҳам танланган вилоятни тизимдан олиб ташламоқчимисиз?",
          NAME_UZ: "Номи (UZ):",
          NAME_RU: "Номи (РУ):",
          NAME_CRL: "Номи (УЗ):",
          NAME_EN: "Номи (EN):",
          TOAST_DELETE: "Танланган вилоят муваффақиятли ўчирилди!",
          TOAST_SUCCESS: "Янги вилоят муваффақиятли қўшилди!",
          TOAST_UPDATE: "Вилоят муваффақиятли таҳрирланди!",
        },
      },
      DISTRICTS: {
        TABLE_HEADERS: {
          ID: "ID",
          REGION: "Вилоят",
          NAME: "Номи",
          CREATOR: "Яратган фойдаланувчи",
          CREATED_AT: "Яратилган сана",
        },
        MODAL: {
          TITLE_SAVE: "Туман қўшиш",
          TITLE_UPDATE: "Туманни таҳрирлаш",
          TITLE_DELETE: "Туманни ўчириш",
          DELETE_MODAL_SUBTITLE:
            "Сиз ҳақиқатан ҳам танланган туманни тизимдан олиб ташламоқчимисиз?",
          NAME_UZ: "Номи (UZ):",
          NAME_RU: "Номи (РУ):",
          NAME_CRL: "Номи (УЗ):",
          NAME_EN: "Номи (EN):",
          TOAST_DELETE: "Танланган туман муваффақиятли ўчирилди!",
          TOAST_SUCCESS: "Янги туман муваффақиятли қўшилди!",
          TOAST_UPDATE: "Туман муваффақиятли таҳрирланди!",
        },
        IMPORT: {
          BUTTON: "Импорт",
          MODAL_TITLE: "Туманлар статистикасини импорт қилиш",
          INFO_TITLE: "Маълумот",
          INFO_DESCRIPTION:
            "Туманлар статистикаси учун қўшимча маълумотларни киритиш. Фақат Excel форматидаги файллар қабул қилинади.",
          DOWNLOAD_TEMPLATE: "Намуна файлни юклаб олиш",
          SELECT_FILE: "Excel файлни танланг",
        },
      },
      VILLAGES: {
        INFO: "Сариқ рангли қатордаги маҳалланинг координаталари йўқ!",
        FROZEN_INFO: "Кўк рангли қатордаги маҳалла музлатилган!",
        FILTER_BTN: "Сариқ қаторлар",
        LEGAL_INFO:
          "Сариқ рангли қаторлардаги юридик абонентлар ҳудуди киритилмаган!",
        MODAL: {
          TITLE_SAVE: "Маҳалла қўшиш",
          TITLE_UPDATE: "Маҳаллани таҳрирлаш",
          TITLE_DELETE: "Маҳаллани ўчириш",
          DELETE_MODAL_SUBTITLE:
            "Сиз ҳақиқатан ҳам танланган маҳаллани тизимдан олиб ташламоқчимисиз?",
          COMPANY: "Корхона номи",
          GPS_BASED: "GPS асосида",
          DEFAULT: "Одатий",
          MONTHLY_TRIPS_NUMBER: "Ойлик қатновлар сони",
          MIN_MILAGE: "Ўтилиши керак бўлган минимум масофа (км)",
          MIN_DURATION_IN: "Mинимум маҳаллада бўлиш вақти (минут)",
          MIN_MOVING_DURATION: "Mинимум ҳаракат вақти (минут)",
          AFFECT_ON_VISIT: "Ташриф бўлганда начисленияга таъсир қилиш",
          ACTUAL_BALANCE_CALCULATE_INDICATOR:
            "GPS орқали ҳисобланган суммани жорий қилиш",
          MIN_STOPS_COUNT: "Mинимум тўхташлар сони",
          MAX_AVERAGE_SPEED: "Максимум ўртача тезлик (км/соат)",
          ACCURAL_TYPE: "Ҳисоб-китоб тури",
          SECTOR_TYPE: "Сектор тури",
          FIRST_SECTOR: "1-сектор",
          SECOND_SECTOR: "2-сектор",
          THIRD_SECTOR: "3-сектор",
          FOURTH_SECTOR: "4-сектор",
          UNASSIGNED: "Тайинланмаган",
          NAME_UZ: "Маҳалла номи (UZ)",
          NAME_RU: "Маҳалла номи (РУ)",
          NAME_CRL: "Маҳалла номи (УЗ)",
          COMMENTARY_UZ: "Изоҳ (UZ)",
          COMMENTARY_RU: "Изоҳ (РУ)",
          COMMENTARY_CRL: "Изоҳ (УЗ)",
          WARNING_TITLE:
            "Ушбу маҳалла ҳудудларга эга бўлганлиги сабабли, баъзи майдонларни тўлдириш шарт эмас!",
          CHECKING_TITLE: "Маҳалланинг ҳудудга эгалиги текширилмоқда...",
          GPS_ACCRUAL_CONFIRMATION_FILEID:
            "Маҳаллани GPS бўйича начисление қилиш учун асос файл",
          MAHALLA_FILE: "Маҳаллани яратиш учун асос файл",
          GPS_ACCRUAL_START_DATE: "GPS ҳисоблаш бошланиш санаси",
        },
      },
      STREETS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Номи",
          COMMENTARY: "Изоҳ",
        },
        MODAL: {
          TITLE_SAVE: "Кўча қўшиш",
          TITLE_UPDATE: "Кўчани таҳрирлаш",
          TITLE_DELETE: "Кўчани ўчириш",
          DELETE_MODAL_SUBTITLE:
            "Сиз ҳақиқатан ҳам танланган кўчани тизимдан олиб ташламоқчимисиз?",
          NAME_UZ: "Кўча номи (UZ)",
          NAME_RU: "Кўча номи (РУ)",
          NAME_CRL: "Кўча номи (УЗ)",
          COMMENTARY_UZ: "Изоҳ (UZ)",
          COMMENTARY_RU: "Изоҳ (РУ)",
          COMMENTARY_CRL: "Изоҳ (УЗ)",
          TOAST_DELETE: "Танланган кўча муваффақиятли ўчирилди!",
          TOAST_SUCCESS: "Янги кўча муваффақиятли қўшилди!",
          TOAST_UPDATE: "Кўча муваффақиятли таҳрирланди!",
        },
      },
      SELECT_INPUT: {
        COMPANY_NAME: "Корхона номи",
        INSPECTOR_FULLNAME: "Назоратчи Ф.И.Ш",
      },
      POLYGON: {
        SYNC_UP: "Синхронлаш",
        SUCCESS: "Муваффақиятли",
        MODAL_TITLE: "Майдонни таҳрирлаш",
        TABLE_HEADERS: {
          NAME: "Номи",
          DESCRIPTION: "Изоҳ",
        },
      },
      WASTE_COLLECTION_AREA: {
        WASTE_COLLECTION_AREA_EXEL_TITLE: "ЧЙМга бириктирилган абонентлар",
        TABLE_HEADERS: {
          NAME: "Номи",
          STREET_NAME: "Кўча номи",
          CADASTRAL_NUMBER: "Кадастр рақами",
          LATTITUDE: "Кенглик",
          LONGITUDE: "Узунлик",
          BOX_COUNT: "Қутилар сони",
          DESCRIPTION: "Изоҳ",
        },
        FORMS: {
          VILLAGE: "Маҳалла",
          STREET: "Кўча",
          NAME: "Номи",
          CADASTRAL_NUMBER: "Кадастр рақами",
          LATTITUDE: "Кенглик",
          LONGITUDE: "Узунлик",
          BOX_COUNT: "Қутилар сони",
          DESCRIPTION: "Изоҳ",
          MINIMUM_TIME: "ЧЙМда минимал бўлиш вақти (минут)",
          BOXES: "Қутилар",
          SIZE: "Ҳажми",
          COUNT: "Сони",
          AFFECT_ON_VISIT: "Ташриф бўлганда начисленияга таъсир қилиш",
          WASTE_COLLECTION_AREA_RADIUS: "Чиқинди йиғиш ҳудуди радиуси",
          MINIMUM_TIME_IN_MINUTES: "ЧЙМ да минимал бўлиш вақти (дақиқа)",
          WASTE_SORT_AVAILABLE:
            "Саралаб йиғишга мўлжалланган чиқинди йиғиш майдончаси",
          NUMBER_OF_TRIPS: "Қатновлар сони",
        },
        MODAL: {
          TITLE_SAVE: "Майдон қўшиш",
          TITLE_UPDATE: "Майдонни таҳрирлаш",
          TITLE_DELETE: "Майдонни ўчириш",
          ADD_WCA_VIA_FILE_IMPORT: "Импорт орқали қўшиш",
          DELETE_MODAL_SUBTITLE:
            "Сиз ҳақиқатан ҳам танланган майдонни тизимдан олиб ташламоқчимисиз?",
          NUMBER_OF_TRIPS: "Қатновларни сони таҳрирлаш",
        },
      },
      WCA_BINDING_RESIDENTS: {
        TABLE_HEADERS: {
          RESIDENT_ID: "Абонент ID",
          FIRST_NAME: "Исм",
          LAST_NAME: "Фамилия",
          PATRONYMIC: "Отасининг исми",
          ACCOUNT_NUMBER: "Хисоб рақами",
          MAHALLA_NAME: "Маҳалла номи",
          STREET_NAME: "Кўча номи",
          HOME_NUMBER: "Уй рақами",
          FLAT_NUMBER: "Квартира рақами",
          HOME_INDEX: "Уй индекси",
        },
        FILTER_FORM: {
          MAHALLA: "Маҳалла",
          STREET: "Кўча",
          ACCOUNT_NUMBER: "Хисоб рақами",
          RESIDENT_ID: "Абонент ID",
          FILTER_RESIDENTS: "Абонентларни фильтрлаш",
        },
        ACTIONS: {
          BINDING_RESIDENTS: "Абонент бириктириш",
          MULTIPLE_DELETE: "Танлаб ўчириш",
          MOVE_RESIDENTS: "Абонентларни кўчириш",
        },
        MODAL: {
          TITLE: "Абонентларни чиқинди йиғиш майдонига бириктириш",
          MERGE_RESIDENTS_INTO_ANOTHER_CHYM:
            "Абонентларни бошқа чиқинди йиғиш майдонига бириктириш",
          UNBINDING_TITLE: "Бириктирилган абонентларни ўчириш",
          CONFIRM_TITLE:
            "Сиз ҳақиқатан ҳам танланган абонентларни чиқинди йиғиш майдонидан олиб ташламоқчимисиз?",
        },
      },
      VILLAGE_CLASSIFIER: {
        VILLAGES_CLASSIFIER: "Маҳаллаларни синхронлаш",
        VILLAGES_CODE_CLASSIFIER: "Маҳалла кодини синхронлаш",
        TABLE_HEADERS: {
          MAHALLA_FROM_CLASSIFIER: "Классификатордан олинган маҳалла",
          MAHALLA_FROM_TOZA_MAKON: "Тоза-макондан олинган маҳалла",
          INDEX: "Ўхшашлик индекси",
          OBJECT_ID: "Объект  ID",
          CAOTO_CODE: "Соато коди",
          NAME: "Номи",
          SELECTED_MAHALLA: "Танланган маҳаллалар",
          CLASSIFIER_REGION: "Класс.Вилоят",
          CLASSIFIER_DISTRICT: "Класс.Туман",
          VILLAGE_CODE: "Маҳалла коди",
        },
        CONFIRM_TEXT:
          "Сиз ҳақиқатан ҳам танланган маҳаллаларни синхронламоқчимисиз?",
      },
      RESIDENT_ACCRUAL: {
        TABLE_HEADERS: {
          VISIT: "Ташриф",
          DATE: "Сана",
          IN_TIME: "Кириш вақти",
          OUT_TIME: "Чиқиш вақти",
          ACCOUNT_NUMBER: "Ҳисоб рақами",
          FISH: "Ф.И.Ш",
          INHABITANT_CNT: "Яшовчилар сони",
          TARIFF: "Тариф (сўм)",
          CALCULATED: "Ҳисобланди",
          STATUS: "Ҳолати",
          MOVED: "Кўчирилган",
          UNMOVED: "Кўчирилмаган",
        },
        MODAL: {
          TITLE: "Ҳисобланган summa",
          EXCEL_TITLE: "Ҳисобланган_summa.xlsx",
          MAP_TITLE: "Ҳаракат тарихи",
        },
      },
      MAHALLA_AREA: {
        TABLE_HEADERS: {
          NAME: "Ҳудуд номи",
          VILLAGE_NAME: "Маҳалла номи",
          AFFECT_TO_BALANCE: " Ташриф бўлганда ҳисоб-китобга таъсир қилиш",
          MONTHLY_TRIPS_NUMBER: "Ойлик қатновлар сони",
          MIN_MILAGE: "Ўтилиши керак бўлган минимум масофа (км)",
          MIN_MOVING_DURATION: "Mинимум ҳаракат вақти (минут)",
          MIN_STOPS_COUNT: "Mинимум тўхташлар сони",
          MAX_AVERAGE_SPEED: "Максимум ўртача тезлик (км/соат)",
          ACTION: "Ҳаракат",
        },
        MODAL: {
          ADD_MAHALL_AREA: "Ҳудуд қўшиш",
          UPDATE_MAHALL_AREA: "Ҳудуд таҳрирлаш",
          TITLE_DELETE: "Майдонни ўчириш",
          DELETE_MODAL_SUBTITLE:
            "Сиз ҳақиқатан ҳам танланган майдонни тизимдан олиб ташламоқчимисиз?",
        },
      },
      MAHALLA_AREA_ZONE_BINDED_RESIDENTS: {
        TITLE: "Ҳудудга бириктирилган абонентлар",
        TABLE_HEADERS: {
          NAME: "Ф.И.Ш",
          ACCOUNT_NUMBER: "Ҳисоб рақами",
          STREET_NAME: "Кўча номи",
          HOME_NUMBER: "Уй рақами",
          FLAT_NUMBER: "Квартира рақами",
          HOME_INDEX: "Уй индекси",
        },
        MODAL: {
          BIND_RESIDENTS_TITLE: "Hududga abonent biriktirish",
          CONFIRMATION_MODAL_TEXT:
            "Сиз ҳақиқатан ҳам танланган абонентларни ҳудуддан олиб ташламоқчимисиз?",
        },
        ACTIONS: {
          BINDING_RESIDENTS: "Абонент бириктириш",
          MULTIPLE_DELETE: "Танлаб ўчириш",
          MOVE_RESIDENTS: "Абонентларни кўчириш",
        },
      },
      MAHALLA_AREA_ZONE_AUTOMOBILE_VISITS: {
        TITLE: "Ташрифлар",
        TABLE_HEADERS: {
          AUTOMOBILE_NUMBER: "Автомобил рақами",
          VISIT_DATE: "Ташриф санаси",
          AUTOMOBILE_NUMBER_AND_MODEL: "Автомобил рақами ва модели",
          COMPANY_NAME: "Корхона номи",
          DRIVER: "Ҳайдовчи",
          TIME_IN: "Кириш вақти",
          TIME_OUT: "Чиқиш вақти",
          DURATION_IN_TIME: "Ҳудудда бўлиш давомийлиги",
          MOVING_DURATION_IN_TIME: "Ҳаракатда бўлган вақти давомийлиги",
          PARKING_DURATION_IN_TIME: "Харакатсиз бўлган вақти давомийлиги",
          MILEAGE: "Босиб ўтган масофаси (км)",
          STOPS_COUNT: "Тўхташлар сони",
          AVG_SPEED: "Ўртача тезлик (км/соат)",
          MAX_SPEED: "Энг юқори тезлик (км/соат)",
          ON_MAP: "Харитада",
          VISIT_COUNT: "Ташрифлар сони",
        },
      },
      MAHALLA_AREA_VISIT_ANALYSIS_ROUTE: {
        TITLE: "Маҳалла ҳудудига ташрифлар таҳлили",
      },
      MAHALLA_AREA_VISIT_POINTS: {
        TITLE: "Геозона ташриф нуқталари",
        ADD_BUTTON: "Геозонага ташриф нуқталарини қўшишы",
        POINT_ASSIGNATION: "Геозонага ташриф нуқталарини белгилаш",
        CANCEL: "Бекор қилиш",
      },
    },
    SPRAVOCHNIK: {
      PAYMENT_PARTNERS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Номи",
          USERNAME: "Фойдаланувчи номи",
          IS_ACTIVE: "Ҳолати",
          TYPE: "Тури",
          COMMISSION: "Комиссия",
        },
        MODAL: {
          ONLINE: "Онлайн",
          OFLINE: "Офлайн",
          TITLE_SAVE: "Янги тўлов ҳамкорини қўшиш",
          TITLE_UPDATE: "Тўлов ҳамкорини таҳрирлаш",
          TITLE_DELETE: "Тўлов ҳамкорини ўчириш",
          NAME: "Номи:",
          USERNAME: "Фойдаланувчи номи:",
          PASSWORD: "Пароль:",
          ACCESS_TOKEN: "Яратиш",
          CONFIRMATION_MODAL_TEXT:
            " Сиз ҳақиқатан ҳам танланган тўлов ҳамкорини тизимдан олиб ташлашни хоҳлайсизми?",
          CONFIRMATION_EDIT_STATUS_MODAL_TEXT:
            "Сиз ҳақиқатан ҳам танланган тўлов ҳамкорини ҳолатини таҳрирламоқчимисиз?",
        },
      },
      STATUS_TYPES: {
        ACT_TYPES: {
          TITLE: "Акт турлари",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Номи",
          },
          MODAL: {
            TITLE_SAVE: "Янги акт тури қўшиш",
            TITLE_UPDATE: "Акт тури таҳрирлаш",
            TITLE_DELETE: "Акт турини ўчириш",
            NAME_UZ: "Суд иши номи (UZ)",
            NAME_RU: "Суд иши номи (РУ)",
            NAME_CRL: "Суд иши номи (УЗ)",
            CONFIRMATION_MODAL_TEXT:
              "Сиз ҳақиқатан ҳам танланган Акт турини ўчиришни хоҳлайсизми?",
            TOAST_DELETE: "Танланган Акт тури муваффақиятли ўчирилди!",
            TOAST_SUCCESS: "Янги Акт тури муваффақиятли қўшилди!",
            TOAST_UPDATE: "Акт тури муваффақиятли таҳрирланди!",
            TOAST_SELECT_ROW: "Илтимос, қаторни танланг!",
          },
        },
        ACT_ACTIONS_TYPES: {
          TITLE: "Акт ҳаракатлари турлари",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Номи",
          },
          MODAL: {
            TITLE_SAVE: "Янги акт ҳаракат тури қўшиш",
            TITLE_UPDATE: "Акт ҳаракат турини таҳрирлаш",
            TITLE_DELETE: "Акт ҳаракат турини ўчириш",
            NAME: "Номи:",
            CONFIRMATION_MODAL_TEXT:
              "Сиз ҳақиқатан ҳам танланган aкт ҳаракат турини олиб ташлашни хоҳлайсизми?",
            TOAST_DELETE: "Танланган акт ҳаракат тури муваффақиятли ўчирилди!",
            TOAST_SUCCESS: "Янги акт ҳаракат тури муваффақиятли қўшилди!",
            TOAST_UPDATE:
              "Танланган акт ҳаракат тури муваффақиятли таҳрирланди!",
            TOAST_SELECT_ROW: "Илтимос, қаторни танланг!",
          },
        },
        POSITION_TYPES: {
          TITLE: "Лавозим турлари",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Номи",
            STATUS: "Ҳолат",
          },
          MODAL: {
            TITLE: "Рол турлари",
            TITLE_SAVE: "Янги лавозим тури қўшиш",
            TITLE_UPDATE: "Лавозим тури таҳрирлаш",
            TITLE_DELETE: "Лавозим турини ўчириш",
            NAME_UZ: "Лавозим номи (UZ)",
            NAME_RU: "Лавозим номи (РУ)",
            NAME_CRL: "Лавозим номи (УЗ)",
            STATUS: "Ҳолат",
            MODAL_BUTTONS: {
              CHANGE: "Сақлаш",
              CANCEL: "Бекор қилиш",
              ADD: "Қўшиш",
            },
            CONFIRMATION_MODAL_TEXT:
              "Сиз ҳақиқатан ҳам танланган лавозим тури ўчиришни хоҳлайсизми?",
            TOAST_DELETE: "Танланган лавозим тури муваффақиятли ўчирилди!",
            TOAST_SUCCESS: "Янги лавозим тури муваффақиятли қўшилди!",
            TOAST_UPDATE: "Лавозим тури муваффақиятли таҳрирланди!",
            TOAST_SELECT_ROW: "Илтимос, қаторни танланг!",
          },
        },
        ACT_STATUS: {
          TITLE: "Aкт статуслари",
          MODAL_ADD: {
            TITLE: "Янги акт статус қўшиш",
            TOAST_SUCCESS: "Aкт статус муваффақиятли қўшилди!",
          },
          MODAL_EDIT: {
            TITLE: "Акт статусни таҳрирлаш",
            TOAST_EDIT: "Акт статус муваффақиятли таҳрирланди!",
          },
          MODAL_DELETE: {
            TITLE: "Aкт статусни ўчириш",
            TOAST_DELETE: "Танланган акт статус муваффақиятли ўчирилди!",
            CONFIRMATION_MODAL_TEXT:
              "Сиз ҳақиқатан ҳам танланган акт статусни тизимдан олиб ташламоқчимисиз?",
          },
        },
        PACK_TYPES: {
          TITLE: "Пачка турлари",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Номи",
          },
          MODAL: {
            TITLE_SAVE: "Янги пачка тури қўшиш",
            TITLE_UPDATE: "Пачка тури таҳрирлаш",
            TITLE_DELETE: "Пачка турини ўчириш",
            NAME_UZ: "Пачка номи (UZ)",
            NAME_RU: "Пачка номи (РУ)",
            NAME_CRL: "Пачка номи (УЗ)",
            MODAL_BUTTONS: {
              CHANGE: "Сақлаш",
              CANCEL: "Бекор қилиш",
              ADD: "Қўшиш",
            },
            CONFIRMATION_MODAL_TEXT:
              "Сиз ҳақиқатан ҳам танланган пачка тури ўчиришни хоҳлайсизми?",
            TOAST_DELETE: "Танланган пачка тури муваффақиятли ўчирилди!",
            TOAST_SUCCESS: "Янги пачка тури муваффақиятли қўшилди!",
            TOAST_UPDATE: "Пачка тури муваффақиятли таҳрирланди!",
            TOAST_SELECT_ROW: "Илтимос, қаторни танланг!",
          },
        },
        LIGITATION_STATUS_TYPES: {
          TITLE: "Суд ҳолатлари турлари",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Номи",
          },
          MODAL: {
            TITLE_SAVE: "Янги cуд ҳолати қўшиш",
            TITLE_UPDATE: "Суд ҳолатини таҳрирлаш",
            TITLE_DELETE: "Суд ҳолатини ўчириш",
            NAME: "Номи:",
            CONFIRMATION_MODAL_TEXT:
              "Сиз ҳақиқатан ҳам танланган cуд ҳолатини олиб ташлашни хоҳлайсизми?",
            TOAST_DELETE: "Танланган cуд ҳолати муваффақиятли ўчирилди!",
            TOAST_SUCCESS: "Янги cуд ҳолати муваффақиятли қўшилди!",
            TOAST_UPDATE: "Танланган cуд ҳолати муваффақиятли таҳрирланди!",
            TOAST_SELECT_ROW: "Илтимос, қаторни танланг!",
          },
        },
        OWNER_SHIP_TYPES: {
          TITLE: "Корхона турлари",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Номи",
            SHORT_NAME: "Қисқа Номи:",
          },
          MODAL: {
            TITLE_SAVE: "Корхона тури қўшиш",
            TITLE_UPDATE: "Корхона тури таҳрирлаш",
            TITLE_DELETE: "Корхона турини ўчириш",
            NAME: "Номи:",
            MODAL_BUTTONS: {
              CHANGE: "Сақлаш",
              CANCEL: "Бекор қилиш",
              ADD: "Қўшиш",
            },
            SHORT_NAME: "Қисқа Номи:",
            CONFIRMATION_MODAL_TEXT:
              "Сиз ҳақиқатан ҳам танланган Корхона тури ўчиришни хоҳлайсизми?",
            TOAST_DELETE: "Танланган Корхона тури муваффақиятли ўчирилди!",
            TOAST_SUCCESS: "Янги Корхона тури муваффақиятли қўшилди!",
            TOAST_UPDATE: "Корхона тури муваффақиятли таҳрирланди!",
            TOAST_SELECT_ROW: "Илтимос, қаторни танланг!",
          },
        },
        ORGANIZATION_TYPES: {
          TITLE: "Ташкилот турлари",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Номи",
            ORG_TYPE_ID: "Cоҳа тури",
          },
          MODAL: {
            TITLE_SAVE: "Янги соҳа тури қўшиш",
            TITLE_UPDATE: "Соҳа турини таҳрирлаш",
            TITLE_DELETE: "Соҳа турини ўчириш",
            NAME_UZ: "Номи (UZ):",
            NAME_CRL: "Номи (УЗ):",
            NAME_RU: "Номи (РУ):",
            ORG_TYPE_ID: "Cоҳа тури:",

            CONFIRMATION_MODAL_TEXT:
              "Сиз ҳақиқатан ҳам танланган соҳа турини олиб ташлашни хоҳлайсизми?",
            TOAST_DELETE: "Танланган соҳа тури муваффақиятли ўчирилди!",
            TOAST_SUCCESS: "Янги соҳа тури муваффақиятли қўшилди!",
            TOAST_UPDATE: "Танланган соҳа тури муваффақиятли таҳрирланди!",
            TOAST_SELECT_ROW: "Илтимос, қаторни танланг",
          },
        },
        APPEAL_STATUS: {
          TITLE: "Онлайн мурожаат ҳолати",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Номи",
          },
          MODAL_ADD: {
            TITLE: "Янги онлайн мурожаат ҳолатини қўшиш",
            TOAST_SUCCESS: "Онлайн мурожаат холати муваффакиятли қўшилди!",
          },
          MODAL_EDIT: {
            TITLE: "Онлайн мурожаат ҳолатини ўзгартириш",
            TOAST_EDIT:
              "Танланган онлайн мурожаат ҳолати муваффакиятли ўзгартирилди!",
          },
          MODAL_DELETE: {
            TITLE: "Онлайн мурожаат ҳолатини ўчириш",
            TOAST_DELETE: "Онлайн мурожаат ҳолати муваффақиятли ўчирилди!",
            CONFIRMATION_MODAL_TEXT:
              "Сиз ҳақиқатан ҳам танланган онлайн мурожаатни тизимдан олиб ташламоқчимисиз?",
          },
        },
        APPEAL_TYPE: {
          TITLE: "Онлайн мурожаат тури",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Номи",
          },
          MODAL_ADD: {
            TITLE: "Янги мурожаат тури қўшиш",
            TOAST_SUCCESS: "Онлайн мурожаат тури муваффақиятли қўшилди!",
          },
          MODAL_EDIT: {
            TITLE: "Онлайн мурожаат турини ўзгартириш",
            TOAST_EDIT: "Онлайн мурожаат тури муваффакиятли ўзгартирилди!",
          },
          MODAL_DELETE: {
            TITLE: "Онлайн мурожаат турини ўчириш",
            TOAST_DELETE:
              "Танланган онлайн мурожаат тури муваффақиятли ўчирилди!",
            CONFIRMATION_MODAL_TEXT:
              "Сиз ҳақиқатан ҳам танланган онлайн мурожаат турини тизимдан олиб ташламоқчимисиз?",
          },
        },
        COURT_FILE_TYPES: {
          TITLE: "Суд иши турлари",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Номи",
          },
          FORM: {
            NAME_UZ: "Суд иши номи (UZ)",
            NAME_RU: "Суд иши номи (РУ)",
            NAME_CRL: "Суд иши номи (УЗ)",
          },
          MODAL_ADD: {
            TITLE: "Янги суд иши турини қўшиш",
            TOAST_SUCCESS: "Суд иши тури муваффақиятли қўшилди!",
          },
          MODAL_EDIT: {
            TITLE: "Суд иши турини ўзгартириш",
            TOAST_EDIT: "Суд иши тури муваффакиятли ўзгартирилди!",
          },
          MODAL_DELETE: {
            TITLE: "Суд иши турини ўчириш",
            TOAST_DELETE: "Танланган Суд иши тури муваффақиятли ўчирилди!",
            CONFIRMATION_MODAL_TEXT:
              "Сиз ҳақиқатан ҳам танланган Суд иши турини тизимдан олиб ташламоқчимисиз?",
          },
        },
      },
      TEMPLATES: {
        TABLE_LANGUAGE: "Тил",
        TABLE_CONTENT: "Таркиб",
        MODAL_SAVE_TITLE: "Янги ҳужжатни қўшиш",
        MODAL_SAVE_TITLE_CONTRACT: "Шартнома қўшиш",
        MODAL_SAVE_TITLE_EV_DOC: "Далолатнома қўшиш",
        MODAL_SAVE_TITLE_NOTIFICATION: "Хабарнома қўшиш",
        MODAL_UPDATE: "Ҳужжати ўзгартириш",
        MODAL_UPDATE_TITLE_CONTRACT: "Шартномани таҳрирлаш",
        MODAL_UPDATE_TITLE_EV_DOC: "Далолатномани таҳрирлаш",
        MODAL_UPDATE_TITLE_NOTIFICATION: "Хабарномани таҳрирлаш",
        MODAL_DELETE: "Танланган ҳужжати турини ўчириш",
        MODAL_DELETE_EV_DOC: "Далолатномани ўчириш",
        MODAL_DELETE_NOTIFICATION: "Хабарномани ўчириш",
        TEMPLATES_TYPE: "Ҳужжат тури",
        TEMPLATE_IN_UZ: "Shartnoma shabloni (UZ)",
        TEMPLATE_IN_RU: "Шаблон контракта (РУ)",
        TEMPLATE_IN_CRL: "Шартнома шаблони (УЗ)",
        CONFIRMATION_MODAL_TEXT:
          "Сиз ҳақиқатан ҳам танланган ҳужжати тизимдан олиб ташламоқчимисиз?",
        CONFIRMATION_MODAL_TEXT_EV_DOC:
          "Сиз ҳақиқатан ҳам танланган далолатномани  тизимдан олиб ташламоқчимисиз?",
        CONFIRMATION_MODAL_TEXT_NOTIFICATION:
          "Сиз ҳақиқатан ҳам танланган хабарномани  тизимдан олиб ташламоқчимисиз?",
        INDIVIDUAL: "Индивидуал",
        LEGAL: "Юридик",
      },
      TEMPLATE_TYPES: {
        SMS: {
          TABLE_HEADERS: {
            SHORT_NAME: "Қисқа номи",
            SMS_TITLE: "SMS сарлавҳаси",
            CONTENT_SMS: "SMS матни",
          },
          MODAL: {
            TITLE_SAVE: "Янги СМС шаблонини қўшиш",
            TITLE_UPDATE: "СМС шаблонини таҳрирлаш",
            TITLE_DELETE: "СМС шаблонини ўчириш",
            DELETE_MODAL_SUBTITLE:
              "Сиз ҳақиқатан ҳам танланган СМС шаблонини тизимдан олиб ташламоқчимисиз?",
          },
        },
      },
    },
    WORK1031: {
      PAYMENT_LIST: {
        TABLE_HEADERS: {
          ID: "ID",
          DATE: "Сана",
          TRANSFER_PAYMENT: "Тўлов топшир.№",
          SUM_1: "Сумма",
          SUM_2: "Жами тўловлар суммаси",
          COMPANY_NAME: "Ташкилот номи",
          QUANTITY: "Сони",
          STATUS: "Статус",
          REGISTRATION_DATE: "Реестр санаси",
          NAME: "Фойдаланувчи Ф.И.Ш",
          COMMENT: "Изоҳ",
        },
        MODAL: {
          TITLE_ADD: "Тўлов қўшиш",
          TITLE_EDIT: "Тўловни янгилаш",
          TITLE_DELETE: "Тўловни ўчириш",
          CONFIRMATION_MODAL_TEXT: "Бу тўловни ўчириб ташламоқчимисиз?",
          TOAST_SUCCESS: "Янги тўлов муваффақиятли қўшилди!",
          TOAST_SUCCESS_EDIT: "Тўлов янгиланди!",
          TOAST_DELETE: "Тўлов ўчирилди!",
          PLACEHOLDER_COMPANY_NAME: "Корхона:",
          PLACEHOLDER_ORGANIZATIONS: "Ташкилотлар:",
          PLACEHOLDER_SUM: "Сумма:",
          PLACEHOLDER_TRANSFER_PAYMENT: "Тўлов топшир.№:",
          PLACEHOLDER_STATUS: "Статус:",
          PLACEHOLDER_DATE: "Сана:",
          PLACEHOLDER_REGISTRATION_DATE: "Реестр санаси:",
          PLACEHOLDER_COMMENT: "Изоҳ:",
        },
      },
      PAYMENTS: {
        TABLE_HEADERS: {
          ID: "ID",
          ORGANIZATION_EMPLOYEE: "Ташкилот ҳодими",
          ORGANIZATION_PAYMENT_PACK: "Тўлов пачкани",
          PAYER_FIO: "Тўловчи Ф.И.Ш",
          AMOUNT: "Сумма",
          PURPOSE: "Мақсад",
          PAYMENT_DATE: "Тўлов санаси",
          COMMENT: "Изоҳ",
        },
        MODAL: {
          EXCEL_TITLE:
            "МИБ ва 1031 Тўловлар рўйхати билан ишлаш кесимидаги ҳисобот {{date}}.xlsx",
          ORG_EXPORT_TITLE: "МИБ ва 1031 Ташкилотлари {{date}}.xlsx",
          ORG_EMPLOYEES_EXPORT_TITLE:
            "МИБ ва 1031 Ташкилотлари ҳодимлари ҳисоботи {{date}}.xlsx",
          TITLE_ADD: "Тўлов қўшиш",
          FILET_RESULT: "Қидирув натижалари",
          TITLE_EDIT: "Тўловни янгилаш",
          TITLE_DELETE: "Тўловни ўчириш",
          EXPORT: "Ехcелга экспорт қилиш",
          CONFIRMATION_MODAL_TEXT:
            "Сиз ҳақиқатан ҳам бу тўловни тизимдан олиб ташламоқчимисиз?",
          TOAST_SUCCESS: "Янги тўлов муваффақиятли қўшилди!",
          TOAST_SUCCESS_EDIT: "Тўлов янгиланди!",
          TOAST_DELETE: "Тўлов ўчирилди!",

          ORGANIZATION_EMPLOYEE: "Ташкилот ҳодими:",
          ORGANIZATION_PAYMENT_PACK: "Тўлов пачкаси:",
          PAYER_FIO: "Тўловчи Ф.И.Ш:",
          AMOUNT: "Сумма:",
          PURPOSE: "Мақсад:",
          COMMENT: "Изоҳ:",
        },
      },
      ORGANIZAION_LIST: {
        TABLE_HEADERS: {
          ID: "ID",
          CompanyID: "Корхона",
          NAME: "Ташкилот номи",
          EMPLOYEE_COUNT: "Ишчилар сони",
          DIRECTOR_FIO: "Директор Ф.И.Ш",
          DEBITORS: "Дебиторлар",
          CREDITORS: "Кредиторлар",
          COUNT: "Сони",
          PAYMENT: "Жорий даврдаги тўловлар суммаси",
          SUM: "Сумма",
          PHONE_NUMBER: "Телефон рақами",
          EMAIL: "E-mail",
          BANK_MFO: "Банк МФО",
          STIR: "STIR",
          BANK_ACCOUNT: "Банк ҳисоби",
          ADDRESS: "Манзил",
          IS_BUDGET_ORG: "Бюджет ташкилоти",
          OKED: "ОКЭД",
          DESCRIPTION: "Изоҳ",
        },
        MODAL: {
          TITLE_ADD: "Ташкилот қўшиш",
          TITLE_EDIT: "Ташкилотни тахрирлаш",
          TITLE_DELETE: "Ташкилотни ўчириш",
          TITLE_EXPORT: "Ташкилотлар рўйҳатини экспорт қилиш",
          CONFIRMATION_MODAL_TEXT:
            "Сиз ҳақиқатан ҳам танланган ташкилотни тизимдан олиб ташламоқчимисиз?",
          TITLE_IMPORT_EMPLOYEES: "Ташкилот ходимлар рўйхатини импорт қилиш",
          BUTTON_IMPORT_EMPLOYEES: "Ходимларни импорт қилиш",
          DATE: "Санани киритинг:",
          CompanyID: "Корхона:",
          NAME: "Ташкилот номи:",
          DIRECTOR_FIO: "Директор Ф.И.Ш:",
          PHONE_NUMBER: "Телефон рақами:",
          EMAIL: "E-mail:",
          BANK_MFO: "Банк МФО:",
          STIR: "STIR:",
          BANK_ACCOUNT: "Банк ҳисоби:",
          ADDRESS: "Манзил:",
          IS_BUDGET_ORG: "Бюджет ташкилоти:",
          OKED: "ОКЭД:",
          DESCRIPTION: "Изоҳ:",
        },
      },
      ORGANIZAION_DEPARTMENT: {
        TABLE_HEADERS: {
          ID: "ID",
          ORGANIZATION_ID: "Ташкилот номи",
          NAME: "Ташкилот бўлими номи",
          DESCRIPTION: "Изоҳ",
        },
        MODAL: {
          TITLE_ADD: "Ташкилот бўлими қўшиш",
          TITLE_EDIT: "Ташкилот бўлимини таҳрирлаш",
          TITLE_DELETE: "Ташкилот бўлимини ўчириш",
          CONFIRMATION_MODAL_TEXT:
            "Сиз ҳақиқатан ҳам бу ташкилот бўлимини олиб ташламоқчимисиз?",
          ORGANIZATION_ID: "Ташкилот номи:",
          NAME: "Ташкилот бўлими номи:",
          DESCRIPTION: "Изоҳ:",
        },
      },
      ORGANIZATION_EMPLOYEES: {
        TABLE_HEADERS: {
          ID: "ID",
          ORGANIZATION_ID: "Ташкилот номи",
          ORGANIZATION_DEPARTMENT_ID: "Ташкилот бўлими номи",
          FULLNAME: "Ҳодим Ф.И.Ш",
          ABONENT_FIO: "Абонент Ф.И.Ш",
          POSITION: "Лавозими",
          TABLE_NUMBER: "Табел №",
          REZIDENT: "Резидент",
          ACCOUNT_NUMBER: "Ҳисоб рақами",
          NEIGHBORHOOD: "Маҳалла",
          STREET: "Кўча",
          HOUSE: "Уй",
          INDEX: "Индекс",
          KV: "Кв",
          LIVING_COUNT: "Яшовчилар сони",
          PERIOD: "Давр",
          SATART_SALDO: "Салдо боши",
          ACT: "Акт",
          CALCULATED: "Ҳисобланди",
          QAMOUNT: "Тушум",
          END_SALDO: "Салдо охири",
          DESCRIPTION: "Изоҳ",
        },
        MODAL: {
          TITLE_ADD: "Ташкилот бўлимига ҳодим қўшиш",
          TITLE_EDIT: "Ташкилот бўлими ҳодимини таҳрирлаш",
          TITLE_DELETE: "Ташкилот бўлими ҳодимини ўчириш",
          TITLE_EXPORT: "Ташкилот ҳодимларни ехcелга экспорт қилиш",
          CONFIRMATION_MODAL_TEXT:
            "Сиз ҳақиқатан ҳам бу ташкилот бўлими ҳодимини тизимдан олиб ташламоқчимисиз?",

          ORGANIZATION_ID: "Ташкилот номи",
          ORGANIZATION_DEPARTMENT_ID: "Ташкилот бўлими номи",
          ACCOUNT_NUMBER: "Hisob raqami:",
          FULLNAME: "Ходим Ф.И.Ш:",
          REZIDENT_FULLNAME: "Абoнент Ф.И.Ш:",
          POSITION: "Лавозим:",
          TABLE_NUMBER: "Табел №:",
          DESCRIPTION: "Изоҳ:",
          REZIDENT: "Резидент:",
        },
        FILTER: {
          ACCOUNT_NUMBER: "Ҳисоб рақами:",
          LITSEVOY: "Ҳисоб рақами",
          MAHALA: "Маҳалла",
          STREET: "Кўча",
          HOME: "Уй",
          FLAT: "Кв",
          TABLE_NUMBER: "Табличка №",
          FULLNAME: "Ходим Ф.И.Ш",
          SEARCH_EMPLOYEES: "Ходимлардан излаш",
          SEARCH_RESIDENTS: "Абанентлардан излаш",
        },
      },
    },

    REPORTS: {
      REPORT_TYPE_MAHALLA: "Маҳалла",
      REPORT_TYPE_STREET: "Кўча",
      PUBLIC_CONTRACT_REPORT: {
        TITLE: "Оммавий оферта шартномаси ҳисоботи",
        MAHALLA_COUNT: "Маҳаллалар сони",
        ATTACH_MAHALLA_CONTRACT_TOTAL:
          "Жами янги намунадаги оммавий шартнома бириктирилган маҳаллалар сони",
        ATTACH_MAHALLA_CONTRACT_COUNT:
          "Танланган санадаги янги намунадаги оммавий шартнома бириктирилган маҳаллалар сони",
        WARNING_COUNT: "Оммавий шартнома бўйича жами юборилган SMS лар сони",
        CONFIRM_RESIDENT_COUNT:
          "(Оммавий шартнома) SMS орқали юборилганда танишиб қабул қилган абонентлар сони",
        UN_ATTACH_MAHALLA_CONTRACT_COUNT:
          "Янги намунадаги оммавий шартномалар бириктирилмаган маҳаллалар сони",
        UN_CONFIRM_RESIDENT_COUNT:
          "(Оммавий шартнома) SMS орқали юборилганда қабул қилмаган абонентлар сони",
      },
      RESIDENTS_FEEDBACK_REPORT: {
        TABLE_HEADERS: {
          NAME: "Номи",
          RESIDENT_FEEDBACK_EXCELLENT:
            "“Аъло” ҳолатидаги фикр-мулоҳазалар сони",
          RESIDENT_FEEDBACK_GOOD: "“Яхши” ҳолатидаги фикр-мулоҳазалар сони",
          RESIDENT_FEEDBACK_SATISFACTORY:
            "“Қониқарли” ҳолатидаги фикр-мулоҳазалар сони",
          RESIDENT_FEEDBACK_UNSATISFACTORY:
            "“Қониқарсиз” ҳолатидаги фикр-мулоҳазалар сони",
          RESIDENT_FEEDBACK_CONTRACT: "Оммаий оферта шартномаси сони",
        },
      },
      PNFL_CADASTR_COUNT: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Номи",
          PNFL_COUNT: "ЖШШИР",
          PNFL_PERCENT: "Жами ЖШШИР киритилган % да",
          CADASTRE_PERCENT: "Жами кадастр рақам киритилган % да",
          RESIDENT_COUNT: "Жами абонентлар",
          CADASTRAL_NUMBER_COUNT: "Кадастр рақами",
        },
        INPUTS: {
          OWNER_SHIP_TYPES: "Корхона тури",
        },
      },
      RESIDENT_IDENTIFICATION_CANCEL_REASON_REPORT: {
        TABLE_HEADERS: {
          NAME: "Номи",
          INVALID_PASSPORT_SERIAL_COUNT: "Нотўғри паспорт сериялари сони",
          INVALID_PINFL_COUNT: "Нотўғри ПИНФЛ сони",
          TOTAL: "Жами идентификацияси бекор қилинган абонентлар сони",
          PHOTO_COUNT: "Фото сони",
          INVALID_CADASTRAL_NUMBER_COUNT: "Нотўғри кадастр рақамлари сони",
          CYRILLIC_COUNT: "Кирилл ҳарфларидаги Ф.И.О лар сони",
          INVALID_COATO_COUNT: "Нотўғри СОАТО кодлари сони",
          INVALID_ELECTRICITY_ACCOUNT_NUMBER_COUNT:
            "Нотўғри электр ҳисоб рақамлари сони",
          COATO_MATCHDISTRICTCOATO_COUNT:
            "Туман СОАТО билан Абонент СОАТО мос келмаганлар сони",
          DUPLICATE_CADASTRAL_NUMBER_COUNT:
            "Кадастр рақамлари дубликатлари сони",
          DUPLICATE_ELECTRICITY_ACCOUNT_NUMBER_COUNT:
            "Электр ҳисоб рақами дубликатлари сони",
        },
        CANCELED_RESIDENTS: {
          TABLE_HEADERS: {
            FIO: "Ф.И.Ш",
            ACCOUNT_NUMBER: "Ҳисоб рақами",
            REASON_STATUS: "Сабаб статуси",
            DATE: "Сана",
          },
          REASON_STATUS: {
            DEFAULT: "Стандарт",
            INVALID_PINFL: "Нотўғри ПИНФЛ",
            INVALID_PASSPORT_SERIAL: "Нотўғри паспорт серияси",
            PHOTO: "Фото",
            INVALID_CADASTRAL_NUMBER: "Нотўғри кадастр рақами",
            CYRILLIC: "Кирилл ёзуви",
            INVALID_COATO: "Нотўғри СОАТО коди",
            INVALID_ELECTRICITY_ACCOUNT_NUMBER: "Нотўғри электр ҳисоб рақами",
            COATO_MATCH_DISTRICT_COATO: "СОАТО туман СОАТО билан мос келади",
            DUPLICATE_CADASTRAL_NUMBER: "Кадастр рақами дубликат",
            DUPLICATE_ELECTRICITY_ACCOUNT_NUMBER:
              "Электр ҳисоб рақами дубликат",
          },
        },
      },
      ELECTRICITY: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Номи",
          RESIDENT_COUNT: "Абонент сони",
          CADASTRAL_NUMBER_COUNT: "Тизимга киритилган кадастр раками сони",
          INSERTED_ETC_ACCOUNT_COUNT:
            "ЭТК шахсий ҳисоб раками киритилган абонентлар сони",
          CADASTRE_NUMBER_COUNT_BY_ETC_ACCOUNT:
            "Тизимга киритилган кадастр раками сони (ЭТК л/с Тизимга киритилгани буйича)",
          PHONE_NUMBER_COUNT:
            "Тел раками тизимга киритилгани буйича абонент сони",
          ETC_ACCOUNT_PERCENT:
            "Жами абонент сонидан ЭТК шахсий раками киритилган абонентлар сонига нисбатан %",
          NOT_INSERTED_ETC_ACCOUNT_COUNT:
            "ЭТК ҳисоб раками киритилмаган абонентлар сони",
        },
        TABLE_HEADERS_2: {
          ACCOUNT_NUMBER: "Ҳисоб рақам",
          CADASTRAL_NUMBER: "Кадастр рақами",
          COMPANY_NAME: "Корхона",
          ELECTRICITY_ACCOUNT_NUMBER: "ЭТК ҳисоб рақам",
          FULL_NAME: "Ф.И.О",
          INN: "СТИР",
          PHONE_NUMBER: "Телефон рақами",
          STREET_NAME: "Кўча номи",
        },
        MODAL_TITLE: "Абонентлар",
        EXCEL_NAME: "Электр энергия солиштирма ҳисоботи",
      },
      MAHALLA_DEBITORS_ANALYSIS: {
        PERIOD: "Давр",

        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Номи",
          ABONENT_COUNT: "Абонентлар сони",
          TOTAL_PEOPLE_COUNT: "Жами яшовчи сони",
          CALCULATED: "Ҳисобланди",
          COUNT: "Сони",
          SUM: "Сумма",
          TOTAL: "Жами",
          CREDITORS: "Кредиторлар",
          DEBTORS: "Дебиторлар",
          DEBTORS_0_TO_50_000: "Қарздорлик (0-50 000)",
          DEBTORS_50_000_TO_100_000: "Қарздорлик (50 000-100 000)",
          DEBTORS_100_000_TO_300_000: "Қарздорлик (100 000-300 000)",
          DEBTORS_300_000_TO_500_000: "Қарздорлик (300 000-500 000)",
          DEBTORS_500_000_TO_1_000_000: "Қарздорлик (500 000-1 000 000)",
          DEBTORS_1_000_000_UPPER: "1 000 000 сўмдан катта бўлганлар",

          CREDITORS_0_TO_50_000: "Ҳақдорлик (0-50 000)",
          CREDITORS_50_000_TO_100_000: "Ҳақдорлик (50 000-100 000)",
          CREDITORS_100_000_TO_300_000: "Ҳақдорлик (100 000-300 000)",
          CREDITORS_300_000_TO_500_000: "Ҳақдорлик (300 000-500 000)",
          CREDITORS_500_000_TO_1_000_000: "Ҳақдорлик (500 000-1 000 000)",
          CREDITORS_1_000_000_UPPER: "1 000 000 сўмдан катта бўлганлар",

          CREDITORS_TOOLTIP:
            "Хакдорлиги 300 000 сўм дан юкори абонентлар мавжуд",
        },
      },
      COURT_PROCESS_ANALYSIS_REPORT: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Номи",
          TOTAL: "Жами сони",
          FROM_THAT: "Шундан",
          TO_5: "5 кунгача",
          FROM_5_TO_10: "5 кундан 10 кунгача",
          FROM_10_TO_30: "10 кундан 30 кунгача",
          FROM_30_TO_60: "30 кундан 60 кунгача",
          MORE_60: "60 кундан юкори",
        },
        COURT_STATUS: {
          WARNED: "Огохлантирилди",
          DOCUMENT_PREPARATION: "Суд хужжатларини тайёрлаш",
          DOCUMENTS_SENT: "Хужжатлар судга юборилди",
          COURT_DECISION: "Суд карори чикарилди",
          DEBT_PAID: "Қарздорлик тўлик қопланди",
        },
        PLACEHOLDER: {
          STATUS: "Ҳолат",
        },
      },
      DHSH_1: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Номи",
          ABONENT_COUNT: "Абонентлар сони",
          TOTAL_PEOPLE_COUNT: "Жами яшовчи сони",
          N_SALDO: "Салдо боши",
          START_PERIOD_DT_COUNT: "Дебиторлар сони(Давр боши)",
          END_PERIOD_DT_COUNT: "Дебиторлар сони(Давр охири)",
          START_DT_COUNT: "Дебитор давр бошига",
          END_DT_COUNT: "Дебитор давр охирига",
          START_PERIOD_KT_COUNT: "Кредиторлар сони(Давр боши)",
          END_PERIOD_KT_COUNT: "Кредиторлар сони(Давр охири)",
          START_KT_COUNT: "Кредитор давр бошига",
          END_KT_COUNT: "Кредит давр охирига",
          CALCULATED: "Ҳисобланди",
          REVENUE: "Тушум",
          INCOME_KVIT: "Нақд пул тушумлари",
          INCOME_E_PAYMENT: "Эл.тушумлар",
          INCOME_MUNIS_PAYMENT: "Мунис",
          INCOME_1031_PAYMENT: "МИБ ва 1031 тушумлари",
          INCOME_ACT: "Акт",
          K_SALDO: "Салдо охири",
          NEW_ABONENT_COUNT: "Янги абонентлар сони",
          NEW_ABONENT_N_SALDO: "Янги абонентлар салдо боши",

          TOTAL_INCOME: "Жами тушумлар",
        },
      },
      RESIDENTS_HIGH_DEBT_REPORT: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Ф.И.Ш",
          ACCOUNT_NUMBER: "Ҳисоб рақам",
          MAHALLA_NAME: "Маҳалла",
          STREET_NAME: "Кўча",
          HOME_NUMBER: "Уй",
          INDEX: "Индекс",
          KV: "Кв",
          inhabitants: "Яшовчилар сони",
          SALDO_BEGINING: "Салдо боши",
          WAS_CALCULED: "Ҳисобланди",
          CALCULATED: "Ҳисобланди",
          ACT: "Акт",
          PAYMENTS: "Тўловлар",
          TOTAL: "Жами",
          MUNIS: "Мунис",
          CASH: "Нақд",
          TERMINAL: "Терминал",
          PAYNET: "Paynet",
          PAYME: "Payme",
          UPAY: "UPay",
          CLICK: "CLICK",
          PLATEJI_1031: "МИБ ва 1031 тўловлари",
          SALDO_END: "Салдо охири",
        },
        PLACEHOLDER_FILTER: {
          COMPANY_NAME: "Корхона номи",
          COMPANY_TYPE: "Корхона тури",
          N_SALDO_RANGE: "Салдо бошига қарз оралиғи",
        },
      },
      ONLINE_APPEALS_REPORT: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Номи",
          ALL_APPEALS: "Барча мурожаатлар сони (ой)",
          UNANSWERED_APPEALS: "Жавоб берилмаган мурожаатлар сони",
          APPLICATION_RECEIVED: "Қабул қилинган мурожаатлар сони",
          ANSWERED_APPEALS: "Жавоб берилган мурожаатлар сони",
          APPLICATION_REJECTED: "Рад этилган мурожаатлар сони",
        },
      },
      COURT_PROCESS_PERIODIC: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Номи",
          RESIDENTS_DEBT: "Қарздор абонентлар",
          WARNED: "Огоҳлантирилди",
          DOCUMENT_PREPARATION: "Суд ҳужжатларини тайёрлаш",
          SEND_TO_COURT: "Ҳужжатлар судга юборилди",
          COURT_DECISION: "Суд қарори чиқарилди",
          DEBT_PAID_FULL: "Қарздорлик тўлиқ қопланди",
          COUNT: "Сони",
          SUMMA: "Сумма",
        },
        RESIDENT_DATATABLE: {
          TABLE_HEADERS: {
            ID: "ID",
            ACCOUNT_NUMBER: "Ҳисоб рақам",
            NAME: "Ф.И.О",
            STATUS: "Ҳолат",
            WARNING_DATE: "Огоҳлантириш санаси",
            WARNING_AMOUNT: "Огоҳлантириш миқдори",
            N_SALDO: "Салдо боши",
            COMPANY_NAME: "Корхона номи",
            CREATED_BY_USER: "Яратган фойдаланувчи",
          },
        },

        WARNED_FILE: "Огоҳлантириш файли",
        DOCUMENT_PREPARATION_FILE: "Суд ҳужжатлари",
        COURT_DECISION: "Суд буйруғи",

        SEND_TO_COURT_FILE: "Судга юбориш файллари",
        COURT_ORDER: "Суд қарорлари",
      },
      UNPAID_RESIDENTS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Номи",
          ABONENT_COUNT: "Жами абонентлар сони",
          COUNT: "Сони",
          DEBTOR: "Қарздорлик",
          DEBTOR_0_3_MONTH: "0 - 3 ойгача тўламаган абонентлар",
          DEBTOR_3_6_MONTH: "3 - 6 ойгача тўламаган абонентлар",
          DEBTOR_6_12_MONTH: "6 - 12 ойгача тўламаган абонентлар",
          DEBTOR_12_36_MONTH: "12 - 36 ойгача тўламаган абонентлар",
          DEBTOR_36_UPPER_MONTH: "36 ойдан ортиқ тўламаган абонентлар",
        },
        DEBTOR: "Қарздорлик",
        CREDITOR: "Ҳақдорлик",
      },
      MUNIS_REPORTS: {
        TABLE_HEADERS: {
          ID: "ID",
          PERIOD: "Давр",
          COMPANY_NAME: "Корхона номи",
          ACCOUNT_NUMBER: "Ҳисоб рақам",
          DOCUMENT_NUMBER: "Хужжат рақами",
          DOCUMENT_DATE: "Хужжат вақти",
          DAY_PAYMENT: "Тушган куни",
          TIME_PAYMENT: "Тўлов вақти",
          SUMMA: "Сумма",
          RESIDENT_FIO: "Ф.И.Ш",
          BANK_MFO: "МФО",
          HASH: "Х/Р",
          INN: "ИНН",
          MAHALLA_NAME: "Маҳалла",
          STREET_NAME: "Кўча",
          HOME_NUMBER: "Уй",
          FLAT_NUMBER: "Кв",
          NAME: "Номи",
          PURPOSE: "Мақсади",
          DELETE: "Ўчирилган",
        },
        RESIDENTS_TABLE: {
          ID: "ID",
          NAME: "Ф.И.Ш",
          ACCOUNT_NUMBER: "Ҳисоб рақами",
          INHABITANT_CNT: "Яшовчи сони",
          SUMMA: "Суммаси",
          COMPANY_NAME: "Корхона номи",
          MAHALLA_NAME: "Маҳалла",
          STREET_NAME: "Кўча",
          HOME_NUMBER: "Уй",
          INDEX: "Индекс",
        },
      },
      MUNIS_PAYMENTS: {
        TABLE_HEADERS: {
          PERIOD: "ID",
          NAME: "Номи",
          TOTAL: "Жами",
          ACTIVE_CONTRACT: "Фаол шартномалар бўйича",
          CANCEL_CONTRACT: "Бекор бўлган шартномалар бўйича",
          PAYMENT_COUNT: "Тўловлар сони",
          SUM: "Суммаси",
        },
      },
      RESIDENTS_WITH_HIGH_INDEBTEDNESS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Номи",
          TOTAL_MONTHLY: "Жами ойлик",
          RESIDENTS: "Aбонентлар",
          INHB_COUNT: "Яшовчилар сони",
          N_SALDO: "Салдо боши",
          BY_FILTER: "Филтр бўйича",
          CALCULATED: "Ҳисобланди",
          ACT: "Акт",
          REVENUE: "Тўловлар",
          REVENUE_TOTAL: "Жами",
          MUNIS: "МУНИС",
          CASH: "Нақд",
          TERMINAL: "Терминал",
          PAYNET: "Paynet",
          PAYME: "Payme",
          U_PAY: "UPay",
          CLICK: "Click",
          PAYMENT_1031: "МИБ ва 1031 тўловлар",
          MONTH_END: "Ой охирида",
          K_SALDO: "Салдо охири",
          INV_ACT: "Инвентаризация актлари",
          ONLINE_PAYMENTS: "Онлайн тўловлар",

          ACCOUNT_NUMBER: "Ҳисоб рақами",
          PAYMENT: "Тўловлар",
          CALCULATE: "Ҳисобланди",
          DATE: "Инв. санаси актлари",
          MAHALLA_NAME: "Маҳалла",
          STREET: "Кўча",
          HOUSE: "Уй",
          INDEX: "Индекс",
          FLAT_NUMBER: "Кв",
          FILES: "Бириктирилган файллар",
        },
      },
      ELECTRICITY_PAYMENTS_REPORTS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Номи",
          TOTAL: "Жами",
          COUNT: "Сони",
          SUMMA: "Сумма",
          PAYNET: "Paynet",
          PAYME: "Payme",
          UPAY: "UPay",
          CLICK: "Click",
          UZ_POCHTA: "УзПочта",
          EcoPay: "EcoPay",
          Oson: "Oson",
          UZUM_BANK: "UZUM BANK",
        },
      },
      REPORT_ANALYTICAL_SMS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Номи",
          TOTAL_SMS_SEND: "Жами жўнатилган смс сони",
          TOTAL_DEBT: "Жами қарздорлик суммаси",
          TOTAL_PAYMENT_NUMBER: "Тўлов қилган абонентлар сони",
          TOTAL_PAYMENT_SUM: "Тўлов қилинган сумма",
          SUCCESS_SMS: "Муваффақиятли СМС (%)",
        },
      },
      REVENUES_DXSH_2: {
        TABLE_HEADERS: {
          NAME: "Номи",
          FROZEN_DEBT: "Давр бошига музлатилган дебитор қарздорлик",
          FROZEN_REVENUE: "Музлатилган қарздорликдан тушган тушум",
          MONTH_END_DEBT: "Ой охирига қарздорлик",
          DXSH_COSTS_20: "ДХШ тўлов унидирилиши бўйича ҳаражатлар (20%)",
          DXSH_COSTS_80: "Музлатилган қарздорлик ундируви (80%)",
        },
      },
      REVENUES_DXSH: {
        TABLE_HEADERS: {
          NAME: "Номи",
          TOTAL_REVENUE_AMOUNT: "Умумий тушум суммаси",
          FROM_THAT: "Шундан",
          RECEIPTS: "Квитансиялар",
          ELECTRONIC_PAYMENTS: "Эл тўловлар",
          MUNIS: "МУНИС",
          REVENUE_1031: "МИБ ва 1031 тушумлари",
          DHSH_REVENUES: "ДХШ тушумлар",
          FROZEN_DEBT: "Музлатилган қарздорлик",
          MONTH_START_DEBT: "Ой бошига қарздорлик",
          REVENUE: "Тушум",
          AKT: "Акт",
          MONTH_END_DEBT: "Ой охирига қарздорлик",
          DXSH_PAYMENT_20: "ДХШ тўлов ундирилиши бўйича харажатлар",
          FROZEN_DEBT_80: "Музлатилган қарздорлик ундируви",
        },
        RESIDENTS_TABLE: {
          NAME: "Ф.И.Ш",
          ACCOUNT_NUMBER: "Ҳисоб рақам",
          PERIOD: "Давр",
          FRONZEN_DEBT: "Музлатилган қарздорлик",
          COMPANY_NAME: "Корхона номи",
          N_SALDO: "Салдо боши",
          REVENUE: "Тушум",
          AKT: "Акт",
          DEBT_ACT: "Қарздорлик акти",
          K_SALDO: "Салдо охири",
        },
      },
      NOTICE_LIMITS_REPORTS: {
        NAME: "Номи",
        TOTAL_SMS_SEND: "Жами юборилган СМС лар сони",
        FOR_REGISTRATION: "Регистрация учун",
        FROM_THAT: "Шундан",
        FROM_NOTIFICATIONS: "Огоҳлантиришлар учун",
        LIMITS: "Чеклов",
        WAS_USED: "Ишлатилди",
        OTHER_TYPE: "Бошқа турдаги СМС лар",
      },
      GPS_WORKING_TIME: {
        ON_MAP_MODAL_TITLE: "Махсус техниканинг кунлик йўл харитаси",
        ON_MAP_MODAL_NO_DATA: "Маршрут аниқланмади",
        ON_MAP_MODAL_START_BTN: "Маршрут ҳаракатини кўриш",
        ON_MAP_MODAL_CHOSEN_DATE_BTN: "Маршрутни кўриш",
        ON_MAP_MODAL_PAUSE_BTN: "Пауза",
        ON_MAP_MODAL_CONTINUE_BTN: "Ҳаракатни давом этиш",
        ON_MAP_MODAL_END_TIME: "Ҳаракат тугаш вақти",
        ON_MAP_MODAL_STOP_BTN: "Ҳаракатни тўхтатиш",
        ON_MAP_MODAL_ACTION_START_TIME: "Ҳаракат бошланган вақт",
        ON_MAP_MODAL_ACTION_END_TIME: "Ҳаракат тугалланган вақт",
        ON_MAP_MODAL_ATTENTION:
          "Махсус техниканинг кунлик йўл харитаси кўриш учун, кун, бошланиш вақтини ва тугаш вақтини киритинг !",
        TABLE_HEADERS_REPUBLIC: {
          NAME: "Номи",
          NUMBER_TOTAL_TECHNIQUE: "Жами техникалар сони",
          ON_AVERAGE: "Жами техникаларга нисбатан ўртача ҳисоблаганда",
          NUMBER_DAYS_WORK: "Ишга чиқган кунлар сони",
          TOTAL_TIME: "Жами вақт",
          ENGINE_ACTIVE_TIME: "Двигател фаол вақти",
          ENGINE_NO_ACTIVE_TIME: "Двигател нофаол вақти",
          MOVE_TIME: "Ҳаракатда бўлган вақт",
          MOTIONLESS_ENGINE_ACTIVE_TIME:
            "Ҳаракатсиз, двигател фаол бўлган вақт",
          TOTAL_KILOMETER: "Босиб ўтилган масофа (км)",
          AVERAGE_SPEED: "Ўртача тезлик (км/соат)",
          MAX_SPEED: "Энг юқори тезлик (км/соат)",
        },
        TABLE_HEADERS_COMPANY: {
          VEHICLE_NUMBER: "Автомобил рақами",
          NUMBER_DAYS_WORK: "Ишга чиқган кунлар сони",
          TOTAL_TIME: "Жами вақт",
          ENGINE_ACTIVE_TIME: "Двигател фаол вақти",
          ENGINE_NO_ACTIVE_TIME: "Двигател нофаол вақти",
          MOVE_TIME: "Ҳаракатда бўлган вақт",
          MOTIONLESS_ENGINE_ACTIVE_TIME:
            "Ҳаракатсиз, двигател фаол бўлган вақт",
          TOTAL_KILOMETER: "Босиб ўтилган масофа (км)",
          AVERAGE_SPEED: "Ўртача тезлик (км/соат)",
          MAX_SPEED: "Энг юқори тезлик (км/соат)",
          ON_MAP: "Харитада",
        },
        TABLE_HEADERS: {
          DATE: "Сана",
          ACTION_START_TIME: "Ҳаракат бошланган вақт",
          ACTION_START_LOCATION: "Ҳаракат бошланган жойлашув",
          ACTION_END_TIME: "Ҳаракат тугалланган вақт",
          ACTION_END_LOCATION: "Ҳаракат тугалланган жойлашув",
          TOTAL_TIME: "Жами вақт",
          ENGINE_ACTIVE_TIME: "Двигатель фаол вақти",
          ENGINE_NO_ACTIVE_TIME: "Двигатель нофаол вақти",
          AVERAGEMILAEGE_PERDAY: "Ўртача кунлик босиб ўтилган масофа (км)",
          MOVE_TIME: "Ҳаракатда бўлган вақт",
          MOTIONLESS_ENGINE_ACTIVE_TIME:
            "Ҳаракатсиз, двигатель фаол бўлган вақт",
          TOTAL_KILOMETER: "Босиб ўтилган масофа (км)",
          AVERAGE_SPEED: "Ўртача тезлик (км/соат)",
          MAX_SPEED: "Энг юқори тезлик (км/соат)",
        },
        DAY: "Кун",
        EXCEL_TITLES: {
          BY_REPUBLIC:
            "Махсус чиқинди ташувчи техникалар ишга чиққанлиги ҳақида вилоятлар кесимида ҳисобот {{date}}",
          BY_REGION:
            "Махсус чиқинди ташувчи техникалар ишга чиққанлиги ҳақида туманлар кесимида ҳисобот{{date}}",
          BY_DISTRICT:
            "Махсус чиқинди ташувчи техникалар ишга чиққанлиги ҳақида корхоналар кесимида ҳисобот {{date}}",
          BY_COMPANY:
            "Махсус чиқинди ташувчи техникалар ишга чиққанлиги ҳақида автомобиллар кесимида ҳисобот {{date}}",
          BY_AUTOMOBILE:
            "Махсус чиқинди ташувчи техника ишга чиққанлиги ҳақида ҳисобот {{date}}",
        },
      },
      VISITS_TO_POLYGON: {
        TABLE_HEADERS: {
          VISITS_COUNT_FOR_LAST_DAY:
            "Охирги кун учун ташрифлар сони ({{items}})",
          VISITS_COUNT_FOR_LAST_WEEK:
            "Охирги ҳафта учун ташрифлар сони ({{from}} - {{to}})",
          VISITS_COUNT_FOR_LAST_MONTH:
            "Охирги ой учун ташрифлар сони ({{from}} - {{to}})",
          VISITS_COUNT_FOR_LAST_DAY1: "Охирги кун учун ташрифлар сони",
          VISITS_COUNT_FOR_LAST_WEEK1: "Охирги ҳафта учун ташрифлар сони",
          VISITS_COUNT_FOR_LAST_MONTH1: "Охирги ой учун ташрифлар сони",
          AUTO: "Автомобил",
          COMPANY: "Корхона",
          DATE: "Сана",
          TIME_IN: "Кириш вақти",
          TIME_OUT: "Чиқиш вақти",
        },
        FILTER_COMPONENT: {
          START_DATE_FOR_CALCULATE_INTERVAL:
            "Интервални ҳисоблаш учун бошлангич сана",
        },
        EXCEL_TITLES: {
          BY_REPUBLIC:
            "Вилоятлар кесимида полигонларга ташрифлар сони {{date}}",
          BY_REGION: "Туманлар кесимида полигонларга ташрифлар сони {{date}}",
          BY_DISTRICT: "Полигонлар кесимида ташрифлар сони {{date}}",
          BY_POLIGON_DAY: "Полигонлар кесимида кунлик ташрифлар сони {{date}}",
          BY_POLIGON_WEEK:
            "Полигонлар кесимида ҳафталик ташрифлар сони {{date}}",
          BY_POLIGON_MONTH: "Полигонлар кесимида ойлик ташрифлар сони {{date}}",
        },
      },
      VISITS_TO_LEGAL: {
        LOCATION_ON_THE_MAP: "Харитадаги жойлашув",
        LEGAL_RESIDENT_NAME: "Юридик абонент номи",
        ADDRESS: "Манзил",
        DIRECTOR: "Директор",
        IS_ADDRESS: "{{ village }} маҳалласи, {{street}} кўчаси",
        EXCEL_TITLES: {
          BY_REPUBLIC:
            "Вилоятлар кесимида юридик абонентларга ташрифлар сони {{date}}",
          BY_REGION:
            "Туманлар кесимида юридик абонентларга ташрифлар сони {{date}}",
          BY_DISTRICT: "Юридик абонентлар кесимида ташрифлар сони {{date}}",
          BY_POLIGON_DAY:
            "Юридик абонентлар кесимида кунлик ташрифлар сони {{date}}",
          BY_POLIGON_WEEK:
            "Юридик абонентлар кесимида ҳафталик ташрифлар сони {{date}}",
          BY_POLIGON_MONTH:
            "Юридик абонентлар кесимида ойлик ташрифлар сони {{date}}",
        },
      },
      ENTRY_TIME: {
        REGION_LEVEL_TABLE_HEADERS: {
          NAME: "Номи",
          DURATION_IN_TIME: "Ҳудудда бўлиш давомийлиги",
          MOVING_DURATION_IN_TIME: "Ҳаракатда бўлган вақти давомийлиги",
          PARKING_DURATION_IN_TIME: "Харакатсиз бўлган вақти давомийлиги",
          VISIT_COUNT: "Ташрифлар сони",
          MILEAGE: "Босиб ўтган масофаси (км)",
          STOPS_COUNT: "Тўхташлар сони",
          AVG_SPEED: "Ўртача тезлик (км/соат)",
          MAX_SPEED: "Энг юқори тезлик (км/соат)",
        },
        MAHALLA_LEVEL_TABLE_HEADERS: {
          VISIT_DATE: "Сана",
          AUTOMOBILE_NUMBER_AND_MODEL: "Автомобил рақами ва модели",
          COMPANY_NAME: "Корхона номи",
          DRIVER: "Ҳайдовчи",
          TIME_IN: "Кириш вақти",
          TIME_OUT: "Чиқиш вақти",
          DURATION_IN_TIME: "Ҳудудда бўлиш давомийлиги",
          MOVING_DURATION_IN_TIME: "Ҳаракатда бўлган вақти давомийлиги",
          PARKING_DURATION_IN_TIME: "Харакатсиз бўлган вақти давомийлиги",
          MILEAGE: "Босиб ўтган масофаси (км)",
          STOPS_COUNT: "Тўхташлар сони",
          AVG_SPEED: "Ўртача тезлик (км/соат)",
          MAX_SPEED: "Энг юқори тезлик (км/соат)",
          ON_MAP: "Харитада",
        },
        EXCEL_TITLE: "Техникаларнинг ҳудудларга кириш-чиқиш вақти {{date}}",
        ALL_ROADS_ON_MAP: "Барча ташрифлар",
      },
      MFA_1: {
        TABLE_HEADERS: {
          NAME: "Номи",
          DEBT_INTEREST: "Қарзд.(ўсиш/пас)",
          INV: "Бирламчи инв.ўтганлар",
          ABONENTS_COUNT: "Абонентлар сони",
          TOTAL: "Жами",
          NEW_ABONENTS: "Янги абонент",
          NUMBER_OF_INHABITANTS: "Яшовчилар сони",
          COUNT: "Сони",
          SUMMA: "Сумма",
          N_SALDO: "Салдо боши",
          START_DT: "Дебитор давр бошига",
          START_KT_COUNT: "Кредитор давр бошига",
          CALCULATE: "Хисобланди",
          QQS_PRICE: "ҚҚС суммаси",
          ALL_PAYMENTS: "Барча тўловлар",
          COMPANIES_COUNT: "Корхоналар сони",
          CASH_RECEIPTS: "Нақд тушум",
          ELECTRONIC_PAYMENTS: "Эл.тушумлар",
          MUNIS: "МУНИС",
          MIB_AND_1031: "МИБ ва 1031 тушумлари",
          AKT: "Акт",
          K_SALDO: "Салдо охири",
          END_DT_COUNT: "Дебитор давр охирига",
          END_KT_COUNT: "Кредитор давр охирига",
          MAHALLA: "Маҳаллалар",
        },
      },
      MFA_2: {
        TABLE_HEADERS: {
          NAME: "Номи",
          CURRENT_PERIOD: "Жорий давр",
          CURRENT_RATE: "Жорий тариф",
        },
      },
      MFA_6: {
        TABLE_HEADERS: {
          NAME: "Номи",
          TOTAL: "Жами",
          MAHALLA_COUNT: "Маҳаллалар сони",
          ABONENTS_COUNT: "Абонент сони",
          INHABITANT_CNT: "Яшовчилар сони",
          DEBTOR: "Дебитор",
          CREDITORS: "Кредитор",
          DT_COUNT: "Сони",
          DT_SUM: "Суммаси",
          KT_COUNT: "Сони",
          KT_SUM: "Суммаси",
          PARTIALLY_DELETED_MAHALLA: "Қисман ўчирилган маҳаллалар сони",
          PARTIALLY_DELETED_INHABITANT:
            "Қисман ўчирилган маҳаллаларда  яшовчилар сони",
          COMPLETELY_DELETED_MAHALLA: "Тўлиқ ўчирилган маҳаллалар сони",
          COMPLETELY_DELETED_INHABITANT:
            "Тўлиқ ўчирилган маҳаллаларда яшовчилар сони",
          INCOME: "Тушум",
          TEMPORARILY_DELETED: "Вақтинча ўчирилганлар",
          COUNT: "Сони",
          SUMMA: "Сумма",
        },
      },
      MFA_16: {
        TABLE_HEADERS: {
          NAME: "Номи",
          TOTAL_AMOUNT: "Жами сумма",
          TOTAL_CALCULATE: "Жами хисобланди",
          POPULATION: "Аҳоли",
          PAID_ABONENTS: "Тўлов қилган абонентлар сони",
          HOW_MUCH_DEBITOR: "Дебиторликдан қанчаси қопланган(сумма)",
          HOW_MUCH_CREDITOR: "Кредиторликдан қанчаси қопланган(сумма)",
          NUMBER_OF_INHABITANTS: "Яшовчилар сони",
          CALCULATE: "Хисобланди",
          TOTAL: "Жами",
          CHASH_AMOUNT: "Нақд тушум",
          REVENUE: "Тушум",
          TERMINAL: "Терминал орқали",
          BANK: "Банк томонидан",
          MIB_AND_1031: "МИБ ва 1031 тушумлари",
          MUNIS: "МУНИС",
          ELECTRONIC_INCOME: "Электрон тушумлар",
          JURIDICAL: "Юридик шахслар",
          ORGANIZATION_COUNT: "Ташкилотлар сони",
        },
        RESIDENTS_TABLE: {
          FISH: "Ф.И.Ш",
          TOTAL_AMOUNT: "Жами сумма",
          NUMBER_OF_INHABITANTS: "Яшовчилар сони",
          CASH_INCOMES: "Нақд пул тушумлари",
          INCOMES_1031: "МИБ ва 1031 тушумлари",
          MUNIS_AMOUNT: "Мунис",
          ACT_AMOUNT: "Акт суммаси",
          ACCOUNT_NUMBER: "Ҳисоб рақам",
          ACCRUAL: "Ҳисобланди",
          N_SALDO: "Салдо боши",
          K_SALDO: "Салдо охири",
          ELECTRONIC_INCOME: "Электрон тушумлар",
        },
      },
      MFA_4: {
        TABLE_HEADERS: {
          NAME: "Номи",
          AKT_COUNT: "Актлар сони",
          AKT_SUMMA: "АКТлар суммаси",
          DEBITORS: "Дебитор",
          COUNT: "Сони",
          SUMMA: "Сумма",
          CREDITOR: "Kредитор",
          INVENTORY: "Бирламчи инв",
          CANCEL_CONTRACT: "Шартномани бекор қилиш",
          CANCEL_AKT: "Бекор қилинган актлар",
        },
      },
      MFA_8: {
        TABLE_HEADERS: {
          NAME: "Номи",
          TOTAL: "Жами",
          SUCCESS: "Муваффақиятли",
          UNSUCCESSFUL: "Жўнатилмади",
          REGISTRATION: "Рўйхатдан ўтиш",
          PAYME: "Тўловлар",
          DEBT_WARNINGS: "Қарздорлик ҳақида огоҳлантиришлар",
          OTHER: "Бошқа",
          ETK_SMS: "ҲЕТ га улаш бўйича юборилган СМС",
        },
      },
      MONITORING_ABONENT: {
        TABLE_HEADERS: {
          NAME: "Номи",
          PRESCRIBED_CNT: "Биллинг базасидаги яшовчилар сони",
          SUCCESS_MIA_PRESCRIBED_CNT: "ИИВ базасидаги яшовчилар сони",
          DIFFIRENCE: "Фарқи",
          ERROR_MIA_PRESCRIBED_CNT: "Хато кадастр рақам киритилганлар сони",
          NULL_MIA_PRESCRIBED_CNT: "Кадастр рақам мавжуд бўлмаганлар сони",
          RESIDENT_COUNT: "Абонентлар сони",
          IDENTIFIED_COUNT: "Танланган вақтдаги идентификация қилинганлар сони",
          UNIDENTIFIED_COUNT: "Идентификация қилинмаганлар сони",
          TOTAL_IDENTIFIED_COUNT: "Жами идентификация қилинганлар сони",
          IDENTITY_SHARE: "Идентификация қилинган абонентлар улуши (%)",
          FOREIGN_IDENTIFIED_COUNT:
            "Жами чет ел фуқаролариниг идентификация қилинганлар сони",
          FOREIGN_IDENTIFIED_COUNT_BY_DATE:
            "Танланган вақтдаги чет ел фуқароларининг идентификация қилинганлар сони",
        },
        REGISTERED_ABONENT: {
          TABLE_HEADERS: {
            ID: "ID",
            NAME: "Номи",
            ACCOUNT_NUMBER: "Ҳисоб рақам",
            MAHALLA_NAME: "Маҳалла",
            STREET_NAME: "Кўча",
            HOME_NUMBER: "Уй",
            FLAT: "Кв",
            HOME_INDEX: "Уй индекси",
            COMPANY_NAME: "Корхона номи",
          },
        },
      },
      MUNIS: {
        TABLE_HEADERS: {
          NAME: "Номи",
          COUNT: "Сони",
          SUMMA: "Сумма",
        },
      },
      SMS_COLLECTION: {
        TABLE_HEADERS: {
          NAME: "Номи",
          COUNT: "Сони",
          SUCCESS: "Муваффақиятли",
          UNSUCCESSFUL: "Жўнатилмади",
        },
      },
      NUMBER_DAILY_ABONENTS: {
        TABLE_HEADERS: {
          NAME: "Номи",
          MONTH: "Фақат бир ой ичида",
          COUNT: "Абонентлар сони",
          INHABITANT_CNT: "Яшовчилар сони",
        },
      },
      ACT_STATUS: {
        TABLE_HEADERS: {
          NAME: "Номи",
          TOTAL_ACT_COUNT: "Жами актлар сони",
          NEW_ACT_COUNT: "Янги актлар сони",
          CANCEL_ACT_COUNT: "Бекор қилинган актлар сони",
          CONFIRMED_ACT_COUNT: "Тасдиқланган актлар сони",
          WARNED: "Огоҳлантирилган актлар сони",
          TOTAL: "Жами",
          CURRENT: "Жорий",
          EXPIRED: "Муддати тугаган",
          FIXED_ACT_COUNT: "Камчиликлари тўғирланган актлар",
          WARNED_FIXED_ACT_COUNT: "Огоҳлантириш тўғирланган актлар сони",
          CONFIRMED_CANCELLED_ACTS_COUNT:
            "Тасдиқланиб бекор қилинган актлар сони",
        },
        RESIDENT_TABLE_HEADERS: {
          COMPANY: "Корхона номи",
          PERIOD: "Давр",
          ACCOUNT_NUMBER: "Ҳисоб рақам",
          DATA_FILE: "Aкт санаси",
          SUM: "Сумма",
          ACT_COMMENTARY: "Aкт изоҳи",
          ACT_TYPE_ID: "Акт тури",
          MAHALLA_NAME: "Маҳалла",
          STREET_NAME: "Кўча",
          HOME_NUMBER: "Уй",
          HOME_INDEX: "Уй индекси",
          FLAT: "Кв",
        },
      },
      ABONENT_CHANGE: {
        TABLE_HEADERS: {
          NAME: "Номи",
          START_MONTH: "Ой бошига абонентлар сони",
          CURRENT_MONTH: "Шу ойда",
          END_MONTH: "Ой охиридаги абонентлар сони",
          ABONENT_COUNT: "Абонентлар сони",
          INHABITANT_COUNT: "Ахоли сони",

          TOTAL_DECREASED: "Жами камайган",
          TOTAL_INCREASED: "Жами кўпайган",
          DELETED_SYSTEM: "Шундан:Тизимдан ўчирилган",
          NEW_ADD_SYSTEM: "Шундан:Тизимга қўшилган",
        },
      },
      F_3_DHJ: {
        TABLE_HEADERS: {
          NAME: "Номи",
          ABONENTS_COUNT: "Абонентлар сони",
          INHABITANT_CNT: "Яшовчилар сони",
          START_DT_COUNT: "Дебитор давр бошига",
          END_DT_COUNT: "Дебитор давр охирига",
          START_KT_COUNT: "Кредитор давр бошига",
          END_KT_COUNT: "Кредитор давр охирига",
          TOTAL_CALCULATE: "Жами хисобланди",
          CALCULATE: "Хисобланди",
          DOPLATA: "Қўшимча",
          REVENUE: "Тушум",
          AKT: "Акт",
          CREDITOR: "Ҳақдорлик",
        },
      },
      COURT_ACTION_STATUS: {
        TABLE_HEADERS: {
          NAME: "Номи",
          TOTAL: "Жами",
          COUNT: "Сони",
          SUMMA: "Сумма",
          CURRENT: "Жорий",
          EXPIRED: "Муддати тугаган",
          WARNED: "Огоҳлантирилди",
          DOCUMENT_PREPARATION: "Суд ҳужжатларини тайёрлаш",
          SEND_TO_COURT: "Ҳужжатлар судга юборилди",
          COURT_DECISION: "Суд қарори чиқарилди",
          DEBT_PAID_FULL: "Қарздорлик тўлиқ қопланди",
          FROM: "Қарздорлик (Дан)",
          TO: "Қарздорлик (Гача)",
        },
      },
      REVENUES_BY_EMPLOYEES: {
        TABLE_HEADERS: {
          NAME: "Номи",
          MAHALLA_COUNT: "Маҳаллалар сони",
          ABONENT_COUNT: "Абонентлар сони",
          DIFFERENCE: "Фарқли",
          INHABITANT_COUNT: "Ахоли сони",
          PLANS: "Режа",
          INCOME: "Тушум",
          ONE_DAY_INCOME: "1 кунлик режа",
          ONE_MONTH_INCOME: "Ойлик режага нисбатан тушум",
          N_SALDO: "Салдо боши",
          K_SALDO: "Салдо охири",
          DEBITORS: "Дебитор",
          DEBITORS_DIFFERENCE: "Дебитор фарқи %",
          CREDITOR: "Кредитор",
          CREDITOR_DIFFERENCE: "Кредитор фарқи %",
        },
      },
      RESIDENT_VISITS_ACCRUALS: {
        TABLE_HEADERS: {
          NAME: "Номи",
          TOTAL: "Жами",
          COUNT: "Сони",
          SUMMA: "Сумма",
          ACCRUALS: "Начисления ҳисобланган абонентлар сони",
          RESIDENT_COUNT: "Жами бириктирилган абонентлар сони",
        },
      },
      DEBT_SETTLE: {
        TABLE_HEADERS: {
          NAME: "Номи",
          COUNT: "Сони",
          SUMMA: "Сумма",
          DEBTOR_SUMMA: "Қарздорлик суммаси",
          PERCENTAGE: "Фоиз %",
          START_MONTH_DEBTOR_ABONENTS:
            "Дастлабки ой бошига нисбатан қарздор абонентлар",
          START_MONTH_FILTER_DEBTOR_ABONENTS:
            "Дастлабки ой бошига нисбатан филтер бўйича қарздор абонентлар",
          NEXT_MONTH_INCOME: "Кейинги ойдаги жами тушумлар",
          NEXT_MONTH_DEBTOR_INCOME:
            "Кейинги ойга нисбатан қарздорликдан ундирилган жами тушум",
          NEXT_MONTH_AKT_DEBTOR:
            "Кейинги ойга нисбатан акт бўйича ундирилган дебиторлик",
          NEXT_MONTH_FILTER_DEBTOR:
            "Кейинги ойга нисбатан филтер бўйича ундирилган дебиторлик",
          NEXT_MONTH_FILTER_DEBTOR_EXACTLY:
            "Кейинги ойга нисбатан филтер бўйича айнан ундирилган дебиторлик",
          IDENTIFIED_DEBTORS_COUNT:
            "Қарздор абонентлардан идентификациядан ўтганлар сони",
          IDENTIFIED_MONTHLY_DEBTORS_COUNT:
            "Бир ойлик қарздорлардан идентификациядан ўтганлар сони",
        },
        PERIOD: "Давр",
        ONE_MONTH: "1 ойлик",
        THREE_MONTHS: "3 ойлик",
        SIX_MONTHS: "6 ойлик",
      },
      GRAPH_CONTROL: {
        TABLE_HEADERS: {
          NAME: "Номи",
          MAHALLA_COUNT: "Маҳаллалар сони",
          RESIDENT_COUNT: "Абонентлар сони",
          AUTOMOBILE_COUNT: "Автомобил сони",
          WASTE_COLLECTION_AREA_COUNT: "Чиқинди йиғиш майдони сони",
          RESIDENT_WASTE_COLLECTION_AREA_COUNT:
            "Чиқинди йиғиш майдонига бириктирилган абонентлар сони",
          RESIDENT_WASTE_COLLECTION_AREA_INHABITANT_COUNT:
            "Чиқинди йиғиш майдонига бириктирилган абонентлар яшовчилар сони",
          SUB_MAHALLA_COUNT: "Суб маҳаллалар сони",
          SUB_MAHALLA_REIDENTS_COUNT: "Суб маҳаллалардаги абонентлар сони",
          SUB_MAHALLA_REIDENTS_INHABITANT_COUNT:
            "Суб маҳаллалаардаги абонентларнинг яшовчилар сони",
          VISIT_GRAPH_COUNT: "Ташриф графикаси сони",
          TOTAL_SORT_ENABLED_WASTE_COLLECTION_AREA_COUNT:
            "Саралаб йиғиш мавжуд бўлган чиқинди йиғиш майдонлари сони",
          TOTAL_VISIT_GRAPH_FILE_COUNT: "Ташриф график файллари умумий сони",
          RESIDENT_WASTEAREA_PERCENTAGE:
            "Чиқинди йиғиш майдонига бириктирилган абонентлар фоизи",
          SUB_MAHALLA_RESIDENTS_PERCENTAGE:
            "Суб маҳаллалардаги абонентлар фоизи",
          BOUND_RESIDENTS_PERCENTAGE: "Умумий бириктирилган абонентлар фоизи",
          UNBOUND_RESIDENTS_PERCENTAGE:
            "Умумий бириктирилмаган абонентлар фоизи",
        },
      },
      DUPLICATE_CADASTRAL: {
        TABLE_HEADERS: {
          NAME: "Номи",
          COUNT: "Сони",
          CADASTRAL_NUMBER: "Кадастр рақами",
        },
      },
      ACT_TYPE: {
        TABLE_HEADERS: {
          NAME: "Номи",
          SIMPLE: "Тўлов келиб тушмаган",
          SERVICE_NOT_PROVIDED: "Хизмат кўрсатилмаган",
          CANCEL_CONTRACT: "Шартномани бекор қилиш",
          INVENTORY: "Одам сонини ўзгартириш",
          FROZEN: "Музлатилган қарздорлик",
          COUNT: "Сони",
          SUMMA: "Сумма",
          TOTAL: "Жами",
          ALL_ACTS: "Жами актлар",
          CREDIT: "Ҳақдорлик",
          DEBIT: "Қарздорлик",
          CREDITOR: "Ҳақдор",
          DEBTOR: "Қарздор",
          ECO_PAY: "EcoPay Инвентаризация",
        },
      },
      HET_WARNING: {
        WARNING_COUNT: "Жами огохлантирилшлар сони",
        CREATED_COUNT: "Тизимда яратилган огохлантиришлар сони",
        SENT_COUNT: "ҲЭТ қабул қилган огоҳлантиришлар сони",
        DELIVERED_COUNT: "Абонентларга етказилган огоҳлантириш хабарлари",
        DELIVERED_PAYMENT: "Тўловлар суммаси",
        TRANSMITTED_COUNT: "Операторга юборилганлар сони",
        NOT_FOUND_ELECTRICITY_ACCOUNT_COUNT:
          "Электр ҳисоб-рақами ҲЭТ базасида аниқланмаганлар сони",
        INVALID_CONSUMER_PHONE_NUMBER_COUNT:
          "ҲЭТда телефон рақами яроқсиз бўлганлар сони",
        SERVER_ERROR_MESSAGE_COUNT: "ҲЭТ сервисида хатолик бўлганлар сони",
        FAILED_COUNT: "SMS сервис томонидан юборилмаган хабарлар сони",
        COMPLETED_COUNT:
          "Огохлантиришдан чиқарилган абонентлар сони (тўлов ёки акт орқали)",
        CANCEL_WARNING_COUNT:
          "Ходимлар томонидан бекор қилинган огохлантиришлар сони",
        ELECTRICITY_ACCOUNT_NUMBER_CHANGED:
          "ҲЭТ ҳисоб рақами ўзгартирилган абонентлар сони",
        CANCEL_CONTRACT_COUNT: "Бекор қилинган шартномалар сони",
        TOTAL_DEBIT_SUM: "Огохлантирилган абонентлар жами қарздорлик суммаcи",
        WARNING_DEBIT_SUM:
          "Огохлантирилган қарздорлик суммаcи (07.2025 дан ҳозиргача)",
        MAHALLA_COUNT: "Огоҳлантириш юборилган маҳаллалар сони",
        ACCEPTED: "ҲЕТ томонидан қабул қилинган",
        SMS_SERVICE_STATUS: "СМС сервис ҳолати",
        PAYMENT:
          "Огохлантирилган абонентлар томонидан амалга оширилган тўловлар",
        PAYMENT_SUM:
          "Огоҳлантирилган абонентлар томонидан амалга оширилган тўловлар суммаси",
        ACT_PAYMENT: "Огохлантирилган абонентлар учун қилинган актлар",
        ACT_PAYMENT_SUM:
          "Огохлантирилган абонентлар учун қилинган актлар суммаси",
        CREATED: "Яратилди",
        SENT: "Юборилди",
        DELIVERED: "Еткaзилди",
        TRANSMITTED: "Операторга юборилди",
        NOT_DELIVERED: "Еткaзилмади",
        REJECTED: "Рад этилди",
        FAILED: "Юборишда хатолик",
        EXPIRED: "Еткaзиш вақти тугади",
        COMPLETED: "Тугатилди",
        ELECTRICITY_ACCOUNT_NUMBER_CHANGEDS:
          "СОАТО ёки электр ҳисоб рақами ўзгартирилган",
        CANCEL_CONTRACT: "Шартнома бекор қилинди",
        CANCEL_WARNING: "Огохлантириш бекор қилинди",
        NOT_FOUND_ELECTRICITY_ACCOUNT: "Истеъмолчи коди топилмади",
        INVALID_CONSUMER_PHONE_NUMBER:
          "Истеъмолчи телефон рақамида хатолик мавжуд",
        SERVER_ERROR_MESSAGE: "ҲЭТ сервисда муаммо",
        CHANGE_MSG_STATUS_TIME: "Хабар ҳолатини ўзгариш вақти",
        USER_FULL_NAME: "Огоҳлантиришни бекор қилган ходим Ф.И.Ш",
        SENT_TO_BLOCK_COUNT: "Блоклашга юборилганлар сони",
        SENT_TO_BLOCK: "Блоклашга юборилди",
        ERROR_SEND_WARNING_SMS:
          "Хатоликлар сабабли етказилмаган огоҳлантириш хабарлари сони",
        CANCEL_WARNING_OPERATION:
          "Маълум сабабларга кўра огоҳлантириш бекор қилинган абонентлар сони",
        ACCRUAL_TYPE: "Ҳисоб-китоб тури",
        DEFAULT: "Оддий",
        GPS_BASED: "GPS асосида",
        LAST_WARNING_DATE: "Охирги огоҳлантириш санаcи",
        LAST_BLOCK_DATE: "Охирги блоклаш санаcи",
        VISIT_BY_IMPACT_ON_ACCRUALS: "Ташрифларни начислениега таъсир бўйича",
        BY_GPS_CALCULATED_AMOUNTS: "GPS орқали ҳисобланган суммалар бўйича",
        VISITS_AFFECTING_ACCRUALS: "Ташрифларни начислениега таъсири бўлганлар",
        VISITS_NOT_COUNTED: "Ташрифлар ҳисобга олинмаганлар",
        GPS_INCLUDED_AMOUNTS: "GPS орқали ҳисобланган суммалар қўшилганлар",
        GPS_EXCLUDED: "GPS инобатга олинмайдиганлар",
        PERIODS: "Даврлар",
        ALL_PERIOD: "Барчаси",
        CURRENT_MONTH: "Жорий ой",
        LAST_MONTH: "Ўтган ой",
        MULTIPLE_WARNING: "Танлаб огоҳлантириш",
        MULTIPLE_BLOCK: "Танлаб огоҳлантирилганларни блоклаш",
        MULTIPLE_AUTO_LIST: "Рўйхат шакллантириш",
        AUTO_LIST_BUTTON: "Танланганларни рўйхатга олиш",
        REMOVE_FROM_AUTO_LIST_BUTTON: "Танланганларни рўйхатдан олиб ташлаш",
        IN_LIST: "Рўйхатга олинган",
        START_HET_WARNING: "Рўйҳатдагиларни огоҳлантириш",
        START_HET_WARNING_POPUP:
          "Рўйҳатга олинган маҳаллаларнинг қарздор абонентларига ҲЕТ томонидан огоҳлантириш функцияси",
        START_HET_WARNING_TITLE: "Огоҳлантиришни бошлаш",
        START_HET_WARNING_MSG:
          "Бунда танланган маҳаллаларнинг қарздор абонентларига ҲЕТ томонидан огоҳлантириш амаллари бажарилади. Сиз ростан ҳам рўйҳатга олинган маҳаллаларнинг қарздор абонентларига огоҳлантиришларни юбормоқчимисиз?",
        START_HET_BLOCK: "Рўйҳатдагиларни блоклаш",
        START_HET_BLOCK_POPUP:
          "Рўйҳатга олинган маҳаллаларнинг огоҳлантирилган абонентларини ҲЕТ томонидан блоклаш функцияси",
        START_HET_BLOCK_TITLE: "Блоклашни бошлаш",
        START_HET_BLOCK_MSG:
          "Бунда танланган маҳаллаларнинг огоҳлантирилган абонентларига ҲЕТ томонидан блоклаш амаллари бажарилади. Сиз ростан ҳам рўйҳатга олинган маҳаллаларнинг огоҳлантирилган абонентларини блокламоқчимисиз?",
        HET_BLOCK: "Блокланган",
        HET_WARNING: "Огоҳлантирилган",
        HET_WARNING_ERROR: "Огоҳлантиришда хатолик юз берганлар",
        BY_AUTO_LIST: "Рўйхат бўйича",
        AUTO_LIST_ENABLED: "Рўйхатга олинган",
        AUTO_LIST_DISABLED: "Рўйхатга олинмаган",
        MAHALLA_PAYMENT:
          "Огоҳлантириш юборилган маҳаллалар томонидан амалга оширилган тўловлар",
      },
      HET_WARNING_POSSIBLE_RESIDENTS: {
        IDENTIFICATION_COUNT: "Идентификациядан ўтган абонентлар",
        DEBIT_COUNT: "Жами қарздор абонентлар сони",
        TOTAL_DEBIT: "Жами қарздорлик",
        WARNING_DEBIT: "Огоҳлантириладиган қарздорлик",
        WARNING_DEBIT_PERIOD:
          "Огоҳлантириладиган қарздорлик (07.2025 дан шаклланган)",
        TOTAL_GPS_RESIDENTS: "GPS асосида қўшилган МФЙдаги қарздор абонентлар",
        TOTAL_GPS_RESIDENT_COUNT_AND_IDENTIFY_COUNT:
          "GPS асосида қўшилган МФЙдаги ва идентификациядан ўтган абонентлар",
        IDENTIFY: "Идентификациядан ўтган",
        IDENTIFY_DATE: "Идентификация санаси",
        GPS_ENABLE_STATUS: "GPS ҳолати",
        DISABLED: "Ёпиқ",
        ENABLED_CHYM: "ЧЙМ орқали",
        ENABLED_MAHALLA: "Маҳалла орқали",
        WARNING_COUNT_PERIOD:
          "Огоҳлантириладиган абонентлар сони (07.2025 дан шаклланган)",
        WARNING_COUNT: "Огоҳлантириладиган абонентлар",
        MAHALLAS_COUNT: "Маҳаллалар сони",
        TOTAL_RESIDENTS_COUNT: "Жами абонентлар",
      },
    },

    RESIDENT_CARD: {
      ACTION_BUTTONS: {
        EDIT_RESIDENT_DATA: "Абонент маълумотларини таҳрирлаш",
        NEW_RECEIPT: "Янги квитанция",
        NEW_ACT: "Янги акт",
        NEW_ACT_CHANGES_HABITANTS: "Янги акт (яшовчилар сонини ўзгартириш)",
        CHANGE_INHABITANT_CNT: "Яшовчи сонини ўзгартириш",
        CHANGE_RESIDENT_INFO: "Маълумотларни ўзгартириш",
        CHANGE_HOUSE: "Участкани ўзгартириш",
        FIRST_INVENTAR: "Бирламчи инвентар",
        TERMINATE_CONTRACT: "Шартномани бекор қилиш",
        CONTRACT: "Шартномани қайта тиклаш",
        FIRST_INV: "Бирламчи инвентаризация",
        IMPORT_PERIOD_SALDO: "Import давр бошига салдо",
      },
      CANCELLATION_OF_CONTRACT: {
        MODAL_TITLE: "Тасдиқлаш",
        MODAL_TEXT:
          "Ушбу абонент шартномаси бекор қилинган кейин қайта тикланмайди! Сиз ростан ҳам ушбу ҳаракатни амалага оширмоқчимисиз?",
        BALANCE_IN_HABITANT_ERROR:
          "Aбонентнинг яшовчилар сони ва жорий баланси нолга тэнг бўлиши керак.",
        BALANCE_ERROR: "Aбонент жорий баланси нол бўлиши керак.",
        HABITANT_ERROR: "Aбонентнинг яшовчилар сони нолга тенг бўлиши керак.",
        SUCCESS_TOAST: "Шартнома бекор қилинди.",
      },
      CONTRACT: {
        MODAL_TITLE: "Шартномани қайта тиклаш",
        MODAL_TEXT: "Сиз ушбу абонент билан шартномани қайта тикламоқчимисиз?",
        SUCCESS_TOAST: "Шартнома қайта тикланди.",
      },
      TABS: {
        RESIDENT_INFO: "Абонент маълумотлари",
        DXSH: "ДҲЖ",
        CASH_INCOMES: "Нақд пул тушумлари",
        INCOMES_1031: "МИБ ва 1031 тушумлари",
        PAYMENT_TRANSACTION: "Электрон тўловлар",
        MUNIS: "MUNIS",
        AKT_RESIDENT: "Актлар",
        RESIDENT_APPEAL: "Абонент мурожаати",
        RESIDENT_APPEAL_TO_COURT: "Судга даъво",
        WASTE_COLLECTION_AREAS: "ЧYM орқали ҳисобланган сумма",
        ORG_EMPLOYEE: "Ташкилот ҳодимлари",
        FROZEN_RESIDENTS: "Музлатилганлик тарихи",
        RELATION_RESIDENTS: "Суб-ҳисоб рақамлар",
        FROZEN_DEBT_ACTS: "Музлатилган қарздорлик актлари",
        ACTIONS: "Амаллар",
        OLD_ACTIONS: "Эски тизимдаги амаллар",
        INHABITANTS: "Яшовчилар",
        CALCULATION_BY_MAHALLA: "Маҳалла бўйича ҳисобланган сумма",
        HET_WARNING_RESIDENT: "ҲЕТ огоҳлантиришлари тарихи",
        HET_BLOCK_RESIDENT: "ҲЕТ блокланганлик тарихи",
      },
      RESIDENT_INFO: {
        CARDS: {
          DESC1: "Давр",
          DESC2: "Яшовчилар сони",
          DESC3: "ИИВ базасидаги яшовчилар",
          DESC4: "Ҳисобланди",
          DESC5: "Тушум",
          RESERVE: "{{reserve}} гача ҳақдор",
        },
        CARD_LIST: {
          EMAIL: "E-mail",
          PHONE: "Телефон рақами",
          HOME_PHONE: "Уй телефони",
          PASSPORT_NUMBER: "Паспорт рақами",
          PASSPORT_NUMBERS: "ЖШШИР",
          CONTRACT_NUMBER: "Шартнома рақами",
          SHOT_NUMBER: "Ҳисоб рақами",
          COMPANY_LOCATION: "Корхона манзили",
          CONTRACT_DATE: "Шартнома қилинган вақти",
          OWNER_COMPANY: "Корхона эгаси",
          NOT_INCLUDE_EMAIL: "E-mail киритилмаган",
          NOT_INCLUDE_PHONE: "Телефон рақами киритилмаган",
          NOT_INCLUDE_HOME_PHONE: "Уй телефони рақами киритилмаган",
          NOT_INCLUDE_PASSPORT_NUMBER: "Паспорт рақами киритилмаган",
          COMPANY_NAME: "Корхона номи",
          ADDRESS: "Манзил",
          INN: "ИНН",
          CADASTRAL_NUMBER: "Кадастр рақами",
          ELECTRIC_NUMBER: "Электр энергия рақами",
          ELECTRIC_COATO: "Электр энергия COATO",
          DATE_APPROVE_CONTRACT: "Шартнома тасдиқланган сана",
        },
        CHART_WIDGETS: {
          TITLE1: "Тушум статистикаси (сўм)",
          TITLE2: "Қарздорлик/Хақдорлик статистикаси (сўм)",
          INCOM: "Кирим",
          CALCULATED: "Ҳисобланди",
          DEBT: "Қарзи",
          CURRANCY: "сўм",
        },
        INCOMES: {
          TABLE_HEADERS: {
            ID: "ID",
            ACCOUNT_NUMBER: "Ҳисоб рақами",
            SUM: "Сумма",
            COMPANY_NAME: "Ташкилот номи",
            PAYER: "Тўловчининг Ф.И.Ш",
            OVERALL_SUM: "Жами сумма",
            PURPOSE: "Мақсад",
            DESCRIPTION: "Изоҳ",
          },
          MODAL: {
            TITLE_ADD: "Кирим қўшиш",
            TITLE_EDIT: "Киримни таҳрирлаш",
            TITLE_DELETE: "Киримни ўчириш",
            CONFIRMATION_MODAL_TEXT:
              "Сиз ҳақиқатан ҳам танланган киримни тизимдан олиб ташламоқчимисиз?",
            TOAST_SUCCESS: "Янги кирим муваффақиятли қўшилди!",
            TOAST_SUCCESS_EDIT: "Кирим муваффақиятли таҳрирланди!",
            TOAST_DELETE: "Кирим ўчирилди!",
          },
        },
        ACTIONS: {
          CANCEL_HET_WARNING: "ҲЕТ дан огоҳлантиришни бекор қилиш",
          CANCEL_HET_WARNING_MESSAGE:
            "Сиз ҳақиқатан ҳам бу абонентни ҲЕТ томонидан огоҳлантиришни бекор қилмоқчимисиз?",
          CANCEL_HET_BLOCK: "ҲЕТ дан блоклашни олиб ташлаш",
          CANCEL_HET_BLOCK_MESSAGE:
            "Сиз ҳақиқатан ҳам бу абонентни ҲЕТ томонидан блоклашни бекор қилмоқчимисиз?",
          BLOCKED_DATE_FROM_HET: "HET томонидан блокланган сана:",
          WARNED_DATE_FROM_HET: "HET томонидан огоҳлантирилган сана:",
          TABLE_HEADERS: {
            ID: "ID",
            ENTITY_NAME: "Ҳаракат номи",
            ACCOUNT_NUMBER: "Ҳисоб рақами",
            RESIDENT_FIO: "Абонент Ф.И.Ш",
            WORK_TYPE_NAME: "Иш тури",
            USER_FULL_NAME: "Фойдаланувчи Ф.И.Ш",
            COMPANY_NAME: "Компания номи",
            CHANNEL: "Канал",
            CHANGED_VALUE: "Ўзгартирилган қиймат",
            ORIGINAL_VALUE: "Асл қиймат",
            CHANGED_VALUE_ORIGINAL: "Асл Ўзгартирилган қиймат",
            OPERATION: "Операция",
            CHANGE_DATE: "Ўзгартирилган сана",
            VIEW: "Кўриш",
            OLD_PARAMS: "Эски параметрлар",
            NEW_PARAMS: "Янги параметрлар",
            CREATED_AT: "Яратилган вақти",
          },
        },
      },
      DHJ: {},
      FROZEN_RESIDENTS: {
        TABLE_HEADERS: {
          DESCRIPTION: "Изоҳ",
          FILE_NAME: "Изоҳловчи файл",
          FROM_DATE: "Бошланиш даври",
          TO_DATE: "Тугаш даври",
        },
        COMPONENTS: {
          INITIAL_PERIOD: "Бошлангич давр",
          FINAL_PERIOD: "Охирги давр",
          TOTAL_DURATION: "Умумий муддат:",
          MONTH: "ой",
          DAY: "кун",
          ATTACHED_FILE: "Файл бириктириш",
          FROZEN_RESIDENTS: "Абонентни музлатиш",
        },
        MODALS: {
          ADD_FREEZING_RESIDENTS: "Абонентни вақтинча музлатиш",
          UN_FREEZING_RESIDENTS: "Музлатилганликдан чиқариш",
          CONFIRM_TEXT: "Сиз ҳақиқатан ҳам музлатилганликдан чиқармоқчимисиз?",
        },
      },
      INHABITANTS: {
        FULL_NAME: "Ф.И.Ш",
        BIRTH_DATE: "Туғилган куни",
        PNFL: "ЖШШИР",
        REGISTRATION_DATE: "Рўйхатдан ўтган санаси",
        SEX: "Жинси",
      },
    },
    ERROR_LIST: {
      NOT_FOUND: "Сўралган маълумот топилмади!",
      PINFL_NOT_VALID: "Нотўғри ЖШШИР",
      CADASTRAL_NUMBER_ERROR:
        "Ушбу кадастр рақами абонент вилояти ёки туманига тегишли емас!",
      POPUP_RESTRICTED:
        "Сизнинг браузерингизда чоп этиш саҳифасини очишга рухсат берилмаган!",
      SERVER_ERROR: "Серверда хатолик юзага келди!",
      ACCESS_DENIED: "Кириш чекланган!",
      BAD_REQUEST: "Нотўғри сўров!",
      FIELD_IS_REQUIRED: "Майдон тўлдирилиши керак!",
      INVALID_EMAIL_ADDRESS: "Нотўғри электрон почта манзили!",
      MINLENGTH_REQUIRED:
        "Майдон камида {{requiredLength}} белгидан иборат бўлиши керак!",
      MAXLENGTH_REQUIRED:
        "Майдон {{requiredLength}} белгидан кўп бўлмаслиги керак!",
      MIN_REQUIRED: "Қиймат {{min}} дан кам бўлмаслиги керак!",
      MAX_REQUIRED: "Қиймат {{max}} дан кўп бўлмаслиги керак!",
      PATTERN_REQUIRED:
        "Майдон қуйидаги белгилардан иборат бўлиши керак {{requiredPattern}}",
      BETWEEN: "Қийматлар {{x}} ва {{y}} орасида бўлиши керак!",
      INVALID_LENGTH:
        "INN {{minLength}} ва {{maxLength}} орасида бўлиши керак!",
      IP_NOT_VALID: "Нотўғри IP-манзил киритилди!",
      CONFIRM_PASSWORD_ERROR: "Паролни тасдиқлашда хатолик бўлди!",
      NUMERIC: "Бу майдонда фақат рақамлар ёзилади!",
      LOWERCASE: "Бу майдонда фақат кичик ҳарфлар ёзилади!",
      UPPERCASE: "Бу майдонда фақат катта ҳарфлар ёзилади!",
      MAX_FILE_SIZE: "Файл ҳажми {{size}} дан ошмаслиги керак",
      ONE_UPPERCASE: "Камида 1 та катта ҳарф бўлиши керак",
      ONE_LOWERCASE: "Камида 1 та кичик ҳарф бўлиши керак",
      ONE_NUMBER: "Камида 1 та рақам бўлиши керак",
      ONE_SPECIAL_CHARACTER: "Камида 1 та белги бўлиши керак",
    },
    CHART_PAYMENTS: {
      TITLE: "Tушумлар",
      ELECTRON: "Электрон",
      MUNIS: "МУНИС",
      PAYMEN_1034: "1031",
      CASH: "Нақд",
      MOBILE: "Мобил",
      SMALL_SIDEBAR: "Кичик ён меню",
      PAID_RESIDENTS: "Транзакциялар сони",
      RECEITTS: "Тушумлар динамикаси",
    },
    FILE_INPUT: {
      BROWSE: "Танлаш...",
      NO_FILE_SELECTED: "Файл танланмаган.",
      DOWNLOAD_ERROR_MESSAGE: "Файлни юклаб олишда хатолик юз берди",
    },
    POLYGON: {
      TABLE_HEADERS: {
        NAME: "Ташкилот номи",
        DISTRICT: "Туман",
        BANK: "Банк",
        BANK_OKED: "Банк ОКЭД",
        BANK_ACCOUNT: "Банк ҳисоб рақами",
        ADDRESS: "Манзил",

        START_DATE: "Бошланиш санаси",
        END_DATE: "Тугаш санаси",
        CONTRACT_NUMBER: "Шартнома рақами",
      },
      EDIT_TITLE: "Полигонни  таҳрирлаш",
      POLYGONS_INFO: {
        ADD_POLYGON: {
          ADD_MODAL_TITLE: "Полигон қўшиш",
        },
        DELETE_POLYGON: {
          DELETE_MODAL_TITLE: "Полигон ўчириш",
          DELETE_TEXT: "Сиз ҳақиқатан ҳам полигони олиб ташламоқчимисиз?",
        },
        LOCATION: "Жойлашув",
        BANK_INFO: "Банк маълумотлари",
        BANK_NAME: "Банк номи",
        BANK_OKED: "Банк ОКЭД",
        BANK_MFO: "Банк МФО",
        DESCRIPTION: "Изоҳ",
        POLYGON_NUMBER: "Полигон рақами",
      },
      POLYGON_AREA: "Полигон майдони (м²)",
      POLYGON_NUMBER: "Полигон рақами",
      TAB_NAME_1: "Полигон  ва банк маълумотлари",
      TAB_NAME_2: "Полигон жойлашуви",
      ADD_MODAL_TITLE: "Полигон лицензиясини қўшиш",
      EDIT_MODAL_TITLE: "Лицензияга ега ташкилот маълумотларини таҳрирлаш",
      DELETE_MODAL_TITLE: "Полигон лицензиясини ўчириш",
      LICENSE_START: "Лицензиянинг бошланиш санаси",
      LICENSE_END: "Лицензиянинг тугаш санаси",
      LICENSE_NUMBER: "Лицензия рақами",
      ALERTED_TEXT: "Лицензиянинг бошланиш ва тугаш санаси нотўғри киритлган",
      DELETE_TEXT:
        "Сиз ҳақиқатан ҳам полигон лицензиясини тизимдан олиб ташламоқчимисиз?",
      BANK_ACCOUNT: "Банк ҳисоб рақами",
      DISTRICT_CITY: "Туман / Шаҳар",
      POLYGON_SEARCH: "Полигон номи",
      TABS: {
        ORGANIZATIONS: "Ташкилотлар",
        COMPANY: {
          COMPANY: "Корхоналар",
          COMPANY_ADD: "Корхона бириктириш",
          POLYGON_ADD: "Полигонга қўшиш",
          COMPANY_DELETE: "Корхоналарни ўчириш",
          CONFIRM_MULTIPLE_TEXT:
            "Сиз ҳақиқатан ҳам танланган корхоналарни полигонга бириктирмоқчимисиз?",
          CONFIRM_TITLE: "Танланган корхоналарни полигонга бириктириш",
          DELETE_TITLE: "Танланган корхоналарни полигондан ўчириш",
          DELETE_MULTIPLE_TEXT:
            "Сиз ҳақиқатан ҳам танланган корхоналарни полигондан ўчирмоқчимисиз?",
          SELECTED_COMPANY: "Танланган корхоналар",
        },
        TARIFFS: {
          WARNING_TEXT:
            "Яшил рангли қаторлар жорий тариф активлигини билдиради!",
          COMPANY: "Корхона",
          POLYGON: "Полигон",
          ORGANIZATION: "Ташкилот",
          COMPANY_TARIFF: "Корхона тариф",
          COMPANY_TARIFF_M3: "Корхона тариф (м³)",
          COMPANY_TARIFF_KG: "Корхона тариф (кг)",
          POLYGON_TARIFF: "Полигон тариф",
          POLYGON_TARIFF_M3: "Полигон тариф (м³)",
          POLYGON_TARIFF_KG: "Полигон тариф (кг)",
          ORGANIZATION_TARIFF: "Ташкилот тариф",
          ORGANIZATION_TARIFF_M3: "Ташкилот тариф (м³)",
          ORGANIZATION_TARIFF_KG: "Ташкилот тариф (кг)",
          TABLE_HEADERS: {
            REGIONS: "Вилоят",
            NAME: "Номи",
            RATE: "Нархи",
            DESCRIPTION: "Изоҳ",
            START_DATE: "Бошланиш санаси",
            END_DATE: "Тугаш санаси",
            COMMENT: "Изоҳ",
          },
          ADD_TARIFF: {
            ADD_BUTTON: "Тариф қўшиш",
            ADD_MODAL_TITLE: "Тариф қўшиш",
          },
          EDIT_TARIFF: {
            EDIT_BUTTON: "Тарифни таҳрирлаш",
            EDIT_MODAL_TITLE: "Тарифни таҳрирлаш",
          },
          DELETE_TARIFF: {
            DELETE_BUTTON: "Тарифни ўчириш",
            TEXT: "Сиз ҳақиқатан ҳам ушбу тарифни ўчирмоқчимисиз?",
          },
          TARIFF_RATE: {
            SOLID_WASTE_M3: "Қаттиқ маиший чиқиндилар нархи 1 м³ (сўм)",
            SOLID_WASTE_KG: "Қаттиқ маиший чиқиндилар нархи 1 кг (сўм)",
            LIQUID_WASTE_M3: "Суюқ маиший чиқиндилар нархи 1 м³ (сўм)",
            LIQUID_WASTE_KG: "Суюқ маиший чиқиндилар нархи 1 кг (сўм)",
            CONSTRUCTION_WASTE_M3:
              "Қурилиш ва бошқа чиқиндилар нархи 1 м³ (сўм)",
            CONSTRUCTION_WASTE_KG:
              "Қурилиш ва бошқа чиқиндилар нархи 1 кг (сўм)",
          },
          GARBAGE_TYPE: {
            SOLID_WASTE: "Қаттиқ маиший чиқиндилар нархи",
            LIQUID_WASTE: "Суюқ маиший чиқиндилар нархи",
            CONSTRUCTION_WASTE: "Қурилиш ва бошқа чиқиндилар нархи",
          },
        },
        VISITS: {
          REGISTRATION: "Регистрация",
          TABLE_HEADERS_VISITS: {
            COMPANY_NAME: "Номи",
            AUTOMOBILE_NUMBER: "Автомобил рақами",
            AUTOMOBILE_MODEL: "Автомобил модели",
            VISIT_DATE: "Ташриф санаси",
            M_KUB: "Чиқинди ҳажми (м³)",
            VISIT_SUM: "Ташриф суммаси сўм",
          },
          TABLE_POLYGON_AVTO: {
            ORGANIZATION_NAME: "Ташкилот номи",
            AUTOMOBILE_NUMBER: "Автомобил рақами",
            AUTOMOBILE_MODEL: "Автомобил модели",
            VISIT_DATE: "Ташриф санаси",
            M_KUB: "Чиқинди ҳажми (м³)",
            VISIT_SUM: "Ташриф суммаси сўм",
          },
          REGISTER_VISIT: "Ташрифни регистрация қилиш",
          VISITS: "Ташрифлар",
          COMPANY_NAME: "Корхона номи",
          ORGANIZATION_NAME: "Ташкилот номи",
          POLYGON_NAME: "Полигон номи",
          AUTOMOBILE_NUMBER_AND_MODEL: "Автомобил рақами ва модели",
          VISIT_DATE: "Ташриф санаси",
          M_KUB: "Чиқинди ҳажми (м³)",
          AUTOMOBILE_NUMBER_SELECT: "Автомобил рақамини танланг",
          WASTE_CATEGORY: "Чиқинди тури",
          AUTOMOBILE_NUMBER: "Автомобил рақами",
          TARIFF: "Тариф (сўм)",
          RATE: "Тариф (сўм)",
          VISIT_SUM: "Ташриф суммаси (сўм)",
          WASTE_SELECTED: "Чиқинди турини танланг",
          WARNING:
            "Ушбу ташриф суммаси машинанинг тўлиқ сиғимидан келиб чиқилган ҳолда ҳисобланган!",
        },
        CARS: {
          AUTOMOBILES: "Техникалар",
          ADD_TECHNIQUE: "Техника қўшиш",
          UPDATE_TECHNIQUE: "Техникани таҳрирлаш",
          DELETE_TECHNIQUE: "Техникани ўчириш",
          AUTOMOBILE_NUMBER: "Автомобил рақами",
          AUTOMOBILE_MODEL: "Автомобил модели",
          DESCRIPTION: "Изоҳ",
          M_KUB: "Чиқинди ҳажми (м³)",
          DELETE_TEXT:
            "Сиз ҳақиқатан ҳам танланган техникани тизимдан олиб ташламоқчимисиз?",
        },
      },
      COMPANY: {
        DIRECTOR_FIO: "Директор Ф.И.Ш",
        BANK_NAME: "Банк номи",
        COMPANY_ACCOUNT_NUMBER: "Корхона ҳисоб рақами",
        BANK_MFO: "Банк МФО",
        BANK_OKED: "Банк ОКЭД",
        INN: "ИНН",
        PHONE_NUMBER: "Телефон рақами",
        POLYGON_ATTACHMENT: "Бириктириш / Ажратиш",
        POLYGON_ATTACHMENT_TITLE: "Полигонларни бириктирш ва ажратиш",
        ATTACHMENT: "Бириктириш",
        POLYGON: "Полигон",
        CARS: "Техникалар",
        ADDRESS: "Манзил",
      },
      STATISTICS: {
        BY_REGIONS: {
          TITLE: "Полигонларга ташрифлар сони ва суммаси вилоятлар кесимида",
          TITLE_SUM: "Полигонларга ташрифлар суммаси вилоятлар кесимида",
          TITLE_COUNT: "Полигонларга ташрифлар сони  вилоятлар кесимида",
          VISIT_COUNT: "Ташрифлар сони",
          VISIT_SUM: "Ташрифлар суммаси",
        },
        BY_DISTRICTS: {
          TITLE: "Палигонларга ташрифлар сони ва суммаси туманлар кесимида",
        },
        STAT: {
          AUTOMOBILE_COUNT: "Автомобиллар сони",
          POLYGON_COUNT: "Полигонлар сони",
          LICENSED_ORGANIZATION_COUNT: "Лицензияли ташкилотлар сони",
          CURRENT_PERIOD_VISIT_COUNT: "Жорий даврда ташрифлар сони",
          CURRENT_PERIOD_VISIT_SUM: "Жорий даврда ташрифлар суммаси",
          NUMBER_COMPANY: "Корхоналар сони",
        },
        POLYGONS_MONTHLY: {
          TITLE: "Полигонларга ташрифлар сони ва суммаси",
          TITLE_SUM: "Полигонларга ташрифлар суммаси",
          TITLE_COUNT: "Полигонларга ташрифлар сони",
        },
      },
      REPORTS: {
        REPORT_TITLE: "Ташрифлар бўйича ҳисобот",
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Номи",
          N_SALDO: "Салдо боши",
          K_SALDO: "Салдо охири",
          ACCRUAL: "Ҳисобланди",
          PAYMENT: "Тўлов",
        },
        VISITS: "Ташрифлар",
        ORGANIZATIONS: "Ташкилотлар",
        COMPANIES: "Корхоналар",
        POLYGONS: "Полигонлар",
      },
      EMPLOYEES: {
        POLYGON_NAME: "Полигон номи",
        POLYGON_NAMES: "Полигон номи",
        POSITIONS: "Лавозими",
        PNFL: "ЖШШИР",
        PASSPORT_NUMBER: "Паспорт рақами",
        PHOTO: "Ходим суратини юклаш",
        LAST_NAME: "Фамилия",
        FIRST_NAME: "Исм",
        EMAIL: "Е-маил",
        PHONE_NUMBER: "Телефон рақами",
        LABEL_LOGIN: "Логин",
        LABEL_PASSWORD: "Парол",
        CONFIRM_PASSWORD: "Паролни тасдиқланг",
        TABLE_HEADERS: {
          NUMBERS: "№",
          ID: "ID",
          POLYGON_NAME: "Полигон номи",
          FIO: "Ф.И.Ш",
          JOB_TITLE: "Лавозими",
          EMAIL: "E-mail",
          PHONE: "Телефон",
          LOGIN: "Логин",
          ATTACHED_FILE: "Бириктирилган файл",
          STATUS: "Ҳолат",
          ADDRESS: "Манзил",
          ROLE_DESCRIPTION: "Рол тавсифи",
          COMMENT: "Изоҳ",
        },
      },
      GARBAGE_TYPE: {
        SOLID_WASTE: "Қаттиқ маиший чиқиндилар",
        LIQUID_WASTE: "Суюқ маиший чиқиндилар",
        CONSTRUCTION_WASTE: "Қурилиш ва бошқа чиқиндилар",
      },
    },
    POLYGON_AUTO: {
      TABLE_HEADERS: {
        AUTOMOBILE_NUMBER: "Автомобил рақами",
      },
      DESCRIPTION: "Изоҳ",
      ADD_MODAL_TITLE: "Автомобил литсензиясини қўшиш",
      EDIT_MODAL_TITLE: "Автомобил литсензиясини таҳрирлаш",
      DELETE_MODAL_TITLE: "Автомобил литсензиясини ўчириш",
      DELETE_TEXT:
        "Сиз ҳақиқатан ҳам автомобил литсензиясини тизимдан олиб ташламоқчимисиз?",
    },
    POLYGON_LICENSE_ORGANIZATION: {
      START_DATE: "Шартноманинг бошланиш санаси",
      END_DATE: "Шартноманинг тугаш санаси ",
      POLYGON_LICENSE_ORGANIZATION: "Лицензияли ташкилотлар",
      ADD_BUTTON: "Лицензияли ташкилотларни бирлаштириш",
      DELETE_BUTTON: "Лицензияли ташкилотни ўчириш",
      CONFIRM_TITLE: "Танланган лицензияли ташкилотларни полигонга қўшиш",
      CONFIRM_TEXT:
        "Сиз ҳақиқатан ҳам танланган лицензияли ташкилотларни полигонга қўшмоқчимисиз?",
      POLYGON_LICENSE_ORGANIZATION_INFO: {
        ADDRESS: "Манзил",
      },
      CONFIRMATION_SAVING_POLYGON: {
        POLYGONS: "Полигонлар",
        POLYGON_ATTACHMENT: "Полигон бириктириш",
        CONFIRM: "Бириктириш",
        SELECTED_POLYGON: "Танланган полигонлар",
        CONFIRM_TITLE: "Танланган полигонларни бириктириш",
        CONFIRM_TEXT:
          "Сиз ҳақиқатан ҳам танланган полигонларни бириктирмоқчимисз?",
      },
      POLYGONS: "Полигонлар",
      TECHNIQUES: "Техникалар",
      ADD_TECHNIQUE: "Техника қўшиш",
      TITLE_UPDATE: "Техникани таҳрирлаш",
      TITLE_DELETE: "Техникани ўчириш",
      M_KUB: "Чиқинди ҳажми (м³)",
      DELETE_MODAL_SUBTITLE:
        "Сиз ҳақиқатан ҳам танланган техникани тизимдан олиб ташламоқчимисиз?",
      CONTRACTS: {
        CONTRACTS: "Шартномалар",
        ADD_CONTRACT: "Шартнома қўшиш",
        CONTRACT_NUMBER: "Шартнома рақами",
        CONTRACT_START_DATE: "Шартнома бошланиш санаси",
        CONTRACT_END_DATE: "Шартнома тугаш санаси",
        CONTRACT_FILE: "Шартнома файли",
        CONTRACT_TEM: "Шартнома муддати",
        MODAL: {
          DELETE_MODAL: "Шартномани ўчириш",
          DELETE_MODAL_SUBTITLE:
            "Сиз ҳақиқатан ҳам ушбу шартномани олиб ташламоқчимисиз?",
        },
      },
    },
    primeng: {
      firstDayOfWeek: 1,
      dayNames: [
        "Якшанба",
        "Душанба",
        "Сешанба",
        "Чоршанба",
        "Пайшанба",
        "Жума",
        "Шанба",
      ],
      dayNamesShort: ["Якш", "Душ", "Сеш", "Чор", "Пай", "Жум", "Шан"],
      dayNamesMin: ["Як", "Ду", "Се", "Чо", "Па", "Жу", "Ша"],
      monthNames: [
        "Январь",
        "Февраль",
        "Март",
        "Апрель",
        "Май",
        "Июнь",
        "Июль",
        "Август",
        "Сентябрь",
        "Октябрь",
        "Ноябрь",
        "Декабрь",
      ],
      monthNamesShort: [
        "Янв",
        "Фев",
        "Мар",
        "Апр",
        "Май",
        "Июн",
        "Июл",
        "Авг",
        "Сен",
        "Окт",
        "Ноя",
        "Дек",
      ],
      today: "Бугун",
      clear: "Тозалаш",
    },
    DAY_NAMES: {
      "1": "Душанба",
      "2": "Сешанба",
      "3": "Чоршанба",
      "4": "Пайшанба",
      "5": "Жума",
      "6": "Шанба",
      "7": "Якшанба",
    },
    DAY_NAMES_KEY: {
      MONDAY: "Душанба",
      TUESDAY: "Сешанба",
      WEDNESDAY: "Чоршанба",
      THURSDAY: "Пайшанба",
      FRIDAY: "Жума",
      SATURDAY: "Шанба",
      SUNDAY: "Якшанба",
    },
  },
};
